import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Mr = Object.defineProperty,
    aa = Object.defineProperties;
var ia = Object.getOwnPropertyDescriptors;
var Mt = Object.getOwnPropertySymbols;
var Uo = Object.prototype.hasOwnProperty,
    ko = Object.prototype.propertyIsEnumerable;

var jo = function jo(e, t, r) {
  return t in e ? Mr(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[t] = r;
},
    y = function y(e, t) {
  for (var r in t || (t = {})) {
    Uo.call(t, r) && jo(e, r, t[r]);
  }

  if (Mt) {
    var _iterator = _createForOfIteratorHelper(Mt(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        ko.call(t, r) && jo(e, r, t[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    D = function D(e, t) {
  return aa(e, ia(t));
};

var n = function n(e, t) {
  return Mr(e, "name", {
    value: t,
    configurable: !0
  });
};

var Pe = function Pe(e) {
  return typeof e == "symbol" ? e : e + "";
},
    F = function F(e, t) {
  var r = {};

  for (var o in e) {
    Uo.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  }

  if (e != null && Mt) {
    var _iterator2 = _createForOfIteratorHelper(Mt(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var o = _step2.value;
        t.indexOf(o) < 0 && ko.call(e, o) && (r[o] = e[o]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
};

var ca = function ca(e, t) {
  for (var r in t) {
    Mr(e, r, {
      get: t[r],
      enumerable: !0
    });
  }
};

import * as ao from "react";
import * as Re from "react";
import { useMemo as ro } from "react";
import { QueryClientProvider as tu, QueryClient as ru } from "react-query";
import * as ve from "react";
import { useMemo as ma } from "react";
import { useInRouterContext as fa } from "react-router-dom";
import { createHashHistory as ya } from "history";
import * as Vo from "react";
import { useLayoutEffect as ua, useState as la } from "react";
import { Router as da } from "react-router";

function Go(_ref) {
  var e = _ref.basename,
      t = _ref.children,
      r = _ref.history;

  var _la = la({
    action: r.action,
    location: r.location
  }),
      _la2 = _slicedToArray(_la, 2),
      o = _la2[0],
      s = _la2[1];

  return ua(function () {
    return r.listen(s);
  }, [r]), Vo.createElement(da, {
    basename: e,
    children: t,
    location: o.location,
    navigationType: o.action,
    navigator: r
  });
}

n(Go, "HistoryRouter");
import * as Qo from "react";
import { createContext as pa } from "react";
var Lt = pa("");

var _o = n(function (_ref2) {
  var e = _ref2.children,
      t = _ref2.basename;
  return Qo.createElement(Lt.Provider, {
    value: t
  }, e);
}, "BasenameContextProvider");

var zo = n(function (_ref3) {
  var e = _ref3.history,
      _ref3$basename = _ref3.basename,
      t = _ref3$basename === void 0 ? "" : _ref3$basename,
      r = _ref3.children;
  var o = fa();
  return ve.createElement(_o, {
    basename: o ? t : ""
  }, ve.createElement(o ? ga : Ra, {
    basename: t,
    history: e
  }, r));
}, "AdminRouter"),
    ga = n(function (_ref4) {
  var e = _ref4.children;
  return ve.createElement(ve.Fragment, null, e);
}, "DummyRouter"),
    Ra = n(function (_ref5) {
  var e = _ref5.children,
      t = _ref5.history;
  var r = ma(function () {
    return t || ya();
  }, [t]);
  return ve.createElement(Go, {
    history: r
  }, e);
}, "InternalRouter");
var Wm = n(function (e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "edit";
  var o = "".concat(e, "/").concat(encodeURIComponent(t));
  return r === "show" ? "".concat(o, "/show") : o;
}, "linkToRecord");
var Jm = n(function (e, t, r, o) {
  var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";

  if (typeof e == "function") {
    var a = e(t, r, o);
    return typeof a == "string" ? Fe("".concat(s, "/").concat(a)) : y({
      pathname: Fe("".concat(s, "/").concat(a.pathname))
    }, a);
  }

  switch (e) {
    case "list":
      return Fe("".concat(s, "/").concat(t));

    case "create":
      return Fe("".concat(s, "/").concat(t, "/create"));

    case "edit":
      return Fe("".concat(s, "/").concat(t, "/").concat(encodeURIComponent(r)));

    case "show":
      return Fe("".concat(s, "/").concat(t, "/").concat(encodeURIComponent(r), "/show"));

    default:
      return e;
  }
}, "resolveRedirectTo"),
    Fe = n(function (e) {
  return e.replace("//", "/");
}, "removeDoubleSlashes");
import { useContext as Pa } from "react";
var ae = n(function () {
  return Pa(Lt);
}, "useBasename");
import { useCallback as ha } from "react";
var bt = n(function () {
  var e = ae();
  return ha(function (_ref6) {
    var t = _ref6.resource,
        r = _ref6.id,
        o = _ref6.type;

    switch (o) {
      case "list":
        return ie("".concat(e, "/").concat(t));

      case "create":
        return ie("".concat(e, "/").concat(t, "/create"));

      case "edit":
        return ie("".concat(e, "/").concat(t, "/").concat(encodeURIComponent(r)));

      case "show":
        return ie("".concat(e, "/").concat(t, "/").concat(encodeURIComponent(r), "/show"));

      default:
        return o;
    }
  }, [e]);
}, "useCreatePath"),
    ie = n(function (e) {
  return e.replace("//", "/");
}, "removeDoubleSlashes");
import { useCallback as xa } from "react";
import { useNavigate as Ca } from "react-router-dom";
import { parsePath as Ta } from "history";
var ce = n(function () {
  var e = Ca(),
      t = ae(),
      r = bt();
  return xa(function (o) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var a = arguments.length > 2 ? arguments[2] : undefined;
    var i = arguments.length > 3 ? arguments[3] : undefined;
    var u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    if (o) {
      if (typeof o == "function") {
        var c = o(s, a, i),
            p = typeof c == "string" ? "".concat(t, "/").concat(c) : y({
          pathname: "".concat(t, "/").concat(c.pathname)
        }, c);
        e(typeof p == "string" ? Ta(p) : p, {
          state: y({
            _scrollToTop: !0
          }, u)
        });
        return;
      } else if (typeof o == "string" && o.startsWith("http") && window) {
        window.location.href = o;
        return;
      } else {
        e(r({
          resource: s,
          id: a,
          type: o
        }), {
          state: y({
            _scrollToTop: !0
          }, u)
        });
        return;
      }
    } else return;
  }, [e, t, r]);
}, "useRedirect");
import { useEffect as Sa } from "react";
import { useLocation as Ma } from "react-router-dom";
var Ho = n(function () {
  var e = Ma();
  Sa(function () {
    var t;
    ((t = e.state) == null ? void 0 : t._scrollToTop) && typeof window != "undefined" && window.scrollTo(0, 0);
  }, [e]);
}, "useScrollToTop");
import { createContext as La } from "react";
var ba = {
  id: ""
},
    va = {
  login: function login() {
    return Promise.resolve();
  },
  logout: function logout() {
    return Promise.resolve();
  },
  checkAuth: function checkAuth() {
    return Promise.resolve();
  },
  checkError: function checkError() {
    return Promise.resolve();
  },
  getPermissions: function getPermissions() {
    return Promise.resolve();
  },
  getIdentity: function getIdentity() {
    return Promise.resolve(ba);
  }
},
    Wo = La(va);
Wo.displayName = "AuthContext";
var Ye = Wo;
import { useContext as Ea } from "react";
var Ne = {
  loginUrl: "/login",
  afterLoginUrl: "/"
},
    Da = n(function () {
  return Ea(Ye);
}, "useAuthProvider"),
    ee = Da;
import { useEffect as Fi } from "react";
import { useCallback as wi } from "react";
import { useCallback as gn, useEffect as bi, useRef as Rn } from "react";
import { useLocation as vi, useNavigate as Ei } from "react-router-dom";

var ye = "RaStore",
    vt = ye.length,
    wa = n(function () {
  if (typeof window == "undefined" || window.localStorage == null) return !1;

  try {
    return window.localStorage.setItem("test", "test"), window.localStorage.removeItem("test"), !0;
  } catch (_unused) {
    return !1;
  }
}, "testLocalStorage"),
    Lr = wa(),
    Rf = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1";
  var t = {},
      r = n(function (s, a) {
    Object.keys(t).forEach(function (i) {
      !t[i] || t[i].key === s && t[i].callback(a);
    });
  }, "publish"),
      o = n(function (s) {
    if (s.key.substring(0, vt) !== ye) return;
    var a = s.key.substring(vt + 1),
        i = Yo(s.newValue);
    Object.keys(t).forEach(function (u) {
      !t[u] || t[u].key === a && (i === null ? t[u].callback(void 0) : t[u].callback(i == null ? void 0 : i));
    });
  }, "onLocalStorageChange");
  return {
    setup: function setup() {
      if (Lr) {
        var s = he().getItem("".concat(ye, ".version"));
        s && s !== e && he().clear(), he().setItem("".concat(ye, ".version"), e), window.addEventListener("storage", o);
      }
    },
    teardown: function teardown() {
      Lr && window.removeEventListener("storage", o);
    },
    getItem: function getItem(s, a) {
      var i = Yo(he().getItem("".concat(ye, ".").concat(s)));
      return i == null ? a : i;
    },
    setItem: function setItem(s, a) {
      a === void 0 ? he().removeItem("".concat(ye, ".").concat(s)) : he().setItem("".concat(ye, ".").concat(s), JSON.stringify(a)), r(s, a);
    },
    removeItem: function removeItem(s) {
      he().removeItem("".concat(ye, ".").concat(s)), r(s, void 0);
    },
    reset: function reset() {
      var s = he();

      for (var a = 0; a < s.length; a++) {
        if (s.key(a).substring(0, vt) === ye) {
          var i = s.key(a).substring(vt + 1);
          s.removeItem(s.key(a)), r(i, void 0);
        }
      }
    },
    subscribe: function subscribe(s, a) {
      var i = Math.random().toString();
      return t[i] = {
        key: s,
        callback: a
      }, function () {
        delete t[i];
      };
    }
  };
}, "localStorageStore"),
    Yo = n(function (e) {
  try {
    return JSON.parse(e);
  } catch (_unused2) {
    return e;
  }
}, "tryParse"),
    br = /*#__PURE__*/function () {
  function br() {
    _classCallCheck(this, br);

    this.valuesMap = new Map();
  }

  _createClass(br, [{
    key: "getItem",
    value: function getItem(t) {
      return this.valuesMap.has(t) ? String(this.valuesMap.get(t)) : null;
    }
  }, {
    key: "setItem",
    value: function setItem(t, r) {
      this.valuesMap.set(t, r);
    }
  }, {
    key: "removeItem",
    value: function removeItem(t) {
      this.valuesMap.delete(t);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.valuesMap.clear();
    }
  }, {
    key: "key",
    value: function key(t) {
      if (arguments.length === 0) throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present.");
      return Array.from(this.valuesMap.keys())[t];
    }
  }, {
    key: "length",
    get: function get() {
      return this.valuesMap.size;
    }
  }]);

  return br;
}();

n(br, "LocalStorageShim");
var Ia = new br(),
    he = n(function () {
  return Lr ? window.localStorage : Ia;
}, "getStorage");
import Aa from "lodash/set";
import Jo from "lodash/unset";
import Fa from "lodash/get";
var Et = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = {},
      r = n(function (o, s) {
    Object.keys(t).forEach(function (a) {
      !t[a] || t[a].key === o && t[a].callback(s);
    });
  }, "publish");
  return {
    setup: function setup() {},
    teardown: function teardown() {
      Object.keys(e).forEach(function (o) {
        return delete e[o];
      });
    },
    getItem: function getItem(o, s) {
      return Fa(e, o, s);
    },
    setItem: function setItem(o, s) {
      Aa(e, o, s), r(o, s);
    },
    removeItem: function removeItem(o) {
      Jo(e, o), r(o, void 0);
    },
    reset: function reset() {
      Object.keys(e).forEach(function (o) {
        Jo(e, o), r(o, void 0);
      });
    },
    subscribe: function subscribe(o, s) {
      var a = Math.random().toString();
      return t[a] = {
        key: o,
        callback: s
      }, function () {
        delete t[a];
      };
    }
  };
}, "memoryStore");
import { createContext as Na } from "react";
var Oa = Et(),
    Dt = Na(Oa);
import * as $o from "react";
import { useEffect as Ua } from "react";
var Zo = n(function (_ref7) {
  var e = _ref7.value,
      t = _ref7.children;
  return Ua(function () {
    return e.setup(), function () {
      e.teardown();
    };
  }, [e]), $o.createElement(Dt.Provider, {
    value: e
  }, t);
}, "StoreContextProvider");
import * as wt from "react";
import { useEffect as ja } from "react";
import { useContext as ka } from "react";
var xe = n(function () {
  return ka(Dt);
}, "useStoreContext");
var Of = n(function (_ref8) {
  var e = _ref8.value,
      t = _ref8.name,
      r = _ref8.children;

  var _xe = xe(),
      o = _xe.setItem;

  return ja(function () {
    o(t, e);
  }, [t, o, e]), wt.createElement(wt.Fragment, null, r);
}, "StoreSetter");
import { useState as Si, useEffect as Mi } from "react";
var Va = n(function (e) {
  return e.replace(/(\(|\))/g, "\\$1");
}, "default");
import * as Er from "react";
import { memo as ii } from "react";
import * as en from "react";
import $a from "lodash/get";
import * as Ko from "react";
import { useEffect as Ya, useState as Xo } from "react";
import { createContext as Ga } from "react";
var Je = Ga({
  translate: function translate(e) {
    return e;
  },
  changeLocale: function changeLocale() {
    return Promise.resolve();
  },
  getLocale: function getLocale() {
    return "en";
  }
});
Je.displayName = "I18nContext";
import { useCallback as za } from "react";
import { useContext as _a } from "react";
import { createContext as Qa } from "react";
var It = Qa({
  notifications: [],
  addNotification: function addNotification() {},
  takeNotification: function takeNotification() {},
  resetNotifications: function resetNotifications() {}
});
var At = n(function () {
  return _a(It);
}, "useNotificationContext");
var G = n(function () {
  var _At = At(),
      e = _At.addNotification;

  return za(function (t) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var a = r,
        _a$type = a.type,
        o = _a$type === void 0 ? "info" : _a$type,
        s = F(a, ["type"]);
    e({
      message: t,
      type: o,
      notificationOptions: s
    });
  }, [e]);
}, "useNotify");
import * as Bo from "react";
import { useState as Ha, useCallback as vr, useMemo as Wa } from "react";
var qo = n(function (_ref9) {
  var e = _ref9.children;

  var _Ha = Ha([]),
      _Ha2 = _slicedToArray(_Ha, 2),
      t = _Ha2[0],
      r = _Ha2[1],
      o = vr(function (u) {
    r(function (c) {
      return [].concat(_toConsumableArray(c), [u]);
    });
  }, []),
      s = vr(function () {
    var _t2 = _toArray(t),
        u = _t2[0],
        c = _t2.slice(1);

    return r(c), u;
  }, [t]),
      a = vr(function () {
    r([]);
  }, []),
      i = Wa(function () {
    return {
      notifications: t,
      addNotification: o,
      takeNotification: s,
      resetNotifications: a
    };
  }, [t]);

  return Bo.createElement(It.Provider, {
    value: i
  }, e);
}, "NotificationContextProvider");
var Ft = n(function (_ref10) {
  var _ref10$value = _ref10.value,
      e = _ref10$value === void 0 ? Ja : _ref10$value,
      t = _ref10.children;

  var _ue = ue("locale"),
      _ue2 = _slicedToArray(_ue, 1),
      r = _ue2[0],
      o = G(),
      _Xo = Xo(0),
      _Xo2 = _slicedToArray(_Xo, 2),
      s = _Xo2[0],
      a = _Xo2[1],
      _Xo3 = Xo(r === e.getLocale()),
      _Xo4 = _slicedToArray(_Xo3, 2),
      i = _Xo4[0],
      u = _Xo4[1];

  return Ya(function () {
    r && e.getLocale() !== r ? new Promise(function (c) {
      c(e.changeLocale(r));
    }).then(function () {
      a(function (c) {
        return c + 1;
      }), u(!0);
    }).catch(function (c) {
      u(!0), o("ra.notification.i18n_error", {
        type: "warning"
      }), console.error(c);
    }) : u(!0);
  }, [e, r, o]), i ? Ko.createElement(Je.Provider, {
    value: e,
    key: s
  }, t) : null;
}, "I18nContextProvider"),
    Ja = {
  translate: function translate(e) {
    return e;
  },
  changeLocale: function changeLocale() {
    return Promise.resolve();
  },
  getLocale: function getLocale() {
    return "en";
  }
};
var sy = n(function (_ref11) {
  var e = _ref11.translate,
      t = _ref11.messages,
      r = _ref11.children;
  return en.createElement(Ft, {
    value: {
      translate: t ? function (o, s) {
        var a = $a(t, o);
        return a ? typeof a == "function" ? a(s) : a : s._;
      } : e,
      changeLocale: function changeLocale() {
        return Promise.resolve();
      },
      getLocale: function getLocale() {
        return "en";
      }
    }
  }, r);
}, "TestTranslationProvider");
import { createContext as Za } from "react";
var Nt = Za(void 0);
import * as tn from "react";
var dy = n(function (_ref12) {
  var e = _ref12.children,
      t = _ref12.value;
  return tn.createElement(Nt.Provider, {
    value: t
  }, e);
}, "TranslatableContextProvider");
import Ba from "lodash/merge";
var yy = n(function (e, t) {
  var _window$navigator = window.navigator,
      r = _window$navigator.language,
      o = _window$navigator.browserLanguage,
      s = _window$navigator.userLanguage,
      a = r || o || s || e || rn;
  return (t == null ? void 0 : t.fullLocale) ? a : a.split("-")[0];
}, "resolveBrowserLocale"),
    gy = n(function () {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }

  return Ba.apply(void 0, [{}].concat(e));
}, "mergeTranslations");
import { useMemo as Ka } from "react";
import { useContext as qa } from "react";
var Ot = n(function () {
  return qa(Je);
}, "useI18nProvider");
var Oe = n(function () {
  var e = Ot(),
      t = Ka(function () {
    return e.getLocale();
  }, [e]);
  return ue("locale", t);
}, "useLocaleState");
var by = n(function () {
  var _Oe = Oe(),
      _Oe2 = _slicedToArray(_Oe, 1),
      e = _Oe2[0];

  return e;
}, "useLocale");
var Dy = n(function () {
  var _Oe3 = Oe(),
      _Oe4 = _slicedToArray(_Oe3, 2),
      e = _Oe4[1];

  return e;
}, "useSetLocale");
import { useState as ti, useMemo as ri } from "react";
import { useCallback as Xa } from "react";
var Q = n(function () {
  var e = Ot(),
      t = Xa(function (r, o) {
    return e.translate(r, o);
  }, [e]);
  return e ? t : ei;
}, "useTranslate"),
    ei = n(function (e) {
  return e;
}, "identity");
var Vy = n(function (e) {
  var _Oe5 = Oe(),
      _Oe6 = _slicedToArray(_Oe5, 1),
      t = _Oe6[0],
      _e$defaultLocale = e.defaultLocale,
      r = _e$defaultLocale === void 0 ? t : _e$defaultLocale,
      o = e.locales,
      _ti = ti(r),
      _ti2 = _slicedToArray(_ti, 2),
      s = _ti2[0],
      a = _ti2[1],
      i = H({}),
      u = Q();

  return ri(function () {
    return {
      getSource: function getSource(p) {
        var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : s;
        return "".concat(p, ".").concat(m);
      },
      getLabel: function getLabel(p, m) {
        return u.apply(void 0, _toConsumableArray($e({
          source: p,
          resource: i,
          label: m
        })));
      },
      locales: o,
      selectedLocale: s,
      selectLocale: a
    };
  }, [o, i, s, u]);
}, "useTranslatable");
import { useContext as oi } from "react";
var Hy = n(function () {
  var e = oi(Nt);
  if (!e) throw new Error("useTranslatableContext must be used inside a TranslatableContextProvider");
  return e;
}, "useTranslatableContext");
var rn = "en";
import ni from "inflection";
var $e = n(function (e) {
  if (!e) return [""];
  var t = e.label,
      r = e.parentSource,
      o = e.resource,
      s = e.source;
  return typeof t != "undefined" ? [t, {
    _: t
  }] : typeof s != "undefined" ? ["resources.".concat(o, ".fields.").concat(r ? "".concat(r, ".").concat(s) : s), {
    _: ni.transform(s, ["underscore", "humanize"])
  }] : [""];
}, "default");
import { useContext as ai } from "react";
import { createContext as si } from "react";
var Ut = si(void 0);
var H = n(function (e) {
  var t = ai(Ut);
  return e && e.resource || t;
}, "useResourceContext");
var on = n(function (e) {
  var t = e.source,
      r = e.label,
      o = e.isRequired,
      s = H(e),
      a = Q();
  return r === !1 || r === "" ? null : r && typeof r != "string" ? r : Er.createElement("span", null, a.apply(void 0, _toConsumableArray($e({
    label: r,
    resource: s,
    source: t
  }))), o && Er.createElement("span", {
    "aria-hidden": "true"
  }, "\u2009*"));
}, "FieldTitle");
on.displayName = "FieldTitle";
var ci = ii(on);
import { isValidElementType as ui } from "react-is";
var li = n(function (e, t, r) {
  if (e[t] && !ui(e[t])) return new Error("Invalid prop '".concat(t, "' supplied to '").concat(r, "': the prop is not a valid React component"));
}, "default");

function nn(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}

n(nn, "is");
var sn = n(function (e, t) {
  if (nn(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var r = Object.keys(e),
      o = Object.keys(t);
  if (r.length !== o.length) return !1;

  for (var s = 0; s < r.length; s++) {
    if (!Object.prototype.hasOwnProperty.call(t, r[s]) || !nn(e[r[s]], t[r[s]])) return !1;
  }

  return !0;
}, "shallowEqual");
var di = n(function (e) {
  return e && Object.prototype.toString.call(e) === "[object Object]";
}, "isObject"),
    pi = n(function (e) {
  return e instanceof Date ? !1 : e === "" || e === null || e === void 0 || sn(e, {});
}, "isEmpty"),
    an = n(function (e) {
  return Object.keys(e).reduce(function (t, r) {
    var o = e[r];
    return di(e[r]) && (o = an(e[r])), pi(o) ? t : D(y({}, t), _defineProperty({}, r, o));
  }, {});
}, "removeEmpty"),
    X = an;
var cn = n(function (e, t) {
  return Object.keys(e).reduce(function (r, o) {
    return o !== t ? Object.assign({}, r, _defineProperty({}, o, e[o])) : r;
  }, {});
}, "removeKey"),
    un = n(function (e, t) {
  var r = t.split(".");
  if (r.length === 1) return cn(e, t);
  var o = r[0];
  if (e[o] === void 0) return e;
  var s = un(e[o], r.slice(1).join("."));
  return Object.keys(s).length === 0 ? cn(e, o) : Object.assign({}, e, _defineProperty({}, o, s));
}, "deepRemoveKey"),
    Dr = un;
import * as Z from "react";
import { useState as mi } from "react";
var Ce = {
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    fontFamily: '"Roboto", sans-serif'
  },
  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    flexDirection: "column",
    background: "linear-gradient(135deg, #00023b 0%, #00023b 50%, #313264 100%)",
    color: "white",
    fontSize: "1.5em",
    fontWeight: "bold"
  },
  secondary: {
    height: "20vh",
    background: "#e8e8e8",
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly"
  },
  link: {
    textAlign: "center",
    width: 150,
    display: "block",
    textDecoration: "none",
    color: "black",
    opacity: .7
  },
  linkHovered: {
    opacity: 1
  },
  image: {
    width: 50
  },
  logo: {
    height: 100
  }
},
    wr = n(function (_ref13) {
  var e = _ref13.img,
      t = _ref13.label,
      r = _ref13.href;

  var _mi = mi(!1),
      _mi2 = _slicedToArray(_mi, 2),
      o = _mi2[0],
      s = _mi2[1];

  return Z.createElement("div", null, Z.createElement("a", {
    href: r,
    style: o ? y(y({}, Ce.link), Ce.linkHovered) : Ce.link,
    onMouseEnter: function onMouseEnter() {
      return s(!0);
    },
    onMouseLeave: function onMouseLeave() {
      return s(!1);
    }
  }, Z.createElement("img", {
    src: e,
    alt: t,
    style: Ce.image
  }), Z.createElement("br", null), t));
}, "Button"),
    Ir = n(function () {
  return process.env.NODE_ENV === "production" ? Z.createElement("span", null) : Z.createElement("div", {
    style: Ce.root
  }, Z.createElement("div", {
    style: Ce.main
  }, Z.createElement("img", {
    style: Ce.logo,
    src: "data:image/svg+xml;base64,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",
    alt: "react-admin logo"
  }), Z.createElement("h1", null, "Welcome to React-admin"), Z.createElement("div", null, "Your application is properly configured.", Z.createElement("br", null), "Now you can add a <Resource> as child of <Admin>.")), Z.createElement("div", {
    style: Ce.secondary
  }, Z.createElement(wr, {
    href: "https://marmelab.com/react-admin/Readme.html",
    img: "data:image/svg+xml;base64,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",
    label: "Documentation"
  }), Z.createElement(wr, {
    href: "https://github.com/marmelab/react-admin/tree/master/examples",
    img: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDBWMHoiLz48cGF0aCBkPSJNOS40IDE2LjZMNC44IDEybDQuNi00LjZMOCA2bC02IDYgNiA2IDEuNC0xLjR6bTUuMiAwbDQuNi00LjYtNC42LTQuNkwxNiA2bDYgNi02IDYtMS40LTEuNHoiLz48L3N2Zz4=",
    label: "Examples"
  }), Z.createElement(wr, {
    href: "https://stackoverflow.com/questions/tagged/react-admin",
    img: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyNHB4IgoJIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJCb3VuZGluZ19Cb3giPgoJPHJlY3QgZmlsbD0ibm9uZSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ii8+CjwvZz4KPGcgaWQ9IkZsYXQiPgoJPGcgaWQ9InVpX3g1Rl9zcGVjX3g1Rl9oZWFkZXJfY29weV8yIj4KCTwvZz4KCTxnPgoJCTxjaXJjbGUgb3BhY2l0eT0iMC4zIiBjeD0iOSIgY3k9IjgiIHI9IjIiLz4KCQk8cGF0aCBvcGFjaXR5PSIwLjMiIGQ9Ik05LDE1Yy0yLjcsMC01LjgsMS4yOS02LDIuMDFMMywxOGgxMnYtMUMxNC44LDE2LjI5LDExLjcsMTUsOSwxNXoiLz4KCQk8cGF0aCBkPSJNMTYuNjcsMTMuMTNDMTguMDQsMTQuMDYsMTksMTUuMzIsMTksMTd2M2g0di0zQzIzLDE0LjgyLDE5LjQzLDEzLjUzLDE2LjY3LDEzLjEzeiIvPgoJCTxwYXRoIGQ9Ik0xNSwxMmMyLjIxLDAsNC0xLjc5LDQtNGMwLTIuMjEtMS43OS00LTQtNGMtMC40NywwLTAuOTEsMC4xLTEuMzMsMC4yNEMxNC41LDUuMjcsMTUsNi41OCwxNSw4cy0wLjUsMi43My0xLjMzLDMuNzYKCQkJQzE0LjA5LDExLjksMTQuNTMsMTIsMTUsMTJ6Ii8+CgkJPHBhdGggZD0iTTksMTJjMi4yMSwwLDQtMS43OSw0LTRjMC0yLjIxLTEuNzktNC00LTRTNSw1Ljc5LDUsOEM1LDEwLjIxLDYuNzksMTIsOSwxMnogTTksNmMxLjEsMCwyLDAuOSwyLDJjMCwxLjEtMC45LDItMiwyCgkJCVM3LDkuMSw3LDhDNyw2LjksNy45LDYsOSw2eiIvPgoJCTxwYXRoIGQ9Ik05LDEzYy0yLjY3LDAtOCwxLjM0LTgsNHYzaDE2di0zQzE3LDE0LjM0LDExLjY3LDEzLDksMTN6IE0xNSwxOEgzbDAtMC45OUMzLjIsMTYuMjksNi4zLDE1LDksMTVzNS44LDEuMjksNiwyVjE4eiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=",
    label: "Community"
  })));
}, "default");
var Ze = n(function (e, t) {
  e && process.env.NODE_ENV !== "production" && console.warn(t);
}, "default");
import { useRef as fi, useEffect as yi } from "react";

function ln(e, t) {
  var r = fi();
  yi(function () {
    if (r.current) {
      var o = Object.keys(y(y({}, r.current), t)),
          s = {};
      o.forEach(function (a) {
        r.current[a] !== t[a] && (s[a] = {
          from: r.current[a],
          to: t[a]
        });
      }), Object.keys(s).length && console.log("[why-did-you-update]", e, s);
    }

    r.current = t;
  });
}

n(ln, "useWhyDidYouUpdate");
var gi = n(function (e, t) {
  if (e) return e;

  switch (t) {
    case !0:
      return "undoable";

    case !1:
      return "pessimistic";

    default:
      return "undoable";
  }
}, "getMutationMode");

function Fg(e) {
  return function (t) {
    e.forEach(function (r) {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}

n(Fg, "mergeRefs");
import * as Ue from "react";
import { useCallback as Ri } from "react";
var Pi = typeof window != "undefined" ? Ue.useLayoutEffect : Ue.useEffect,
    dn = n(function (e, t) {
  var r = Ue.useRef(function () {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return Pi(function () {
    r.current = e;
  }, [e].concat(_toConsumableArray(t))), Ri(function () {
    return r.current.apply(r, arguments);
  }, []);
}, "useEventCallback");
import { useState as hi, useRef as kt, useEffect as Be, useCallback as xi } from "react";
import Ci from "lodash/isEqual";

function z(e) {
  var _hi = hi(e),
      _hi2 = _slicedToArray(_hi, 2),
      t = _hi2[0],
      r = _hi2[1],
      o = kt(!1);

  Be(function () {
    return o.current = !0, function () {
      o.current = !1;
    };
  }, []);
  var s = xi(function (a) {
    if (o.current) return r(a);
  }, [o, r]);
  return [t, s];
}

n(z, "useSafeSetState");

function Ti(e) {
  var t = kt();
  return Be(function () {
    t.current = e;
  }), t.current;
}

n(Ti, "usePrevious");

function Vg(e, t) {
  var r = kt();
  Be(function () {
    return Ci(o, t) || (r.current = e()), r.current;
  });
  var o = Ti(t);
}

n(Vg, "useDeepCompareEffect");

function pn() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var _z = z(!1),
      _z2 = _slicedToArray(_z, 2),
      r = _z2[0],
      o = _z2[1];

  return Be(function () {
    o(!1);
    var s = setTimeout(function () {
      o(!0);
    }, e);
    return function () {
      clearTimeout(s);
    };
  }, [t, e, o]), r;
}

n(pn, "useTimeout");

function mn() {
  var e = kt(!0);
  return Be(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), e;
}

n(mn, "useIsMounted");
var ue = n(function (e, t) {
  var _xe2 = xe(),
      r = _xe2.getItem,
      o = _xe2.setItem,
      s = _xe2.subscribe,
      _Si = Si(function () {
    return r(e, t);
  }),
      _Si2 = _slicedToArray(_Si, 2),
      a = _Si2[0],
      i = _Si2[1];

  Mi(function () {
    var c = s(e, function (p) {
      i(typeof p == "undefined" ? t : p);
    });
    return function () {
      return c();
    };
  }, [e, s, t]);
  var u = dn(function (c, p) {
    var m = typeof c == "function" ? c(a) : c;
    o(e, typeof m == "undefined" ? typeof p == "undefined" ? t : p : m);
  }, [e, o, t, a]);
  return [a, u];
}, "useStore");
import { useCallback as Li } from "react";
var fn = n(function (e) {
  var _xe3 = xe(),
      t = _xe3.removeItem;

  return Li(function (r) {
    return t(typeof r == "undefined" ? e : r);
  }, [t, e]);
}, "useRemoveFromStore");
var yn = n(function () {
  var _xe4 = xe(),
      e = _xe4.reset;

  return e;
}, "useResetStore");
var Di = n(function () {
  var e = ee(),
      t = yn(),
      r = Ei(),
      o = Rn(r),
      s = vi(),
      a = Rn(s),
      i = ae(),
      u = ie("".concat(i, "/").concat(Ne.loginUrl));
  bi(function () {
    a.current = s, o.current = r;
  }, [s, r]);
  var c = gn(function () {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : u;
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    return e.logout(m).then(function (C) {
      if (C === !1) {
        t();
        return;
      }

      var b = (C || f).split("?"),
          S = {
        pathname: b[0]
      },
          P = {};
      return x && a.current && a.current.pathname && (P = {
        state: {
          nextPathname: a.current.pathname,
          nextSearch: a.current.search
        }
      }), b[1] && (S.search = b[1]), o.current(S, P), t(), C;
    });
  }, [e, t, u]),
      p = gn(function (m) {
    return r({
      pathname: u
    }, {
      state: {
        nextPathname: s && s.pathname
      }
    }), t(), Promise.resolve();
  }, [t, s, r, u]);
  return e ? c : p;
}, "useLogout"),
    Ee = Di;
var ke = n(function () {
  var e = ee(),
      t = G(),
      r = Ee(),
      o = ae(),
      s = ie("".concat(o, "/").concat(Ne.loginUrl)),
      a = wi(function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : s;
    var p = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
    return e.checkAuth(i).catch(function (m) {
      throw u && (r({}, m && m.redirectTo ? m.redirectTo : c), !(p || m && m.message === !1) && t(Ai(m, "ra.auth.auth_check_error"), {
        type: "warning"
      })), m;
    });
  }, [e, r, t, s]);
  return e ? a : Ii;
}, "useCheckAuth"),
    Ii = n(function () {
  return Promise.resolve();
}, "checkAuthWithoutAuthProvider"),
    Ai = n(function (e, t) {
  return typeof e == "string" ? e : typeof e == "undefined" || !e.message ? t : e.message;
}, "getErrorMessage");
var Ni = {},
    Oi = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Ni;

  var _z3 = z({
    isLoading: !0,
    authenticated: !0
  }),
      _z4 = _slicedToArray(_z3, 2),
      t = _z4[0],
      r = _z4[1],
      o = ke();

  return Fi(function () {
    o(e, !1).then(function () {
      return r({
        isLoading: !1,
        authenticated: !0
      });
    }).catch(function () {
      return r({
        isLoading: !1,
        authenticated: !1
      });
    });
  }, [o, e, r]), t;
}, "useAuthState"),
    Ar = Oi;
import { useEffect as Vi } from "react";
import { useCallback as Ui } from "react";
var ki = n(function () {
  return Promise.resolve([]);
}, "getPermissionsWithoutProvider"),
    ji = n(function () {
  var e = ee(),
      t = Ui(function () {
    var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return e.getPermissions(r);
  }, [e]);
  return e ? t : ki;
}, "useGetPermissions"),
    qe = ji;
var Gi = {},
    Qi = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Gi;

  var _z5 = z({
    isLoading: !0
  }),
      _z6 = _slicedToArray(_z5, 2),
      t = _z6[0],
      r = _z6[1],
      o = qe();

  return Vi(function () {
    o(e).then(function (s) {
      r({
        isLoading: !1,
        permissions: s
      });
    }).catch(function (s) {
      r({
        isLoading: !1,
        error: s
      });
    });
  }, [o, e, r]), t;
}, "usePermissions"),
    Fr = Qi;
import { useEffect as _i } from "react";
import zi from "lodash/isEqual";
var Hi = {},
    Pn = {
  "{}": void 0
},
    Wi = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Hi;

  var t = JSON.stringify(e),
      _z7 = z({
    permissions: Pn[t]
  }),
      _z8 = _slicedToArray(_z7, 2),
      r = _z8[0],
      o = _z8[1],
      s = qe();

  return _i(function () {
    s(e).then(function (a) {
      zi(a, r.permissions) || (Pn[t] = a, o({
        permissions: a
      }));
    }).catch(function (a) {
      o({
        error: a
      });
    });
  }, [s, t]), r;
}, "usePermissionsOptimized"),
    Nr = Wi;
import { Children as $i, createElement as Zi } from "react";
import { useEffect as Yi } from "react";
var re = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _e$enabled = e.enabled,
      t = _e$enabled === void 0 ? !0 : _e$enabled,
      _e$params = e.params,
      r = _e$params === void 0 ? Ji : _e$params,
      o = ke();
  Yi(function () {
    t && o(r).catch(function () {});
  }, [o, t, r]);
}, "useAuthenticated"),
    Ji = {};
var hn = n(function (e) {
  return $i.count(e) === 0;
}, "isEmptyChildren"),
    Bi = n(function (e) {
  var c = e,
      t = c.authParams,
      r = c.children,
      o = c.render,
      s = c.component,
      a = c.staticContext,
      i = F(c, ["authParams", "children", "render", "component", "staticContext"]);
  Ze(o && r && !hn(r) || o && s || s && r && !hn(r), "You should only use one of the `component`, `render` and `children` props in <WithPermissions>"), re(t);

  var _Nr = Nr(t),
      u = _Nr.permissions;

  if (s) return Zi(s, y({
    permissions: u
  }, i));
  if (o) return o(y({
    permissions: u
  }, i));
  if (r) return r(y({
    permissions: u
  }, i));
}, "WithPermissions"),
    Or = Bi;
import { useCallback as xn } from "react";
import { useLocation as qi, useNavigate as Ki } from "react-router-dom";
var Xi = n(function () {
  var e = ee(),
      r = qi().state,
      o = Ki(),
      s = ae(),
      _At2 = At(),
      a = _At2.resetNotifications,
      i = r && r.nextPathname,
      u = r && r.nextSearch,
      c = ie("".concat(s, "/").concat(Ne.afterLoginUrl)),
      p = xn(function () {
    var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var x = arguments.length > 1 ? arguments[1] : undefined;
    return e.login(f).then(function (C) {
      a();
      var b = x || i + u || c;
      return o(b), C;
    });
  }, [e, o, i, u, a, c]),
      m = xn(function (f, x) {
    return a(), o(c), Promise.resolve();
  }, [o, a, c]);

  return e ? p : m;
}, "useLogin"),
    ec = Xi;
import { useEffect as tc } from "react";
var Cn = {
  id: "",
  fullName: null
},
    rc = n(function () {
  var _z9 = z({
    isLoading: !0
  }),
      _z10 = _slicedToArray(_z9, 2),
      e = _z10[0],
      t = _z10[1],
      r = ee();

  return tc(function () {
    r && typeof r.getIdentity == "function" ? n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var s;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return r.getIdentity();

            case 3:
              s = _context.sent;
              t({
                isLoading: !1,
                identity: s || Cn
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              t({
                isLoading: !1,
                error: _context.t0
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })), "callAuthProvider")() : t({
      isLoading: !1,
      identity: Cn
    });
  }, [r, t]), e;
}, "useGetIdentity"),
    oc = rc;
import { useCallback as nc } from "react";
import { useNavigate as sc } from "react-router";
var Ur,
    ac = n(function () {
  var e = ee(),
      t = Ee(),
      r = G(),
      o = sc(),
      s = nc(function (a, i) {
    return e.checkError(a).then(function () {
      return !1;
    }).catch( /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(u) {
        var f, c, m;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                c = (f = u == null ? void 0 : u.logoutUser) != null ? f : !0;

                if (!Ur) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", !0);

              case 3:
                Ur = setTimeout(function () {
                  Ur = void 0;
                }, 0), !(i || u && u.message === !1 || a && a.message === !1) && e.checkAuth({}).then(function () {
                  c ? r(Tn(u, "ra.notification.logged_out"), {
                    type: "warning"
                  }) : r(Tn(u, "ra.notification.not_authorized"), {
                    type: "warning"
                  });
                }).catch(function () {});
                m = u && u.redirectTo ? u.redirectTo : a && a.redirectTo ? a.redirectTo : void 0;
                return _context2.abrupt("return", (c ? t({}, m) : o(m), !0));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref15.apply(this, arguments);
      };
    }());
  }, [e, t, r, o]);
  return e ? s : ic;
}, "useLogoutIfAccessDenied"),
    ic = n(function () {
  return Promise.resolve(!1);
}, "logoutIfAccessDeniedWithoutProvider"),
    Tn = n(function (e, t) {
  return typeof e == "string" ? e : typeof e == "undefined" || !e.message ? t : e.message;
}, "getErrorMessage"),
    kr = ac;
var Sn = "AUTH_LOGIN",
    Mn = "AUTH_CHECK",
    Ln = "AUTH_ERROR",
    bn = "AUTH_LOGOUT",
    vn = "AUTH_GET_PERMISSIONS";
var jr = n(function (e) {
  var t = n(function () {
    for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      r[_key2] = arguments[_key2];
    }

    return e.apply(null, r);
  }, "authProvider");
  return t.login = function (r) {
    return e(Sn, r);
  }, t.logout = function (r) {
    return e(bn, r);
  }, t.checkAuth = function (r) {
    return e(Mn, r);
  }, t.checkError = function (r) {
    return e(Ln, r);
  }, t.getPermissions = function (r) {
    return e(vn, r);
  }, t;
}, "default");
import * as jt from "react";
var xP = n(function (e) {
  var t = e.authParams,
      r = e.children;
  return re({
    params: t
  }), jt.createElement(jt.Fragment, null, r);
}, "Authenticated");
var Vr = "GET_LIST",
    Gr = "GET_ONE",
    Qr = "GET_MANY",
    _r = "GET_MANY_REFERENCE",
    zr = "CREATE",
    Hr = "UPDATE",
    Wr = "UPDATE_MANY",
    Yr = "DELETE",
    Jr = "DELETE_MANY",
    En = ["getOne", "create", "update"],
    $r = ["getList", "getMany", "getManyReference"],
    Dn = [].concat($r, ["updateMany", "deleteMany"]),
    wn = ["getList", "getManyReference"],
    GP = n(function (e) {
  switch (e) {
    case Vr:
      return "getList";

    case Gr:
      return "getOne";

    case Qr:
      return "getMany";

    case _r:
      return "getManyReference";

    case zr:
      return "create";

    case Hr:
      return "update";

    case Wr:
      return "updateMany";

    case Yr:
      return "delete";

    case Jr:
      return "deleteMany";

    default:
      return e;
  }
}, "sanitizeFetchType");
var le = n(function () {
  return Promise.resolve();
}, "defaultDataProvider");

le.create = function () {
  return Promise.resolve(null);
};

le.delete = function () {
  return Promise.resolve(null);
};

le.deleteMany = function () {
  return Promise.resolve(null);
};

le.getList = function () {
  return Promise.resolve(null);
};

le.getMany = function () {
  return Promise.resolve(null);
};

le.getManyReference = function () {
  return Promise.resolve(null);
};

le.getOne = function () {
  return Promise.resolve(null);
};

le.update = function () {
  return Promise.resolve(null);
};

le.updateMany = function () {
  return Promise.resolve(null);
};

var In = {
  create: zr,
  delete: Yr,
  deleteMany: Jr,
  getList: Vr,
  getMany: Qr,
  getManyReference: _r,
  getOne: Gr,
  update: Hr,
  updateMany: Wr
},
    cc = n(function (e) {
  return new Proxy(le, {
    get: function get(r, o) {
      return function (s, a) {
        if (Object.keys(In).includes(o.toString())) {
          var i = In[o.toString()];
          return e(i, s, a);
        }

        return e(o.toString(), s, a);
      };
    },
    apply: function apply(r, o, s) {
      return e.apply(e, s);
    }
  });
}, "convertLegacyDataProvider"),
    Zr = cc;
import { createContext as uc } from "react";
var An = uc(null);
An.displayName = "DataProviderContext";
var Ke = An;

var Xe = /*#__PURE__*/function (_Error) {
  _inherits(Xe, _Error);

  function Xe(t, r) {
    var _this;

    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, Xe);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Xe).call(this, t));
    _this.message = t;
    _this.status = r;
    _this.body = o;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), Xe.prototype), _this.name = _this.constructor.name, typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor) : _this.stack = new Error(t).stack, _this.stack = new Error().stack;
    return _this;
  }

  return Xe;
}(_wrapNativeSuper(Error));

n(Xe, "HttpError");
var Br = Xe;
var On = {};
ca(On, {
  createHeadersFromOptions: function createHeadersFromOptions() {
    return Fn;
  },
  fetchJson: function fetchJson() {
    return dc;
  },
  flattenObject: function flattenObject() {
    return Nn;
  },
  queryParameters: function queryParameters() {
    return pc;
  }
});
import { stringify as lc } from "query-string";
var Fn = n(function (e) {
  var t = e.headers || new Headers({
    Accept: "application/json"
  });
  return !t.has("Content-Type") && !(e && (!e.method || e.method === "GET")) && !(e && e.body && e.body instanceof FormData) && t.set("Content-Type", "application/json"), e.user && e.user.authenticated && e.user.token && t.set("Authorization", e.user.token), t;
}, "createHeadersFromOptions"),
    dc = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = Fn(t);
  return fetch(e, D(y({}, t), {
    headers: r
  })).then(function (o) {
    return o.text().then(function (s) {
      return {
        status: o.status,
        statusText: o.statusText,
        headers: o.headers,
        body: s
      };
    });
  }).then(function (_ref16) {
    var o = _ref16.status,
        s = _ref16.statusText,
        a = _ref16.headers,
        i = _ref16.body;
    var u;

    try {
      u = JSON.parse(i);
    } catch (_unused3) {}

    return o < 200 || o >= 300 ? Promise.reject(new Br(u && u.message || s, o, u)) : Promise.resolve({
      status: o,
      headers: a,
      body: i,
      json: u
    });
  });
}, "fetchJson"),
    pc = lc,
    mc = n(function (e) {
  if (!e) return !1;
  var t = Array.isArray(e),
      r = typeof Buffer != "undefined" && Buffer.isBuffer(e),
      o = Object.prototype.toString.call(e) === "[object Object]",
      s = !!Object.keys(e).length;
  return !t && !r && o && s;
}, "isValidObject"),
    Nn = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return mc(e) ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(e).map(function (r) {
    return Nn(e[r], t.concat([r]));
  })))) : t.length ? _defineProperty({}, t.join("."), e) : e;
}, "flattenObject");
import fc from "eventemitter3";
var ge = new fc();
var je = {
  create: function create() {
    return Promise.resolve({
      data: null
    });
  },
  delete: function _delete() {
    return Promise.resolve({
      data: null
    });
  },
  deleteMany: function deleteMany() {
    return Promise.resolve({
      data: []
    });
  },
  getList: function getList() {
    return Promise.resolve({
      data: [],
      total: 0
    });
  },
  getMany: function getMany() {
    return Promise.resolve({
      data: []
    });
  },
  getManyReference: function getManyReference() {
    return Promise.resolve({
      data: [],
      total: 0
    });
  },
  getOne: function getOne() {
    return Promise.resolve({
      data: null
    });
  },
  update: function update() {
    return Promise.resolve({
      data: null
    });
  },
  updateMany: function updateMany() {
    return Promise.resolve({
      data: []
    });
  }
};
var XP = n(function (e) {
  return new Proxy(je, {
    get: function get(t, r) {
      return function (o, s) {
        if (!(typeof r == "symbol" || r === "then")) return e(o)[r](o, s);
      };
    }
  });
}, "combineDataProviders");
var th = n(function (e) {
  return y({
    getList: function getList() {
      return Promise.resolve({
        data: [],
        total: 0
      });
    },
    getOne: function getOne() {
      return Promise.resolve({
        data: void 0
      });
    },
    getMany: function getMany() {
      return Promise.resolve({
        data: []
      });
    },
    getManyReference: function getManyReference() {
      return Promise.resolve({
        data: [],
        total: 0
      });
    },
    create: function create() {
      return Promise.resolve({
        data: void 0
      });
    },
    update: function update() {
      return Promise.resolve({
        data: void 0
      });
    },
    updateMany: function updateMany() {
      return Promise.resolve({
        data: []
      });
    },
    delete: function _delete() {
      return Promise.resolve({
        data: void 0
      });
    },
    deleteMany: function deleteMany() {
      return Promise.resolve({
        data: []
      });
    }
  }, e);
}, "testDataProvider");
import { useContext as gc, useMemo as Rc } from "react";

function yc(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.error;
  if (!e) throw r("The dataProvider returned an empty response for '".concat(t, "'.")), new Error("ra.notification.data_provider_error");
  if (!e.hasOwnProperty("data")) throw r("The response to '".concat(t, "' must be like { data: ... }, but the received response does not have a 'data' key. The dataProvider is probably wrong for '").concat(t, "'.")), new Error("ra.notification.data_provider_error");
  if (Dn.includes(t) && !Array.isArray(e.data)) throw r("The response to '".concat(t, "' must be like { data : [...] }, but the received data is not an array. The dataProvider is probably wrong for '").concat(t, "'")), new Error("ra.notification.data_provider_error");
  if ($r.includes(t) && Array.isArray(e.data) && e.data.length > 0 && !e.data[0].hasOwnProperty("id")) throw r("The response to '".concat(t, "' must be like { data : [{ id: 123, ...}, ...] }, but the received data items do not have an 'id' key. The dataProvider is probably wrong for '").concat(t, "'")), new Error("ra.notification.data_provider_error");
  if (En.includes(t) && !e.data.hasOwnProperty("id")) throw r("The response to '".concat(t, "' must be like { data: { id: 123, ... } }, but the received data does not have an 'id' key. The dataProvider is probably wrong for '").concat(t, "'")), new Error("ra.notification.data_provider_error");
  if (wn.includes(t) && !e.hasOwnProperty("total") && !e.hasOwnProperty("pageInfo")) throw r("The response to '".concat(t, "' must be like  { data: [...], total: 123 }, but the received response does not have a 'total' key. The dataProvider is probably wrong for '").concat(t, "'")), new Error("ra.notification.data_provider_error");
}

n(yc, "validateResponseFormat");
var Un = yc;
var W = n(function () {
  var e = gc(Ke) || je,
      t = kr();
  return Rc(function () {
    return new Proxy(e, {
      get: function get(o, s) {
        if (!(typeof s == "symbol" || s === "then")) return function () {
          var i = s.toString();
          if (typeof e[i] != "function") throw new Error("Unknown dataProvider function: ".concat(i));

          try {
            for (var _len3 = arguments.length, a = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              a[_key3] = arguments[_key3];
            }

            return e[i].apply(e, a).then(function (u) {
              return process.env.NODE_ENV !== "production" && Un(u, i), u;
            }).catch(function (u) {
              return process.env.NODE_ENV !== "production" && console.error(u), t(u).then(function (c) {
                if (!c) throw u;
              });
            });
          } catch (u) {
            throw process.env.NODE_ENV !== "production" && console.error(u), new Error("The dataProvider threw an error. It should return a rejected Promise instead.");
          }
        };
      }
    });
  }, [e, t]);
}, "useDataProvider");
import { useEffect as Pc, useState as hc } from "react";
import { useQueryClient as xc, QueryObserver as Cc } from "react-query";
var mh = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _t$enabled = t.enabled,
      r = _t$enabled === void 0 ? !0 : _t$enabled,
      o = xc(),
      _hc = hc(function () {
    return r ? o.getQueryData(e) !== void 0 : !1;
  }),
      _hc2 = _slicedToArray(_hc, 2),
      s = _hc2[0],
      a = _hc2[1];

  return Pc(function () {
    if (!!r && o.getQueryData(e) === void 0) {
      var u = new Cc(o, {
        queryKey: e
      }).subscribe(function (c) {
        a(!c.isLoading), u();
      });
      return u;
    }
  }, [r, e, o]), s;
}, "useIsDataLoaded");
import et from "react";
import { notifyManager as kn, useQueryClient as Tc } from "react-query";
var Rh = n(function () {
  var e = Tc(),
      t = et.useRef(!1),
      r = et.useRef(e.isFetching() > 0),
      o = et.useRef(e.isMutating() > 0),
      _et$useState = et.useState(r.current || o.current),
      _et$useState2 = _slicedToArray(_et$useState, 2),
      s = _et$useState2[0],
      a = _et$useState2[1];

  return et.useEffect(function () {
    t.current = !0;
    var i = e.getQueryCache().subscribe(kn.batchCalls(function () {
      t.current && (r.current = e.isFetching() > 0, a(r.current || o.current));
    })),
        u = e.getMutationCache().subscribe(kn.batchCalls(function () {
      t.current && (o.current = e.isMutating() > 0, a(r.current || o.current));
    }));
    return function () {
      t.current = !1, i(), u();
    };
  }, [e]), s;
}, "useLoading");
import { useCallback as Sc } from "react";
import { useQueryClient as Mc } from "react-query";
var Vt = n(function () {
  var e = Mc();
  return Sc(function () {
    e.invalidateQueries();
  }, [e]);
}, "useRefresh");
import { useQuery as Lc } from "react-query";
var Gt = n(function (e, _ref18, o) {
  var t = _ref18.id,
      r = _ref18.meta;
  var s = W();
  return Lc([e, "getOne", {
    id: String(t),
    meta: r
  }], function () {
    return s.getOne(e, {
      id: t,
      meta: r
    }).then(function (_ref19) {
      var a = _ref19.data;
      return a;
    });
  }, o);
}, "useGetOne");
import { useQuery as bc, useQueryClient as vc } from "react-query";
var Ve = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var m, f, x;
  var _t$pagination = t.pagination,
      o = _t$pagination === void 0 ? {
    page: 1,
    perPage: 25
  } : _t$pagination,
      _t$sort = t.sort,
      s = _t$sort === void 0 ? {
    field: "id",
    order: "DESC"
  } : _t$sort,
      _t$filter = t.filter,
      a = _t$filter === void 0 ? {} : _t$filter,
      i = t.meta,
      u = W(),
      c = vc(),
      p = bc([e, "getList", {
    pagination: o,
    sort: s,
    filter: a,
    meta: i
  }], function () {
    return u.getList(e, {
      pagination: o,
      sort: s,
      filter: a,
      meta: i
    }).then(function (_ref20) {
      var C = _ref20.data,
          b = _ref20.total,
          S = _ref20.pageInfo;
      return {
        data: C,
        total: b,
        pageInfo: S
      };
    });
  }, y({
    onSuccess: function onSuccess(_ref21) {
      var C = _ref21.data;
      C.forEach(function (b) {
        c.setQueryData([e, "getOne", {
          id: String(b.id),
          meta: i
        }], function (S) {
          return S != null ? S : b;
        });
      });
    }
  }, r));
  return p.data ? D(y({}, p), {
    data: (m = p.data) == null ? void 0 : m.data,
    total: (f = p.data) == null ? void 0 : f.total,
    pageInfo: (x = p.data) == null ? void 0 : x.pageInfo
  }) : p;
}, "useGetList");
import { useQuery as Ec, useQueryClient as Dc, hashQueryKey as wc } from "react-query";
var Uh = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var o = t.ids,
      s = t.meta,
      a = W(),
      i = Dc(),
      u = i.getQueryCache();
  return Ec([e, "getMany", {
    ids: o.map(function (c) {
      return String(c);
    }),
    meta: s
  }], function () {
    return !o || o.length === 0 ? Promise.resolve([]) : a.getMany(e, {
      ids: o,
      meta: s
    }).then(function (_ref22) {
      var c = _ref22.data;
      return c;
    });
  }, y({
    placeholderData: function placeholderData() {
      var c = o.map(function (p) {
        var f, x;
        var m = wc([e, "getOne", {
          id: String(p),
          meta: s
        }]);
        return (x = (f = u.get(m)) == null ? void 0 : f.state) == null ? void 0 : x.data;
      });
      if (!c.some(function (p) {
        return p === void 0;
      })) return c;
    },
    onSuccess: function onSuccess(c) {
      c.forEach(function (p) {
        i.setQueryData([e, "getOne", {
          id: String(p.id),
          meta: s
        }], function (m) {
          return m != null ? m : p;
        });
      });
    },
    retry: !1
  }, r));
}, "useGetMany");
import { useMemo as Ic } from "react";
import { useQueryClient as Ac, useQuery as Fc, hashQueryKey as Nc } from "react-query";
import Oc from "lodash/union";
var Ge = n(function (e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = W(),
      s = Ac(),
      a = s.getQueryCache(),
      i = t.ids,
      u = t.meta,
      c = Ic(function () {
    var p = i.map(function (m) {
      var x, C;
      var f = Nc([e, "getOne", {
        id: String(m),
        meta: u
      }]);
      return (C = (x = a.get(f)) == null ? void 0 : x.state) == null ? void 0 : C.data;
    });
    if (!p.some(function (m) {
      return m === void 0;
    })) return p;
  }, [i, a, e, u]);
  return Fc([e, "getMany", {
    ids: i.map(function (p) {
      return String(p);
    }),
    meta: u
  }], function () {
    return new Promise(function (p, m) {
      return !i || i.length === 0 ? p([]) : kc({
        resource: e,
        ids: i,
        meta: u,
        resolve: p,
        reject: m,
        dataProvider: o,
        queryClient: s
      });
    });
  }, y({
    placeholderData: c,
    onSuccess: function onSuccess(p) {
      p.forEach(function (m) {
        s.setQueryData([e, "getOne", {
          id: String(m.id),
          meta: u
        }], function (f) {
          return f != null ? f : m;
        });
      });
    },
    retry: !1
  }, r));
}, "useGetManyAggregate"),
    Uc = n(function (e) {
  var t = [],
      r = null;
  return function (o) {
    t.push(o), r && clearTimeout(r), r = setTimeout(function () {
      r = null, e(_toConsumableArray(t)), t = [];
    }, 0);
  };
}, "batch"),
    kc = Uc(function (e) {
  var t = e[0].dataProvider,
      r = e[0].queryClient,
      o = e.reduce(function (s, a) {
    return s[a.resource] || (s[a.resource] = []), s[a.resource].push(a), s;
  }, {});
  Object.keys(o).forEach(function (s) {
    var a = o[s],
        i = a.reduce(function (c, _ref23) {
      var p = _ref23.ids;
      return Oc(c, p);
    }, []).filter(function (c) {
      return c != null && c !== "";
    }),
        u = a.reduce(function (c, _ref24) {
      var p = _ref24.meta;
      return p || c;
    }, void 0);

    if (i.length === 0) {
      a.forEach(function (_ref25) {
        var c = _ref25.resolve;
        c([]);
      });
      return;
    }

    if (a.find(function (_ref26) {
      var c = _ref26.ids;
      return JSON.stringify(c) === JSON.stringify(i);
    })) {
      var _a$ = a[0],
          c = _a$.dataProvider,
          p = _a$.resource,
          m = _a$.ids,
          f = _a$.meta,
          x = _a$.resolve,
          C = _a$.reject;
      c.getMany(p, {
        ids: m,
        meta: f
      }).then(function (_ref27) {
        var b = _ref27.data;
        return b;
      }).then(x, C);
      return;
    }

    r.fetchQuery([s, "getMany", {
      ids: i.map(function (c) {
        return String(c);
      }),
      meta: u
    }], function () {
      return t.getMany(s, {
        ids: i,
        meta: u
      }).then(function (_ref28) {
        var c = _ref28.data;
        return c;
      });
    }).then(function (c) {
      a.forEach(function (_ref29) {
        var p = _ref29.ids,
            m = _ref29.resolve;
        m(c.filter(function (f) {
          return p.includes(f.id);
        }));
      });
    }).catch(function (c) {
      return a.forEach(function (_ref30) {
        var p = _ref30.reject;
        return p(c);
      });
    });
  });
});
import { useQuery as jc, useQueryClient as Vc } from "react-query";
var Qt = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var x, C, b;
  var o = t.target,
      s = t.id,
      _t$pagination2 = t.pagination,
      a = _t$pagination2 === void 0 ? {
    page: 1,
    perPage: 25
  } : _t$pagination2,
      _t$sort2 = t.sort,
      i = _t$sort2 === void 0 ? {
    field: "id",
    order: "DESC"
  } : _t$sort2,
      _t$filter2 = t.filter,
      u = _t$filter2 === void 0 ? {} : _t$filter2,
      c = t.meta,
      p = W(),
      m = Vc(),
      f = jc([e, "getManyReference", {
    target: o,
    id: s,
    pagination: a,
    sort: i,
    filter: u,
    meta: c
  }], function () {
    return p.getManyReference(e, {
      target: o,
      id: s,
      pagination: a,
      sort: i,
      filter: u,
      meta: c
    }).then(function (_ref31) {
      var S = _ref31.data,
          P = _ref31.total,
          g = _ref31.pageInfo;
      return {
        data: S,
        total: P,
        pageInfo: g
      };
    });
  }, y({
    onSuccess: function onSuccess(_ref32) {
      var S = _ref32.data;
      S.forEach(function (P) {
        m.setQueryData([e, "getOne", {
          id: String(P.id),
          meta: c
        }], function (g) {
          return g != null ? g : P;
        });
      });
    }
  }, r));
  return f.data ? D(y({}, f), {
    data: (x = f.data) == null ? void 0 : x.data,
    total: (C = f.data) == null ? void 0 : C.total,
    pageInfo: (b = f.data) == null ? void 0 : b.pageInfo
  }) : f;
}, "useGetManyReference");
import { useRef as Gc } from "react";
import { useMutation as Qc, useQueryClient as _c } from "react-query";
var jn = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var o = W(),
      s = _c(),
      a = Gc(t),
      i = Qc(function () {
    var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref33$resource = _ref33.resource,
        c = _ref33$resource === void 0 ? e : _ref33$resource,
        _ref33$data = _ref33.data,
        p = _ref33$data === void 0 ? a.current.data : _ref33$data,
        _ref33$meta = _ref33.meta,
        m = _ref33$meta === void 0 ? a.current.meta : _ref33$meta;

    return o.create(c, {
      data: p,
      meta: m
    }).then(function (_ref34) {
      var f = _ref34.data;
      return f;
    });
  }, D(y({}, r), {
    onSuccess: function onSuccess(c) {
      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var m = arguments.length > 2 ? arguments[2] : undefined;
      var _p$resource = p.resource,
          f = _p$resource === void 0 ? e : _p$resource;
      s.setQueryData([f, "getOne", {
        id: String(c.id)
      }], c), r.onSuccess && r.onSuccess(c, p, m);
    }
  }));

  return [n(function () {
    var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e;
    var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var m = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var C = m,
        f = C.returnPromise,
        x = F(C, ["returnPromise"]);
    if (f) return i.mutateAsync(y({
      resource: c
    }, p), m);
    i.mutate(y({
      resource: c
    }, p), x);
  }, "create"), i];
}, "useCreate");
import { useRef as qr } from "react";
import { useMutation as zc, useQueryClient as Hc } from "react-query";
var Vn = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = W(),
      s = Hc(),
      a = t.id,
      i = t.data,
      u = t.meta,
      P = r,
      _P$mutationMode = P.mutationMode,
      c = _P$mutationMode === void 0 ? "pessimistic" : _P$mutationMode,
      p = F(P, ["mutationMode"]),
      m = qr(c),
      f = qr(t),
      x = qr([]),
      C = n(function (_ref35) {
    var g = _ref35.resource,
        R = _ref35.id,
        M = _ref35.data;
    var T = Date.now(),
        h = m.current === "undoable" ? T + 5 * 1e3 : T,
        v = n(function (L) {
      if (!L) return;
      var E = L.findIndex(function (I) {
        return I.id == R;
      });
      return E === -1 ? L : [].concat(_toConsumableArray(L.slice(0, E)), [y(y({}, L[E]), M)], _toConsumableArray(L.slice(E + 1)));
    }, "updateColl");
    s.setQueryData([g, "getOne", {
      id: String(R),
      meta: u
    }], function (L) {
      return y(y({}, L), M);
    }, {
      updatedAt: h
    }), s.setQueriesData([g, "getList"], function (L) {
      return L && L.data ? {
        data: v(L.data),
        total: L.total
      } : L;
    }, {
      updatedAt: h
    }), s.setQueriesData([g, "getMany"], function (L) {
      return L && L.length > 0 ? v(L) : L;
    }, {
      updatedAt: h
    }), s.setQueriesData([g, "getManyReference"], function (L) {
      return L && L.data ? {
        data: v(L.data),
        total: L.total
      } : L;
    }, {
      updatedAt: h
    });
  }, "updateCache"),
      b = zc(function () {
    var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref36$resource = _ref36.resource,
        g = _ref36$resource === void 0 ? e : _ref36$resource,
        _ref36$id = _ref36.id,
        R = _ref36$id === void 0 ? f.current.id : _ref36$id,
        _ref36$data = _ref36.data,
        M = _ref36$data === void 0 ? f.current.data : _ref36$data,
        _ref36$meta = _ref36.meta,
        T = _ref36$meta === void 0 ? f.current.meta : _ref36$meta,
        _ref36$previousData = _ref36.previousData,
        h = _ref36$previousData === void 0 ? f.current.previousData : _ref36$previousData;

    return o.update(g, {
      id: R,
      data: M,
      previousData: h,
      meta: T
    }).then(function (_ref37) {
      var v = _ref37.data;
      return v;
    });
  }, D(y({}, p), {
    onMutate: function () {
      var _onMutate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(g) {
        var R;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!p.onMutate) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 3;
                return p.onMutate(g);

              case 3:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = {};

              case 6:
                R = _context3.t0;
                return _context3.abrupt("return", y({
                  snapshot: x.current
                }, R));

              case 10:
                return _context3.abrupt("return", {
                  snapshot: x.current
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function onMutate(_x2) {
        return _onMutate.apply(this, arguments);
      }

      return onMutate;
    }(),
    onError: function onError(g) {
      var R = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var M = arguments.length > 2 ? arguments[2] : undefined;
      if ((m.current === "optimistic" || m.current === "undoable") && M.snapshot.forEach(function (_ref38) {
        var _ref39 = _slicedToArray(_ref38, 2),
            T = _ref39[0],
            h = _ref39[1];

        s.setQueryData(T, h);
      }), p.onError) return p.onError(g, R, M);
    },
    onSuccess: function onSuccess(g) {
      var R = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var M = arguments.length > 2 ? arguments[2] : undefined;

      if (m.current === "pessimistic") {
        var _R$resource = R.resource,
            T = _R$resource === void 0 ? e : _R$resource,
            _R$id = R.id,
            h = _R$id === void 0 ? a : _R$id;
        C({
          resource: T,
          id: h,
          data: g
        }), p.onSuccess && p.onSuccess(g, R, M);
      }
    },
    onSettled: function onSettled(g, R) {
      var M = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var T = arguments.length > 3 ? arguments[3] : undefined;
      if ((m.current === "optimistic" || m.current === "undoable") && T.snapshot.forEach(function (_ref40) {
        var _ref41 = _slicedToArray(_ref40, 1),
            h = _ref41[0];

        s.invalidateQueries(h);
      }), p.onSettled) return p.onSettled(g, R, M, T);
    }
  }));
  return [n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var g,
        R,
        M,
        T,
        h,
        v,
        L,
        E,
        _R$id2,
        I,
        _R$data,
        N,
        _R$meta,
        A,
        w,
        O,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            g = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : e;
            R = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            M = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            T = M.mutationMode, h = M.returnPromise, v = M.onSuccess, L = M.onSettled, E = M.onError;

            if (!(f.current = t, T && (m.current = T), h && m.current !== "pessimistic" && console.warn("The returnPromise parameter can only be used if the mutationMode is set to pessimistic"), m.current === "pessimistic")) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", h ? b.mutateAsync(y({
              resource: g
            }, R), {
              onSuccess: v,
              onSettled: L,
              onError: E
            }) : b.mutate(y({
              resource: g
            }, R), {
              onSuccess: v,
              onSettled: L,
              onError: E
            }));

          case 6:
            _R$id2 = R.id, I = _R$id2 === void 0 ? a : _R$id2, _R$data = R.data, N = _R$data === void 0 ? i : _R$data, _R$meta = R.meta, A = _R$meta === void 0 ? u : _R$meta, w = s.getQueryData([g, "getOne", {
              id: String(I),
              meta: A
            }]), O = [[g, "getOne", {
              id: String(I),
              meta: A
            }], [g, "getList"], [g, "getMany"], [g, "getManyReference"]];
            x.current = O.reduce(function (k, $) {
              return k.concat(s.getQueriesData($));
            }, []);
            _context4.next = 10;
            return Promise.all(x.current.map(function (_ref43) {
              var _ref44 = _slicedToArray(_ref43, 1),
                  k = _ref44[0];

              return s.cancelQueries(k);
            }));

          case 10:
            C({
              resource: g,
              id: I,
              data: N
            });
            v && setTimeout(function () {
              return v(w, y({
                resource: g
              }, R), {
                snapshot: x.current
              });
            }, 0);
            p.onSuccess && setTimeout(function () {
              return p.onSuccess(w, y({
                resource: g
              }, R), {
                snapshot: x.current
              });
            }, 0);

            if (!(m.current === "optimistic")) {
              _context4.next = 15;
              break;
            }

            return _context4.abrupt("return", b.mutate(y({
              resource: g
            }, R), {
              onSettled: L,
              onError: E
            }));

          case 15:
            ge.once("end", function (_ref45) {
              var k = _ref45.isUndo;
              k ? x.current.forEach(function (_ref46) {
                var _ref47 = _slicedToArray(_ref46, 2),
                    $ = _ref47[0],
                    q = _ref47[1];

                s.setQueryData($, q);
              }) : b.mutate(y({
                resource: g
              }, R), {
                onSettled: L,
                onError: E
              });
            });

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), "update"), b];
}, "useUpdate");
import { useRef as Kr } from "react";
import { useMutation as Wc, useQueryClient as Yc } from "react-query";
var xx = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = W(),
      s = Yc(),
      a = t.ids,
      i = t.data,
      u = t.meta,
      P = r,
      _P$mutationMode2 = P.mutationMode,
      c = _P$mutationMode2 === void 0 ? "pessimistic" : _P$mutationMode2,
      p = F(P, ["mutationMode"]),
      m = Kr(c),
      f = Kr(t),
      x = Kr([]),
      C = n( /*#__PURE__*/function () {
    var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref48) {
      var g, R, M, T, h, v;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              g = _ref48.resource, R = _ref48.ids, M = _ref48.data, T = _ref48.meta;
              h = m.current === "undoable" ? Date.now() + 1e3 * 5 : Date.now(), v = n(function (L) {
                if (!L) return;

                var E = _toConsumableArray(L);

                return R.forEach(function (I) {
                  var N = L.findIndex(function (A) {
                    return A.id == I;
                  });
                  N !== -1 && (E = [].concat(_toConsumableArray(E.slice(0, N)), [y(y({}, E[N]), M)], _toConsumableArray(E.slice(N + 1))));
                }), E;
              }, "updateColl");
              R.forEach(function (L) {
                return s.setQueryData([g, "getOne", {
                  id: String(L),
                  meta: T
                }], function (E) {
                  return y(y({}, E), M);
                }, {
                  updatedAt: h
                });
              }), s.setQueriesData([g, "getList"], function (L) {
                return L && L.data ? {
                  data: v(L.data),
                  total: L.total
                } : L;
              }, {
                updatedAt: h
              }), s.setQueriesData([g, "getMany"], function (L) {
                return L && L.length > 0 ? v(L) : L;
              }, {
                updatedAt: h
              }), s.setQueriesData([g, "getManyReference"], function (L) {
                return L && L.data ? {
                  data: v(L.data),
                  total: L.total
                } : L;
              }, {
                updatedAt: h
              });

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x3) {
      return _ref49.apply(this, arguments);
    };
  }(), "updateCache"),
      b = Wc(function () {
    var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref50$resource = _ref50.resource,
        g = _ref50$resource === void 0 ? e : _ref50$resource,
        _ref50$ids = _ref50.ids,
        R = _ref50$ids === void 0 ? f.current.ids : _ref50$ids,
        _ref50$data = _ref50.data,
        M = _ref50$data === void 0 ? f.current.data : _ref50$data,
        _ref50$meta = _ref50.meta,
        T = _ref50$meta === void 0 ? f.current.meta : _ref50$meta;

    return o.updateMany(g, {
      ids: R,
      data: M,
      meta: T
    }).then(function (_ref51) {
      var h = _ref51.data;
      return h;
    });
  }, D(y({}, p), {
    onMutate: function () {
      var _onMutate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(g) {
        var R;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!p.onMutate) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 3;
                return p.onMutate(g);

              case 3:
                _context6.t0 = _context6.sent;

                if (_context6.t0) {
                  _context6.next = 6;
                  break;
                }

                _context6.t0 = {};

              case 6:
                R = _context6.t0;
                return _context6.abrupt("return", y({
                  snapshot: x.current
                }, R));

              case 10:
                return _context6.abrupt("return", {
                  snapshot: x.current
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function onMutate(_x4) {
        return _onMutate2.apply(this, arguments);
      }

      return onMutate;
    }(),
    onError: function onError(g) {
      var R = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var M = arguments.length > 2 ? arguments[2] : undefined;
      if ((m.current === "optimistic" || m.current === "undoable") && M.snapshot.forEach(function (_ref52) {
        var _ref53 = _slicedToArray(_ref52, 2),
            T = _ref53[0],
            h = _ref53[1];

        s.setQueryData(T, h);
      }), p.onError) return p.onError(g, R, M);
    },
    onSuccess: function onSuccess(g) {
      var R = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var M = arguments.length > 2 ? arguments[2] : undefined;

      if (m.current === "pessimistic") {
        var _R$resource2 = R.resource,
            T = _R$resource2 === void 0 ? e : _R$resource2,
            _R$ids = R.ids,
            h = _R$ids === void 0 ? a : _R$ids,
            _R$meta2 = R.meta,
            v = _R$meta2 === void 0 ? u : _R$meta2;
        C({
          resource: T,
          ids: h,
          data: g,
          meta: v
        }), p.onSuccess && p.onSuccess(g, R, M);
      }
    },
    onSettled: function onSettled(g, R) {
      var M = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var T = arguments.length > 3 ? arguments[3] : undefined;
      if ((m.current === "optimistic" || m.current === "undoable") && T.snapshot.forEach(function (_ref54) {
        var _ref55 = _slicedToArray(_ref54, 1),
            h = _ref55[0];

        s.invalidateQueries(h);
      }), p.onSettled) return p.onSettled(g, R, M, T);
    }
  }));
  return [n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var g,
        R,
        M,
        T,
        h,
        v,
        L,
        _R$ids2,
        E,
        _R$data2,
        I,
        _R$meta3,
        N,
        A,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            g = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : e;
            R = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            M = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
            T = M.mutationMode, h = M.onSuccess, v = M.onSettled, L = M.onError;

            if (!(f.current = t, T && (m.current = T), m.current === "pessimistic")) {
              _context7.next = 6;
              break;
            }

            return _context7.abrupt("return", b.mutate(y({
              resource: g
            }, R), {
              onSuccess: h,
              onSettled: v,
              onError: L
            }));

          case 6:
            _R$ids2 = R.ids, E = _R$ids2 === void 0 ? a : _R$ids2, _R$data2 = R.data, I = _R$data2 === void 0 ? i : _R$data2, _R$meta3 = R.meta, N = _R$meta3 === void 0 ? u : _R$meta3, A = [[g, "getOne"], [g, "getList"], [g, "getMany"], [g, "getManyReference"]];
            x.current = A.reduce(function (w, O) {
              return w.concat(s.getQueriesData(O));
            }, []);
            _context7.next = 10;
            return Promise.all(x.current.map(function (_ref57) {
              var _ref58 = _slicedToArray(_ref57, 1),
                  w = _ref58[0];

              return s.cancelQueries(w);
            }));

          case 10:
            _context7.next = 12;
            return C({
              resource: g,
              ids: E,
              data: I,
              meta: N
            });

          case 12:
            h && setTimeout(function () {
              return h(E, y({
                resource: g
              }, R), {
                snapshot: x.current
              });
            }, 0);
            p.onSuccess && setTimeout(function () {
              return p.onSuccess(E, y({
                resource: g
              }, R), {
                snapshot: x.current
              });
            }, 0);

            if (!(m.current === "optimistic")) {
              _context7.next = 16;
              break;
            }

            return _context7.abrupt("return", b.mutate(y({
              resource: g
            }, R), {
              onSettled: v,
              onError: L
            }));

          case 16:
            ge.once("end", function (_ref59) {
              var w = _ref59.isUndo;
              w ? x.current.forEach(function (_ref60) {
                var _ref61 = _slicedToArray(_ref60, 2),
                    O = _ref61[0],
                    k = _ref61[1];

                s.setQueryData(O, k);
              }) : b.mutate(y({
                resource: g
              }, R), {
                onSettled: v,
                onError: L
              });
            });

          case 17:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), "updateMany"), b];
}, "useUpdateMany");
import { useRef as Xr } from "react";
import { useMutation as Jc, useQueryClient as $c } from "react-query";

var _t = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = W(),
      s = $c(),
      a = t.id,
      i = t.previousData,
      S = r,
      _S$mutationMode = S.mutationMode,
      u = _S$mutationMode === void 0 ? "pessimistic" : _S$mutationMode,
      c = F(S, ["mutationMode"]),
      p = Xr(u),
      m = Xr(t),
      f = Xr([]),
      x = n(function (_ref62) {
    var P = _ref62.resource,
        g = _ref62.id;
    var R = Date.now(),
        M = p.current === "undoable" ? R + 5 * 1e3 : R,
        T = n(function (h) {
      if (!h) return;
      var v = h.findIndex(function (L) {
        return L.id == g;
      });
      return v === -1 ? h : [].concat(_toConsumableArray(h.slice(0, v)), _toConsumableArray(h.slice(v + 1)));
    }, "updateColl");
    s.setQueriesData([P, "getList"], function (h) {
      if (!h || !h.data) return h;
      var v = T(h.data);
      return v.length < h.data.length ? {
        data: v,
        total: h.total - 1
      } : h;
    }, {
      updatedAt: M
    }), s.setQueriesData([P, "getMany"], function (h) {
      return h && h.length > 0 ? T(h) : h;
    }, {
      updatedAt: M
    }), s.setQueriesData([P, "getManyReference"], function (h) {
      if (!h || !h.data) return h;
      var v = T(h.data);
      return v.length < h.data.length ? {
        data: v,
        total: h.total - 1
      } : h;
    }, {
      updatedAt: M
    });
  }, "updateCache"),
      C = Jc(function () {
    var _ref63 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref63$resource = _ref63.resource,
        P = _ref63$resource === void 0 ? e : _ref63$resource,
        _ref63$id = _ref63.id,
        g = _ref63$id === void 0 ? m.current.id : _ref63$id,
        _ref63$previousData = _ref63.previousData,
        R = _ref63$previousData === void 0 ? m.current.previousData : _ref63$previousData,
        _ref63$meta = _ref63.meta,
        M = _ref63$meta === void 0 ? m.current.meta : _ref63$meta;

    return o.delete(P, {
      id: g,
      previousData: R,
      meta: M
    }).then(function (_ref64) {
      var T = _ref64.data;
      return T;
    });
  }, D(y({}, c), {
    onMutate: function () {
      var _onMutate3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(P) {
        var g;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!c.onMutate) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 3;
                return c.onMutate(P);

              case 3:
                _context8.t0 = _context8.sent;

                if (_context8.t0) {
                  _context8.next = 6;
                  break;
                }

                _context8.t0 = {};

              case 6:
                g = _context8.t0;
                return _context8.abrupt("return", y({
                  snapshot: f.current
                }, g));

              case 10:
                return _context8.abrupt("return", {
                  snapshot: f.current
                });

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function onMutate(_x5) {
        return _onMutate3.apply(this, arguments);
      }

      return onMutate;
    }(),
    onError: function onError(P) {
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var R = arguments.length > 2 ? arguments[2] : undefined;
      if ((p.current === "optimistic" || p.current === "undoable") && R.snapshot.forEach(function (_ref65) {
        var _ref66 = _slicedToArray(_ref65, 2),
            M = _ref66[0],
            T = _ref66[1];

        s.setQueryData(M, T);
      }), c.onError) return c.onError(P, g, R);
    },
    onSuccess: function onSuccess(P) {
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var R = arguments.length > 2 ? arguments[2] : undefined;

      if (p.current === "pessimistic") {
        var _g$resource = g.resource,
            M = _g$resource === void 0 ? e : _g$resource,
            _g$id = g.id,
            T = _g$id === void 0 ? a : _g$id;
        x({
          resource: M,
          id: T
        }), c.onSuccess && c.onSuccess(P, g, R);
      }
    },
    onSettled: function onSettled(P, g) {
      var R = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var M = arguments.length > 3 ? arguments[3] : undefined;
      if ((p.current === "optimistic" || p.current === "undoable") && M.snapshot.forEach(function (_ref67) {
        var _ref68 = _slicedToArray(_ref67, 1),
            T = _ref68[0];

        s.invalidateQueries(T);
      }), c.onSettled) return c.onSettled(P, g, R, M);
    }
  }));
  return [n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var P,
        g,
        R,
        M,
        T,
        h,
        v,
        _g$id2,
        L,
        _g$previousData,
        E,
        I,
        _args9 = arguments;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            P = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : e;
            g = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
            R = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
            M = R.mutationMode, T = R.onSuccess, h = R.onSettled, v = R.onError;

            if (!(m.current = t, M && (p.current = M), p.current === "pessimistic")) {
              _context9.next = 6;
              break;
            }

            return _context9.abrupt("return", C.mutate(y({
              resource: P
            }, g), {
              onSuccess: T,
              onSettled: h,
              onError: v
            }));

          case 6:
            _g$id2 = g.id, L = _g$id2 === void 0 ? a : _g$id2, _g$previousData = g.previousData, E = _g$previousData === void 0 ? i : _g$previousData, I = [[P, "getList"], [P, "getMany"], [P, "getManyReference"]];
            f.current = I.reduce(function (N, A) {
              return N.concat(s.getQueriesData(A));
            }, []);
            _context9.next = 10;
            return Promise.all(f.current.map(function (_ref70) {
              var _ref71 = _slicedToArray(_ref70, 1),
                  N = _ref71[0];

              return s.cancelQueries(N);
            }));

          case 10:
            x({
              resource: P,
              id: L
            });
            T && setTimeout(function () {
              return T(E, y({
                resource: P
              }, g), {
                snapshot: f.current
              });
            }, 0);
            c.onSuccess && setTimeout(function () {
              return c.onSuccess(E, y({
                resource: P
              }, g), {
                snapshot: f.current
              });
            }, 0);

            if (!(p.current === "optimistic")) {
              _context9.next = 15;
              break;
            }

            return _context9.abrupt("return", C.mutate(y({
              resource: P
            }, g), {
              onSettled: h,
              onError: v
            }));

          case 15:
            ge.once("end", function (_ref72) {
              var N = _ref72.isUndo;
              N ? f.current.forEach(function (_ref73) {
                var _ref74 = _slicedToArray(_ref73, 2),
                    A = _ref74[0],
                    w = _ref74[1];

                s.setQueryData(A, w);
              }) : C.mutate(y({
                resource: P
              }, g), {
                onSettled: h,
                onError: v
              });
            });

          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })), "mutate"), C];
}, "useDelete");

import { useRef as eo } from "react";
import { useMutation as Zc, useQueryClient as Bc } from "react-query";
var Vx = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = W(),
      s = Bc(),
      a = t.ids,
      b = r,
      _b$mutationMode = b.mutationMode,
      i = _b$mutationMode === void 0 ? "pessimistic" : _b$mutationMode,
      u = F(b, ["mutationMode"]),
      c = eo(i),
      p = eo({}),
      m = eo([]),
      f = n(function (_ref75) {
    var S = _ref75.resource,
        P = _ref75.ids;
    var g = Date.now(),
        R = c.current === "undoable" ? g + 5 * 1e3 : g,
        M = n(function (T) {
      if (!T) return;

      var h = _toConsumableArray(T);

      return P.forEach(function (v) {
        var L = h.findIndex(function (E) {
          return E.id == v;
        });
        L !== -1 && (h = [].concat(_toConsumableArray(h.slice(0, L)), _toConsumableArray(h.slice(L + 1))));
      }), h;
    }, "updateColl");
    s.setQueriesData([S, "getList"], function (T) {
      if (!T || !T.data) return T;
      var h = M(T.data);
      return h.length < T.data.length ? {
        data: h,
        total: T.total - (T.data.length - h.length)
      } : T;
    }, {
      updatedAt: R
    }), s.setQueriesData([S, "getMany"], function (T) {
      return T && T.length > 0 ? M(T) : T;
    }, {
      updatedAt: R
    }), s.setQueriesData([S, "getManyReference"], function (T) {
      if (!T || !T.data) return T;
      var h = M(T.data);
      return h.length < T.data.length ? {
        data: h,
        total: T.total - (T.data.length - h.length)
      } : T;
    }, {
      updatedAt: R
    });
  }, "updateCache"),
      x = Zc(function () {
    var _ref76 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref76$resource = _ref76.resource,
        S = _ref76$resource === void 0 ? e : _ref76$resource,
        _ref76$ids = _ref76.ids,
        P = _ref76$ids === void 0 ? p.current.ids : _ref76$ids,
        _ref76$meta = _ref76.meta,
        g = _ref76$meta === void 0 ? p.current.meta : _ref76$meta;

    return o.deleteMany(S, {
      ids: P,
      meta: g
    }).then(function (_ref77) {
      var R = _ref77.data;
      return R;
    });
  }, D(y({}, u), {
    onMutate: function () {
      var _onMutate4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(S) {
        var P;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!u.onMutate) {
                  _context10.next = 10;
                  break;
                }

                _context10.next = 3;
                return u.onMutate(S);

              case 3:
                _context10.t0 = _context10.sent;

                if (_context10.t0) {
                  _context10.next = 6;
                  break;
                }

                _context10.t0 = {};

              case 6:
                P = _context10.t0;
                return _context10.abrupt("return", y({
                  snapshot: m.current
                }, P));

              case 10:
                return _context10.abrupt("return", {
                  snapshot: m.current
                });

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function onMutate(_x6) {
        return _onMutate4.apply(this, arguments);
      }

      return onMutate;
    }(),
    onError: function onError(S) {
      var P = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var g = arguments.length > 2 ? arguments[2] : undefined;
      if ((c.current === "optimistic" || c.current === "undoable") && g.snapshot.forEach(function (_ref78) {
        var _ref79 = _slicedToArray(_ref78, 2),
            R = _ref79[0],
            M = _ref79[1];

        s.setQueryData(R, M);
      }), u.onError) return u.onError(S, P, g);
    },
    onSuccess: function onSuccess(S) {
      var P = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var g = arguments.length > 2 ? arguments[2] : undefined;

      if (c.current === "pessimistic") {
        var _P$resource = P.resource,
            R = _P$resource === void 0 ? e : _P$resource,
            _P$ids = P.ids,
            M = _P$ids === void 0 ? a : _P$ids;
        f({
          resource: R,
          ids: M
        }), u.onSuccess && u.onSuccess(S, P, g);
      }
    },
    onSettled: function onSettled(S, P) {
      var g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var R = arguments.length > 3 ? arguments[3] : undefined;
      if ((c.current === "optimistic" || c.current === "undoable") && R.snapshot.forEach(function (_ref80) {
        var _ref81 = _slicedToArray(_ref80, 1),
            M = _ref81[0];

        s.invalidateQueries(M);
      }), u.onSettled) return u.onSettled(S, P, g, R);
    }
  }));
  return [n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var S,
        P,
        g,
        R,
        M,
        T,
        h,
        _P$ids2,
        v,
        L,
        _args11 = arguments;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            S = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : e;
            P = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
            g = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
            R = g.mutationMode, M = g.onSuccess, T = g.onSettled, h = g.onError;

            if (!(p.current = t, R && (c.current = R), c.current === "pessimistic")) {
              _context11.next = 6;
              break;
            }

            return _context11.abrupt("return", x.mutate(y({
              resource: S
            }, P), {
              onSuccess: M,
              onSettled: T,
              onError: h
            }));

          case 6:
            _P$ids2 = P.ids, v = _P$ids2 === void 0 ? a : _P$ids2, L = [[S, "getList"], [S, "getMany"], [S, "getManyReference"]];
            m.current = L.reduce(function (E, I) {
              return E.concat(s.getQueriesData(I));
            }, []);
            _context11.next = 10;
            return Promise.all(m.current.map(function (_ref83) {
              var _ref84 = _slicedToArray(_ref83, 1),
                  E = _ref84[0];

              return s.cancelQueries(E);
            }));

          case 10:
            f({
              resource: S,
              ids: v
            });
            M && setTimeout(function () {
              return M(v, y({
                resource: S
              }, P), {
                snapshot: m.current
              });
            }, 0);
            u.onSuccess && setTimeout(function () {
              return u.onSuccess(v, y({
                resource: S
              }, P), {
                snapshot: m.current
              });
            }, 0);

            if (!(c.current === "optimistic")) {
              _context11.next = 15;
              break;
            }

            return _context11.abrupt("return", x.mutate(y({
              resource: S
            }, P), {
              onSettled: T,
              onError: h
            }));

          case 15:
            ge.once("end", function (_ref85) {
              var E = _ref85.isUndo;
              E ? m.current.forEach(function (_ref86) {
                var _ref87 = _slicedToArray(_ref86, 2),
                    I = _ref87[0],
                    N = _ref87[1];

                s.setQueryData(I, N);
              }) : x.mutate(y({
                resource: S
              }, P), {
                onSettled: T,
                onError: h
              });
            });

          case 16:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  })), "mutate"), x];
}, "useDeleteMany");
import * as Gn from "react";
import { createContext as qc, useCallback as Qn, useState as Kc, useMemo as Xc } from "react";
import eu from "lodash/isEqual";

var to = qc({
  definitions: {},
  register: function register() {},
  unregister: function unregister() {}
}),
    _n = n(function (_ref88) {
  var _ref88$definitions = _ref88.definitions,
      e = _ref88$definitions === void 0 ? {} : _ref88$definitions,
      t = _ref88.children;

  var _Kc = Kc(e),
      _Kc2 = _slicedToArray(_Kc, 2),
      r = _Kc2[0],
      o = _Kc2[1],
      s = Qn(function (u) {
    o(function (c) {
      return eu(c[u.name], u) ? c : D(y({}, c), _defineProperty({}, u.name, u));
    });
  }, []),
      a = Qn(function (u) {
    o(function (c) {
      var f;
      var x = c,
          p = x[f = u.name];
      return F(x, [Pe(f)]);
    });
  }, []),
      i = Xc(function () {
    return {
      definitions: r,
      register: s,
      unregister: a
    };
  }, [r]);

  return Gn.createElement(to.Provider, {
    value: i
  }, t);
}, "ResourceDefinitionContextProvider");

var oo = n(function (e) {
  var t = e.authProvider,
      r = e.basename,
      o = e.dataProvider,
      s = e.i18nProvider,
      a = e.store,
      i = e.children,
      u = e.history,
      c = e.queryClient;
  if (!o) throw new Error("Missing dataProvider prop.\nReact-admin requires a valid dataProvider function to work.");
  var p = ro(function () {
    return c || new ru();
  }, [c]),
      m = ro(function () {
    return t instanceof Function ? jr(t) : t;
  }, [t]),
      f = ro(function () {
    return o instanceof Function ? Zr(o) : o;
  }, [o]);
  return Re.createElement(Ye.Provider, {
    value: m
  }, Re.createElement(Ke.Provider, {
    value: f
  }, Re.createElement(Zo, {
    value: a
  }, Re.createElement(tu, {
    client: p
  }, Re.createElement(zo, {
    history: u,
    basename: r
  }, Re.createElement(Ft, {
    value: s
  }, Re.createElement(qo, null, Re.createElement(_n, null, i))))))));
}, "CoreAdminContext");
oo.defaultProps = {
  dataProvider: je,
  store: Et()
};
import * as Te from "react";
import { useEffect as Ru, isValidElement as Pu, createElement as hu } from "react";
import { Routes as xu, Route as Jn } from "react-router-dom";
import * as J from "react";
import { useState as pu, useEffect as mu, Children as fu } from "react";
import { Navigate as yu, Route as Qe, Routes as no } from "react-router-dom";
import * as zn from "react";
import { Children as nu, Fragment as su, useCallback as au, useEffect as Hn, useState as iu } from "react";
import { useContext as ou } from "react";
var zt = n(function () {
  return ou(to);
}, "useResourceDefinitionContext");
var Wn = n(function (e) {
  var _Fr = Fr(),
      t = _Fr.permissions,
      _cu = cu(e, t),
      _cu2 = _slicedToArray(_cu, 2),
      r = _cu2[0],
      o = _cu2[1];

  return lu(r.resources, t), {
    customRoutesWithLayout: r.customRoutesWithLayout,
    customRoutesWithoutLayout: r.customRoutesWithoutLayout,
    status: o,
    resources: r.resources
  };
}, "useConfigureAdminRouterFromChildren"),
    cu = n(function (e, t) {
  var r = Ee(),
      _Ar = Ar(),
      o = _Ar.authenticated,
      _uu = uu(tt(e)),
      _uu2 = _slicedToArray(_uu, 3),
      s = _uu2[0],
      a = _uu2[1],
      i = _uu2[2],
      _z11 = z(function () {
    return du(y({
      children: e
    }, s));
  }),
      _z12 = _slicedToArray(_z11, 2),
      u = _z12[0],
      c = _z12[1];

  return Hn(function () {
    var p = n( /*#__PURE__*/function () {
      var _ref89 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(f) {
        var x;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                try {
                  x = f(t);
                  x.then ? x.then(function (C) {
                    i(tt(C)), c("ready");
                  }) : (i(tt(x)), c("ready"));
                } catch (x) {
                  console.error(x), r();
                }

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x7) {
        return _ref89.apply(this, arguments);
      };
    }(), "resolveChildFunction");
    n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var f, x;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              f = Yn(e), x = tt(e);
              a(x), c(f ? "loading" : x.resources.length > 0 ? "ready" : "empty"), f && p(f);

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    })), "updateFromChildren")();
  }, [o, e, r, i, t, a, c]), [s, u];
}, "useRoutesAndResourcesFromChildren"),
    uu = n(function (e) {
  var _iu = iu(e),
      _iu2 = _slicedToArray(_iu, 2),
      t = _iu2[0],
      r = _iu2[1],
      o = au(function (s) {
    r(function (a) {
      return {
        customRoutesWithLayout: a.customRoutesWithLayout.concat(s.customRoutesWithLayout),
        customRoutesWithoutLayout: a.customRoutesWithoutLayout.concat(s.customRoutesWithoutLayout),
        resources: a.resources.concat(s.resources)
      };
    });
  }, []);

  return [t, r, o];
}, "useRoutesAndResourcesState"),
    lu = n(function (e, t) {
  var _zt = zt(),
      r = _zt.register,
      o = _zt.unregister;

  Hn(function () {
    return e.forEach(function (s) {
      if (typeof s.type.registerResource == "function") {
        var a = s.type.registerResource(s.props, t);
        r(a);
      } else throw new Error("When using a custom Resource element, it must have a static registerResource method accepting its props and returning a ResourceDefinition");
    }), function () {
      e.forEach(function (s) {
        if (typeof s.type.registerResource == "function") {
          var a = s.type.registerResource(s.props, t);
          o(a);
        } else throw new Error("When using a custom Resource element, it must have a static registerResource method accepting its props and returning a ResourceDefinition");
      });
    };
  }, [t, r, e, o]);
}, "useRegisterResources"),
    du = n(function (_ref91) {
  var e = _ref91.children,
      t = _ref91.resources,
      r = _ref91.customRoutesWithLayout,
      o = _ref91.customRoutesWithoutLayout;
  return Yn(e) ? "loading" : t.length > 0 || r.length > 0 || o.length > 0 ? "ready" : "empty";
}, "getStatus"),
    Yn = n(function (e) {
  var r = (Array.isArray(e) ? e : [e]).filter(function (o) {
    return typeof o == "function";
  });
  if (r.length > 1) throw new Error("You can only provide one function child to AdminRouter");
  return r.length === 0 ? null : r[0];
}, "getSingleChildFunction"),
    tt = n(function (e) {
  var t = [],
      r = [],
      o = [];
  return nu.forEach(e, function (s) {
    if (!!zn.isValidElement(s)) {
      if (s.type === su) {
        var a = tt(s.props.children);
        t.push.apply(t, _toConsumableArray(a.customRoutesWithLayout)), r.push.apply(r, _toConsumableArray(a.customRoutesWithoutLayout)), o.push.apply(o, _toConsumableArray(a.resources));
      }

      if (s.type.raName === "CustomRoutes") {
        var _a2 = s;
        _a2.props.noLayout ? r.push(_a2.props.children) : t.push(_a2.props.children);
      } else s.type.raName === "Resource" && o.push(s);
    }
  }), {
    customRoutesWithLayout: t,
    customRoutesWithoutLayout: r,
    resources: o
  };
}, "getRoutesAndResourceFromNodes");
var so = n(function (e) {
  var t = pn(1e3);
  Ho();

  var r = bt(),
      _Wn = Wn(e.children),
      o = _Wn.customRoutesWithLayout,
      s = _Wn.customRoutesWithoutLayout,
      a = _Wn.status,
      i = _Wn.resources,
      u = e.layout,
      c = e.catchAll,
      p = e.dashboard,
      m = e.loading,
      f = e.menu,
      x = e.requireAuth,
      C = e.ready,
      b = e.title,
      _pu = pu(!x),
      _pu2 = _slicedToArray(_pu, 2),
      S = _pu2[0],
      P = _pu2[1],
      g = ke();

  return mu(function () {
    x && g().then(function () {
      P(!0);
    }).catch(function () {});
  }, [g, x]), a === "empty" ? J.createElement(C, null) : a === "loading" || !S ? J.createElement(no, null, s, t ? J.createElement(Qe, {
    path: "*",
    element: J.createElement(m, null)
  }) : J.createElement(Qe, {
    path: "*",
    element: null
  })) : J.createElement(no, null, s, J.createElement(Qe, {
    path: "/*",
    element: J.createElement("div", null, J.createElement(u, {
      dashboard: p,
      menu: f,
      title: b
    }, J.createElement(no, null, o, fu.map(i, function (R) {
      return J.createElement(Qe, {
        key: R.props.name,
        path: "".concat(R.props.name, "/*"),
        element: R
      });
    }), J.createElement(Qe, {
      path: "/",
      element: p ? J.createElement(Or, {
        authParams: gu,
        component: p
      }) : i.length > 0 ? J.createElement(yu, {
        to: r({
          resource: i[0].props.name,
          type: "list"
        })
      }) : null
    }), J.createElement(Qe, {
      path: "*",
      element: J.createElement(c, {
        title: b
      })
    }))))
  }));
}, "CoreAdminRoutes");
so.defaultProps = {
  customRoutes: []
};
var gu = {
  route: "dashboard"
};
var Cu = n(function (_ref92) {
  var e = _ref92.children;
  return Te.createElement(Te.Fragment, null, e);
}, "DefaultLayout"),
    $n = n(function (e) {
  var _e$catchAll = e.catchAll,
      t = _e$catchAll === void 0 ? Zn : _e$catchAll,
      r = e.children,
      o = e.dashboard,
      _e$disableTelemetry = e.disableTelemetry,
      s = _e$disableTelemetry === void 0 ? !1 : _e$disableTelemetry,
      _e$layout = e.layout,
      a = _e$layout === void 0 ? Cu : _e$layout,
      _e$loading = e.loading,
      i = _e$loading === void 0 ? Zn : _e$loading,
      _e$loginPage = e.loginPage,
      u = _e$loginPage === void 0 ? !1 : _e$loginPage,
      c = e.menu,
      _e$ready = e.ready,
      p = _e$ready === void 0 ? Ir : _e$ready,
      _e$title = e.title,
      m = _e$title === void 0 ? "React Admin" : _e$title,
      _e$requireAuth = e.requireAuth,
      f = _e$requireAuth === void 0 ? !1 : _e$requireAuth;
  return Ru(function () {
    if (s || process.env.NODE_ENV !== "production" || typeof window == "undefined" || typeof window.location == "undefined" || typeof Image == "undefined") return;
    var x = new Image();
    x.src = "https://react-admin-telemetry.marmelab.com/react-admin-telemetry?domain=".concat(window.location.hostname);
  }, [s]), Te.createElement(xu, null, u !== !1 && u !== !0 ? Te.createElement(Jn, {
    path: "/login",
    element: Tu(u)
  }) : null, Te.createElement(Jn, {
    path: "/*",
    element: Te.createElement(so, {
      catchAll: t,
      dashboard: o,
      layout: a,
      loading: i,
      menu: c,
      requireAuth: f,
      ready: p,
      title: m
    }, r)
  }));
}, "CoreAdminUI"),
    Tu = n(function (e) {
  return Pu(e) ? e : hu(e);
}, "createOrGetElement"),
    Zn = n(function () {
  return null;
}, "Noop");
var eT = n(function (e) {
  var t = e.authProvider,
      r = e.basename,
      o = e.catchAll,
      s = e.children,
      a = e.dashboard,
      i = e.dataProvider,
      u = e.disableTelemetry,
      c = e.history,
      p = e.i18nProvider,
      m = e.queryClient,
      f = e.layout,
      x = e.loading,
      C = e.loginPage,
      b = e.menu,
      S = e.ready,
      P = e.requireAuth,
      _e$title2 = e.title,
      g = _e$title2 === void 0 ? "React Admin" : _e$title2;
  return ao.createElement(oo, {
    authProvider: t,
    basename: r,
    dataProvider: i,
    i18nProvider: p,
    queryClient: m,
    history: c
  }, ao.createElement($n, {
    layout: f,
    dashboard: a,
    disableTelemetry: u,
    menu: b,
    catchAll: o,
    title: g,
    loading: x,
    loginPage: C,
    requireAuth: P,
    ready: S
  }, s));
}, "CoreAdmin");
var Su = n(function (e) {
  return null;
}, "CustomRoutes");
Su.raName = "CustomRoutes";
import * as ne from "react";
import { isValidElement as Ht } from "react";
import { Route as Wt, Routes as Mu } from "react-router-dom";
import * as Bn from "react";
var de = n(function (_ref93) {
  var e = _ref93.children,
      t = _ref93.value;
  return t ? Bn.createElement(Ut.Provider, {
    value: t
  }, e) : e;
}, "ResourceContextProvider");
var qn = n(function (e) {
  var t = e.create,
      r = e.edit,
      o = e.list,
      s = e.name,
      a = e.show;
  return ne.createElement(de, {
    value: s
  }, ne.createElement(Mu, null, t && ne.createElement(Wt, {
    path: "create/*",
    element: Ht(t) ? t : ne.createElement(t, null)
  }), a && ne.createElement(Wt, {
    path: ":id/show/*",
    element: Ht(a) ? a : ne.createElement(a, null)
  }), r && ne.createElement(Wt, {
    path: ":id/*",
    element: Ht(r) ? r : ne.createElement(r, null)
  }), o && ne.createElement(Wt, {
    path: "/*",
    element: Ht(o) ? o : ne.createElement(o, null)
  })));
}, "Resource");
qn.raName = "Resource";

qn.registerResource = function (_ref94) {
  var e = _ref94.create,
      t = _ref94.edit,
      r = _ref94.icon,
      o = _ref94.list,
      s = _ref94.name,
      a = _ref94.options,
      i = _ref94.show;
  return {
    name: s,
    options: a,
    hasList: !!o,
    hasCreate: !!e,
    hasEdit: !!t,
    hasShow: !!i,
    icon: r
  };
};

import io from "inflection";
var Yt = n(function () {
  return zt().definitions;
}, "useResourceDefinitions");
var Se = n(function () {
  var e = Q(),
      t = Yt();
  return function (r) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var s = t[r];
    return e("resources.".concat(r, ".name"), {
      smart_count: o,
      _: s && s.options && s.options.label ? e(s.options.label, {
        smart_count: o,
        _: s.options.label
      }) : io.humanize(o > 1 ? io.pluralize(r) : io.singularize(r))
    });
  };
}, "useGetResourceLabel");
import { useMemo as Lu } from "react";
import bu from "lodash/defaults";
var Kn = n(function (e) {
  var t = H(e),
      r = Yt(),
      _ref95 = e || {},
      o = _ref95.hasCreate,
      s = _ref95.hasEdit,
      a = _ref95.hasList,
      i = _ref95.hasShow;

  return Lu(function () {
    return bu({}, {
      hasCreate: o,
      hasEdit: s,
      hasList: a,
      hasShow: i
    }, r[t]);
  }, [t, r, o, s, a, i]);
}, "useResourceDefinition");
import vu from "jsonexport/dist";
var co = n(function (e, t) {
  var r = document.createElement("a");
  r.style.display = "none", document.body.appendChild(r);
  var o = new Blob([e], {
    type: "text/csv;charset=utf-8"
  });
  window.navigator && window.navigator.msSaveOrOpenBlob ? window.navigator.msSaveOrOpenBlob(o, "".concat(t, ".csv")) : (r.setAttribute("href", URL.createObjectURL(o)), r.setAttribute("download", "".concat(t, ".csv")), r.click());
}, "default");
var Eu = n(function (e, t, r, o) {
  return vu(e, function (s, a) {
    return co(a, o);
  });
}, "defaultExporter"),
    rt = Eu;
import { createContext as Du } from "react";
var Xn = Du(rt);
Xn.displayName = "ExporterContext";
var wu = Xn;
var Iu = n(function (e) {
  return function (t, r, o) {
    return e.getMany(o, {
      ids: Au(t, r)
    }).then(function (_ref96) {
      var s = _ref96.data;
      return s.reduce(function (a, i) {
        return a[i.id] = i, a;
      }, {});
    });
  };
}, "fetchRelatedRecords"),
    Au = n(function (e, t) {
  return Array.from(new Set(e.filter(function (r) {
    return r[t] != null;
  }).map(function (r) {
    return r[t];
  }).reduce(function (r, o) {
    return r.concat(o);
  }, [])));
}, "getRelatedIds"),
    Fu = Iu;
import * as ss from "react";
import er from "inflection";
var De = n(function (e) {
  return e.reduce(function (t, r) {
    return Object.keys(r).forEach(function (o) {
      if (t[o] || (t[o] = []), r[o] != null) {
        var s = Array.isArray(r[o]) ? [r[o]] : r[o];
        t[o] = t[o].concat(s);
      }
    }), t;
  }, {});
}, "default");
import { createElement as es } from "react";

var uo = /*#__PURE__*/function () {
  function uo(t, r, o) {
    _classCallCheck(this, uo);

    this.type = t;
    this.props = r;
    this.children = o;
  }

  _createClass(uo, [{
    key: "getElement",
    value: function getElement() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!!this.isDefined()) return this.children ? es(this.type.component, y(y({}, this.props), t), this.children.length > 0 ? this.children.map(function (r, o) {
        return r.getElement({
          key: o
        });
      }) : this.children.getElement()) : es(this.type.component, y(y({}, this.props), t));
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return this.props;
    }
  }, {
    key: "isDefined",
    value: function isDefined() {
      return !!this.type;
    }
  }, {
    key: "getRepresentation",
    value: function getRepresentation() {
      if (!!this.isDefined()) return this.type.representation ? this.type.representation(this.props, this.children) : "<".concat(this.type.component.displayName || this.type.component.name, " source=\"").concat(this.props.source, "\" />");
    }
  }]);

  return uo;
}();

n(uo, "InferredElement");
var _ = uo;
import { isMatch as ts, isValid as Nu, parseISO as Ou } from "date-fns";
var Uu = n(function (e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}, "isNumeric"),
    ot = n(function (e) {
  return e.every(Uu);
}, "valuesAreNumeric"),
    ku = n(function (e) {
  return Number.isInteger(e) || !isNaN(parseInt(e));
}, "isInteger"),
    nt = n(function (e) {
  return e.every(ku);
}, "valuesAreInteger"),
    ju = n(function (e) {
  return typeof e == "boolean";
}, "isBoolean"),
    Jt = n(function (e) {
  return e.every(ju);
}, "valuesAreBoolean");
var Vu = n(function (e) {
  return typeof e == "string";
}, "isString"),
    $t = n(function (e) {
  return e.every(Vu);
}, "valuesAreString"),
    Gu = /<([A-Z][A-Z0-9]*)\b[^>]*>(.*?)<\/\1>/i,
    Qu = n(function (e) {
  return !e || Gu.test(e);
}, "isHtml"),
    Zt = n(function (e) {
  return e.every(Qu);
}, "valuesAreHtml"),
    _u = /http(s*):\/\/.*/i,
    zu = n(function (e) {
  return !e || _u.test(e);
}, "isUrl"),
    rs = n(function (e) {
  return e.every(zu);
}, "valuesAreUrl"),
    Hu = /http(s*):\/\/.*\.(jpeg|jpg|jfif|pjpeg|pjp|png|svg|gif|webp|apng|bmp|ico|cur|tif|tiff)/i,
    Wu = n(function (e) {
  return !e || Hu.test(e);
}, "isImageUrl"),
    os = n(function (e) {
  return e.every(Wu);
}, "valuesAreImageUrl"),
    Yu = /@{1}/,
    Ju = n(function (e) {
  return !e || Yu.test(e);
}, "isEmail"),
    ns = n(function (e) {
  return e.every(Ju);
}, "valuesAreEmail"),
    $u = n(function (e) {
  return Array.isArray(e);
}, "isArray"),
    Bt = n(function (e) {
  return e.every($u);
}, "valuesAreArray"),
    Zu = n(function (e) {
  return !e || e instanceof Date;
}, "isDate"),
    qt = n(function (e) {
  return e.every(Zu);
}, "valuesAreDate"),
    Bu = n(function (e) {
  return !e || typeof e == "string" && (ts(e, "MM/dd/yyyy") || ts(e, "MM/dd/yy") || Nu(Ou(e)));
}, "isDateString"),
    Kt = n(function (e) {
  return e.every(Bu);
}, "valuesAreDateString"),
    st = n(function (e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}, "isObject"),
    Xt = n(function (e) {
  return e.every(st);
}, "valuesAreObject");
var qu = n(function () {
  return ss.createElement("span", null, ";");
}, "DefaultComponent"),
    se = {
  type: qu,
  representation: function representation() {
    return "<DefaultComponent />";
  }
},
    Ku = {
  array: se,
  boolean: se,
  date: se,
  email: se,
  id: se,
  number: se,
  reference: se,
  referenceArray: se,
  richText: se,
  string: se,
  url: se
},
    te = n(function (e, t) {
  return typeof t[e] != "undefined";
}, "hasType"),
    lo = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Ku;
  if (e === "id" && te("id", r)) return new _(r.id, {
    source: e
  });

  if (e.substr(e.length - 3) === "_id" && te("reference", r)) {
    var o = er.pluralize(e.substr(0, e.length - 3));
    return r.reference && new _(r.reference, {
      source: e,
      reference: o
    }, new _(r.referenceChild));
  }

  if (e.substr(e.length - 2) === "Id" && te("reference", r)) {
    var _o2 = er.pluralize(e.substr(0, e.length - 2));

    return r.reference && new _(r.reference, {
      source: e,
      reference: _o2
    }, new _(r.referenceChild));
  }

  if (e.substr(e.length - 4) === "_ids" && te("referenceArray", r)) {
    var _o3 = er.pluralize(e.substr(0, e.length - 4));

    return r.referenceArray && new _(r.referenceArray, {
      source: e,
      reference: _o3
    }, new _(r.referenceArrayChild));
  }

  if (e.substr(e.length - 3) === "Ids" && te("referenceArray", r)) {
    var _o4 = er.pluralize(e.substr(0, e.length - 3));

    return r.referenceArray && new _(r.referenceArray, {
      source: e,
      reference: _o4
    }, new _(r.referenceArrayChild));
  }

  if (t.length === 0) return new _(r.string, {
    source: e
  });

  if (Bt(t)) {
    if (st(t[0][0]) && te("array", r)) {
      var _o5 = De(t.reduce(function (s, a) {
        return s.concat(a);
      }, []));

      return r.array && new _(r.array, {
        source: e
      }, Object.keys(_o5).map(function (s) {
        return lo(s, _o5[s], r);
      }));
    }

    return new _(r.string, {
      source: e
    });
  }

  if (Jt(t) && te("boolean", r)) return new _(r.boolean, {
    source: e
  });
  if (qt(t) && te("date", r)) return new _(r.date, {
    source: e
  });
  if ($t(t)) return e === "email" && te("email", r) ? new _(r.email, {
    source: e
  }) : e === "url" && te("url", r) ? new _(r.url, {
    source: e
  }) : Kt(t) && te("date", r) ? new _(r.date, {
    source: e
  }) : Zt(t) && te("richText", r) ? new _(r.richText, {
    source: e
  }) : new _(r.string, {
    source: e
  });
  if ((nt(t) || ot(t)) && te("number", r)) return new _(r.number, {
    source: e
  });

  if (Xt(t)) {
    var _o6 = Object.keys(t[0]).shift(),
        s = t.map(function (a) {
      return a[_o6];
    });

    return lo("".concat(e, ".").concat(_o6), s, r);
  }

  return new _(r.string, {
    source: e
  });
}, "inferElementFromValues"),
    as = lo;
var Xu = n(function (e, t) {
  var r = De(e);
  return Object.keys(r).reduce(function (o, s) {
    return o.concat(as(s, r[s], t));
  }, []).filter(function (o) {
    return o.isDefined();
  });
}, "default");
import tr from "inflection";
var BT = ["array", "boolean", "date", "email", "id", "image", "number", "reference", "referenceChild", "referenceArray", "referenceArrayChild", "richText", "string", "url", "object"],
    is = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (e === "id") return {
    type: "id",
    props: {
      source: e
    }
  };
  if (e.substr(e.length - 3) === "_id") return {
    type: "reference",
    props: {
      source: e,
      reference: tr.pluralize(e.substr(0, e.length - 3))
    },
    children: {
      type: "referenceChild"
    }
  };
  if (e.substr(e.length - 2) === "Id") return {
    type: "reference",
    props: {
      source: e,
      reference: tr.pluralize(e.substr(0, e.length - 2))
    },
    children: {
      type: "referenceChild"
    }
  };
  if (e.substr(e.length - 4) === "_ids") return {
    type: "referenceArray",
    props: {
      source: e,
      reference: tr.pluralize(e.substr(0, e.length - 4))
    },
    children: {
      type: "referenceArrayChild"
    }
  };
  if (e.substr(e.length - 3) === "Ids") return {
    type: "referenceArray",
    props: {
      source: e,
      reference: tr.pluralize(e.substr(0, e.length - 3))
    },
    children: {
      type: "referenceArrayChild"
    }
  };
  if (t.length === 0) return e === "email" ? {
    type: "email",
    props: {
      source: e
    }
  } : e === "url" ? {
    type: "url",
    props: {
      source: e
    }
  } : {
    type: "string",
    props: {
      source: e
    }
  };

  if (Bt(t)) {
    if (st(t[0][0])) {
      var r = De(t.reduce(function (o, s) {
        return o.concat(s);
      }, []));
      return {
        type: "array",
        props: {
          source: e
        },
        children: Object.keys(r).map(function (o) {
          return is(o, r[o]);
        })
      };
    }

    return {
      type: "string",
      props: {
        source: e
      }
    };
  }

  if (Jt(t)) return {
    type: "boolean",
    props: {
      source: e
    }
  };
  if (qt(t)) return {
    type: "date",
    props: {
      source: e
    }
  };
  if ($t(t)) return e === "email" || ns(t) ? {
    type: "email",
    props: {
      source: e
    }
  } : e === "url" || rs(t) ? os(t) ? {
    type: "image",
    props: {
      source: e
    }
  } : {
    type: "url",
    props: {
      source: e
    }
  } : Kt(t) ? {
    type: "date",
    props: {
      source: e
    }
  } : Zt(t) ? {
    type: "richText",
    props: {
      source: e
    }
  } : nt(t) || ot(t) ? {
    type: "number",
    props: {
      source: e
    }
  } : {
    type: "string",
    props: {
      source: e
    }
  };
  if (nt(t) || ot(t)) return {
    type: "number",
    props: {
      source: e
    }
  };

  if (Xt(t)) {
    var _r2 = Object.keys(t[0]).shift(),
        o = t.map(function (s) {
      return s[_r2];
    });

    return is("".concat(e, ".").concat(_r2), o);
  }

  return {
    type: "string",
    props: {
      source: e
    }
  };
}, "inferTypeFromValues");
import { useEffect as el, useRef as cs, useCallback as tl } from "react";
import rl from "lodash/debounce";
import ol from "lodash/isEqual";
var nl = n(function (e) {
  return {
    q: e
  };
}, "defaultFilterToQuery"),
    sl = n(function (_ref97) {
  var _ref97$filterToQuery = _ref97.filterToQuery,
      e = _ref97$filterToQuery === void 0 ? nl : _ref97$filterToQuery,
      _ref97$permanentFilte = _ref97.permanentFilter,
      t = _ref97$permanentFilte === void 0 ? {} : _ref97$permanentFilte,
      _ref97$debounceTime = _ref97.debounceTime,
      r = _ref97$debounceTime === void 0 ? 500 : _ref97$debounceTime;

  var o = cs(t),
      s = cs(),
      _z13 = z(y(y({}, t), e(""))),
      _z14 = _slicedToArray(_z13, 2),
      a = _z14[0],
      i = _z14[1],
      u = JSON.stringify(t);

  el(function () {
    ol(o.current, t) || (o.current = t, i(y(y({}, t), e(s.current))));
  }, [u, o, e]);
  var c = tl(rl(function (p) {
    i(y(y({}, t), e(p))), s.current = p;
  }, r), [u]);
  return {
    filter: a,
    setFilter: c
  };
}, "default");
import { useReducer as cl, useEffect as ul, useRef as ll, useCallback as mo } from "react";
import al from "lodash/set";
var at = "SET_SORT",
    oe = "ASC",
    rr = "DESC",
    _e = "SET_PAGE",
    it = "SET_PER_PAGE",
    we = "SET_FILTER",
    ct = "SHOW_FILTER",
    ut = "HIDE_FILTER",
    il = n(function (e) {
  return e === rr ? oe : rr;
}, "oppositeOrder"),
    or = n(function (e, t) {
  switch (t.type) {
    case at:
      return t.payload.field === e.sort ? D(y({}, e), {
        order: il(e.order),
        page: 1
      }) : D(y({}, e), {
        sort: t.payload.field,
        order: t.payload.order || oe,
        page: 1
      });

    case _e:
      return D(y({}, e), {
        page: t.payload
      });

    case it:
      return D(y({}, e), {
        page: 1,
        perPage: t.payload
      });

    case we:
      return D(y({}, e), {
        page: 1,
        filter: t.payload.filter,
        displayedFilters: t.payload.displayedFilters ? t.payload.displayedFilters : e.displayedFilters
      });

    case ct:
      return e.displayedFilters && e.displayedFilters[t.payload.filterName] ? e : D(y({}, e), {
        filter: typeof t.payload.defaultValue != "undefined" ? al(e.filter, t.payload.filterName, t.payload.defaultValue) : e.filter,
        displayedFilters: D(y({}, e.displayedFilters), _defineProperty({}, t.payload.filterName, !0))
      });

    case ut:
      return D(y({}, e), {
        filter: X(Dr(e.filter, t.payload)),
        displayedFilters: e.displayedFilters ? Object.keys(e.displayedFilters).reduce(function (r, o) {
          return o !== t.payload ? D(y({}, r), _defineProperty({}, o, !0)) : r;
        }, {}) : e.displayedFilters
      });

    default:
      return e;
  }
}, "queryReducer"),
    po = or;
var dl = n(function (e, t) {
  switch (t.type) {
    case "SET_SORT":
      return t.payload;

    case "SET_SORT_FIELD":
      {
        var r = t.payload,
            o = e.field === r ? e.order === oe ? rr : oe : oe;
        return {
          field: r,
          order: o
        };
      }

    case "SET_SORT_ORDER":
      {
        var _r3 = t.payload;
        return D(y({}, e), {
          order: _r3
        });
      }

    default:
      return e;
  }
}, "sortReducer"),
    pl = {
  field: "id",
  order: "DESC"
},
    ml = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pl;

  var _cl = cl(dl, e),
      _cl2 = _slicedToArray(_cl, 2),
      t = _cl2[0],
      r = _cl2[1],
      o = ll(!0);

  return ul(function () {
    if (o.current) {
      o.current = !1;
      return;
    }

    r({
      type: "SET_SORT",
      payload: e
    });
  }, [e.field, e.order]), {
    setSort: mo(function (s) {
      return r({
        type: "SET_SORT",
        payload: s
      });
    }, [r]),
    setSortField: mo(function (s) {
      return r({
        type: "SET_SORT_FIELD",
        payload: s
      });
    }, [r]),
    setSortOrder: mo(function (s) {
      return r({
        type: "SET_SORT_ORDER",
        payload: s
      });
    }, [r]),
    sort: t
  };
}, "useSortState"),
    lt = ml;
import { useEffect as fl, useReducer as yl, useCallback as us, useRef as gl } from "react";
var Rl = n(function (e, t) {
  return y(y({}, e), t);
}, "paginationReducer"),
    Pl = {
  page: 1,
  perPage: 25
},
    dt = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _yl = yl(Rl, y(y({}, Pl), e)),
      _yl2 = _slicedToArray(_yl, 2),
      t = _yl2[0],
      r = _yl2[1],
      o = gl(!0),
      s = us(function (i) {
    return r({
      perPage: i,
      page: 1
    });
  }, []),
      a = us(function (i) {
    return r({
      page: i
    });
  }, []);

  return fl(function () {
    if (o.current) {
      o.current = !1;
      return;
    }

    s(e.perPage || 25);
  }, [e.perPage, s]), {
    page: t.page,
    perPage: t.perPage,
    pagination: t,
    setPage: a,
    setPerPage: s,
    setPagination: r
  };
}, "default");
import * as hl from "react";
var xl = n(function (e, t, r) {
  var o = Object.keys(r),
      s = t.filter(function (a) {
    return !o.includes(a);
  });
  if (s.length > 0) throw new Error("<".concat(e, "> component is not properly configured, some essential props are missing.\nBe sure to pass the props from the parent. Example:\n\nconst My").concat(e, " = props => (\n    <").concat(e, " {...props}></").concat(e, ">\n);\n\nThe missing props are: ").concat(s.join(", ")));
}, "useCheckMinimumRequiredProps");
import { useCallback as Cl } from "react";
var Tl = n(function (e) {
  var t = e.record,
      _e$redirect = e.redirect,
      r = _e$redirect === void 0 ? "list" : _e$redirect,
      o = e.onClick,
      s = e.mutationOptions,
      a = H(e),
      i = G(),
      u = nr(a),
      c = ce(),
      _t3 = _t(),
      _t4 = _slicedToArray(_t3, 2),
      p = _t4[0],
      m = _t4[1].isLoading,
      f = Cl(function (x) {
    x.stopPropagation(), p(a, {
      id: t.id,
      previousData: t
    }, y({
      onSuccess: function onSuccess() {
        i("ra.notification.deleted", {
          type: "info",
          messageArgs: {
            smart_count: 1
          },
          undoable: !0
        }), u([t.id]), c(r, a);
      },
      onError: function onError(C) {
        i(typeof C == "string" ? C : C.message || "ra.notification.http_error", {
          type: "warning",
          messageArgs: {
            _: typeof C == "string" ? C : C && C.message ? C.message : void 0
          }
        });
      },
      mutationMode: "undoable"
    }, s)), typeof o == "function" && o(x);
  }, [p, s, i, o, t, c, r, a, u]);

  return {
    isLoading: m,
    handleDelete: f
  };
}, "useDeleteWithUndoController"),
    Sl = Tl;
import { useState as Ml, useCallback as Ll } from "react";
var bl = n(function (e) {
  var t = e.record,
      r = e.redirect,
      o = e.mutationMode,
      s = e.onClick,
      a = e.mutationOptions,
      i = H(e),
      _Ml = Ml(!1),
      _Ml2 = _slicedToArray(_Ml, 2),
      u = _Ml2[0],
      c = _Ml2[1],
      p = G(),
      m = nr(i),
      f = ce(),
      _t5 = _t(),
      _t6 = _slicedToArray(_t5, 2),
      x = _t6[0],
      C = _t6[1].isLoading,
      b = n(function (g) {
    c(!0), g.stopPropagation();
  }, "handleDialogOpen"),
      S = n(function (g) {
    c(!1), g.stopPropagation();
  }, "handleDialogClose"),
      P = Ll(function (g) {
    g.stopPropagation(), x(i, {
      id: t.id,
      previousData: t
    }, y({
      onSuccess: function onSuccess() {
        c(!1), p("ra.notification.deleted", {
          type: "info",
          messageArgs: {
            smart_count: 1
          },
          undoable: o === "undoable"
        }), m([t.id]), f(r, i);
      },
      onError: function onError(R) {
        c(!1), p(typeof R == "string" ? R : R.message || "ra.notification.http_error", {
          type: "warning",
          messageArgs: {
            _: typeof R == "string" ? R : R && R.message ? R.message : void 0
          }
        });
      },
      mutationMode: o
    }, a)), typeof s == "function" && s(g);
  }, [x, o, a, p, s, t, f, r, i, m]);

  return {
    open: u,
    isLoading: C,
    handleDialogOpen: b,
    handleDialogClose: S,
    handleDelete: P
  };
}, "useDeleteWithConfirmController"),
    vl = bl;
import * as fo from "react";
import { useCallback as El } from "react";
import { parse as Dl } from "query-string";
import { useLocation as wl } from "react-router-dom";
var sr = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var L;
  var t = e.disableAuthentication,
      r = e.record,
      o = e.redirect,
      s = e.transform,
      _e$mutationOptions = e.mutationOptions,
      a = _e$mutationOptions === void 0 ? {} : _e$mutationOptions;
  re({
    enabled: !t
  });

  var i = H(e),
      _Kn = Kn(e),
      u = _Kn.hasEdit,
      c = _Kn.hasShow,
      p = o != null ? o : Al(c, u),
      m = wl(),
      f = Q(),
      x = G(),
      C = ce(),
      b = (L = r != null ? r : Il(m)) != null ? L : void 0,
      E = a,
      S = E.onSuccess,
      P = E.onError,
      g = F(E, ["onSuccess", "onError"]),
      _jn = jn(i, void 0, g),
      _jn2 = _slicedToArray(_jn, 2),
      R = _jn2[0],
      M = _jn2[1].isLoading,
      T = El(function (I) {
    var _ref98 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        N = _ref98.onSuccess,
        A = _ref98.onError,
        w = _ref98.transform;

    return Promise.resolve(w ? w(I) : s ? s(I) : I).then(function (O) {
      return R(i, {
        data: O
      }, {
        onSuccess: N || S || function (k) {
          x("ra.notification.created", {
            type: "info",
            messageArgs: {
              smart_count: 1
            }
          }), C(p, i, k.id, k);
        },
        onError: A || P || function (k) {
          x(typeof k == "string" ? k : k.message || "ra.notification.http_error", {
            type: "warning",
            messageArgs: {
              _: typeof k == "string" ? k : k && k.message ? k.message : void 0
            }
          });
        }
      });
    });
  }, [R, p, x, P, S, C, i, s]),
      h = Se(),
      v = f("ra.page.create", {
    name: h(i, 1)
  });

  return {
    isFetching: !1,
    isLoading: !1,
    saving: M,
    defaultTitle: v,
    save: T,
    resource: i,
    record: b,
    redirect: p
  };
}, "useCreateController"),
    Il = n(function (_ref99) {
  var e = _ref99.state,
      t = _ref99.search;
  if (e && e.record) return e.record;
  if (t) try {
    var r = Dl(t);

    if (r.source) {
      if (Array.isArray(r.source)) {
        console.error("Failed to parse location search parameter '".concat(t, "'. To pre-fill some fields in the Create form, pass a stringified source parameter (e.g. '?source={\"title\":\"foo\"}')"));
        return;
      }

      return JSON.parse(r.source);
    }
  } catch (_unused4) {
    console.error("Failed to parse location search parameter '".concat(t, "'. To pre-fill some fields in the Create form, pass a stringified source parameter (e.g. '?source={\"title\":\"foo\"}')"));
  }
  return null;
}, "getRecordFromLocation"),
    Al = n(function (e, t) {
  return t ? "edit" : e ? "show" : "list";
}, "getDefaultRedirectRoute");
import * as lr from "react";
import * as ls from "react";
import { createContext as Fl } from "react";
var ar = Fl(void 0);
ar.displayName = "RecordContext";
var pe = n(function (_ref100) {
  var e = _ref100.children,
      t = _ref100.value;
  return ls.createElement(ar.Provider, {
    value: t
  }, e);
}, "RecordContextProvider");
import { createContext as Nl } from "react";
var pt = Nl({
  record: null,
  defaultTitle: null,
  isFetching: null,
  isLoading: null,
  redirect: null,
  resource: null,
  save: null,
  saving: null
});
pt.displayName = "CreateContext";
import { createContext as Ol } from "react";
var ir = Ol(void 0);
import * as ds from "react";
var cr = n(function (_ref101) {
  var e = _ref101.children,
      t = _ref101.value;
  return ds.createElement(ir.Provider, {
    value: t
  }, e);
}, "SaveContextProvider");
import { useMemo as Ul } from "react";
import kl from "lodash/pick";
var ur = n(function (e) {
  return Ul(function () {
    return kl(e, ["save", "saving", "mutationMode"]);
  }, [e.save, e.saving, e.mutationMode]);
}, "usePickSaveContext");
import { useContext as jl } from "react";
var ps = n(function (e) {
  return jl(ir);
}, "useSaveContext");
var ms = n(function (_ref102) {
  var e = _ref102.children,
      t = _ref102.value;
  return lr.createElement(pt.Provider, {
    value: t
  }, lr.createElement(cr, {
    value: D(y({}, ur(t)), {
      mutationMode: "pessimistic"
    })
  }, lr.createElement(pe, {
    value: t && t.record
  }, e)));
}, "CreateContextProvider");
var TM = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = sr(t),
      a = fo.createElement(ms, {
    value: s
  }, e);
  return t.resource ? fo.createElement(de, {
    value: t.resource
  }, a) : a;
}, "CreateBase");
var vM = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = sr(t);
  return e(s);
}, "CreateController");
import { useContext as Vl, useMemo as Gl } from "react";
import Ql from "lodash/defaults";

var AM = n(function (e) {
  var t = Vl(pt);
  return Gl(function () {
    return Ql({}, e != null ? _l(e) : {}, t);
  }, [t, e]);
}, "useCreateContext"),
    _l = n(function (_ref103) {
  var e = _ref103.record,
      t = _ref103.defaultTitle,
      r = _ref103.isFetching,
      o = _ref103.isLoading,
      s = _ref103.redirect,
      a = _ref103.resource,
      i = _ref103.save,
      u = _ref103.saving;
  return {
    record: e,
    defaultTitle: t,
    isFetching: r,
    isLoading: o,
    redirect: s,
    resource: a,
    save: i,
    saving: u
  };
}, "extractCreateContextProps");

import * as yo from "react";
import { useCallback as zl } from "react";
import { useParams as Hl } from "react-router-dom";
var dr = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = e.disableAuthentication,
      r = e.id,
      _e$mutationMode = e.mutationMode,
      o = _e$mutationMode === void 0 ? "undoable" : _e$mutationMode,
      _e$mutationOptions2 = e.mutationOptions,
      s = _e$mutationOptions2 === void 0 ? {} : _e$mutationOptions2,
      _e$queryOptions = e.queryOptions,
      a = _e$queryOptions === void 0 ? {} : _e$queryOptions,
      _e$redirect2 = e.redirect,
      i = _e$redirect2 === void 0 ? fs : _e$redirect2,
      u = e.transform;
  re({
    enabled: !t
  });

  var c = H(e),
      p = Q(),
      m = G(),
      f = ce(),
      x = Vt(),
      _Hl = Hl(),
      C = _Hl.id,
      b = r || decodeURIComponent(C),
      O = s,
      S = O.onSuccess,
      P = O.onError,
      g = F(O, ["onSuccess", "onError"]),
      _Gt = Gt(c, {
    id: b
  }, y({
    onError: function onError() {
      m("ra.notification.item_doesnt_exist", {
        type: "warning"
      }), f("list", c), x();
    },
    refetchOnReconnect: !1,
    refetchOnWindowFocus: !1,
    retry: !1
  }, a)),
      R = _Gt.data,
      M = _Gt.error,
      T = _Gt.isLoading,
      h = _Gt.isFetching,
      v = _Gt.refetch;

  if (R && R.id && R.id != b) throw new Error("useEditController: Fetched record's id attribute (".concat(R.id, ") must match the requested 'id' (").concat(b, ")"));

  var L = Se(),
      E = p("ra.page.edit", {
    name: L(c, 1),
    id: b,
    record: R
  }),
      I = {
    id: b,
    previousData: R
  },
      _Vn = Vn(c, I, D(y({}, g), {
    mutationMode: o
  })),
      _Vn2 = _slicedToArray(_Vn, 2),
      N = _Vn2[0],
      A = _Vn2[1].isLoading,
      w = zl(function (k) {
    var _ref104 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        $ = _ref104.onSuccess,
        q = _ref104.onError,
        V = _ref104.transform;

    return Promise.resolve(V ? V(k, {
      previousData: I.previousData
    }) : u ? u(k, {
      previousData: I.previousData
    }) : k).then(function (U) {
      return N(c, {
        data: U
      }, {
        onSuccess: $ || S || function () {
          m("ra.notification.updated", {
            type: "info",
            messageArgs: {
              smart_count: 1
            },
            undoable: o === "undoable"
          }), f(i, c, U.id, U);
        },
        onError: q || P || function (j) {
          m(typeof j == "string" ? j : j.message || "ra.notification.http_error", {
            type: "warning",
            messageArgs: {
              _: typeof j == "string" ? j : j && j.message ? j.message : void 0
            }
          });
        }
      });
    });
  }, [o, m, P, S, f, i, c, u, N, I.previousData]);

  return {
    defaultTitle: E,
    error: M,
    isFetching: h,
    isLoading: T,
    mutationMode: o,
    record: R,
    redirect: fs,
    refetch: v,
    resource: c,
    save: w,
    saving: A
  };
}, "useEditController"),
    fs = "list";
import * as pr from "react";
import { useContext as Wl } from "react";
var me = n(function (e) {
  var t = Wl(ar);
  return e && e.record || t;
}, "useRecordContext");
var ZM = n(function (_ref105) {
  var e = _ref105.render;
  var t = me();
  return t ? e(t) : null;
}, "WithRecord");
import * as ys from "react";
var gs = n(function (_ref106) {
  var e = _ref106.value,
      t = _ref106.children;
  return e ? ys.createElement(pe, {
    value: e
  }, t) : t;
}, "OptionalRecordContextProvider");
import { createContext as Yl } from "react";
var mt = Yl({
  record: null,
  defaultTitle: null,
  isFetching: null,
  isLoading: null,
  mutationMode: null,
  redirect: null,
  refetch: null,
  resource: null,
  save: null,
  saving: null
});
mt.displayName = "EditContext";
var Rs = n(function (_ref107) {
  var e = _ref107.children,
      t = _ref107.value;
  return pr.createElement(mt.Provider, {
    value: t
  }, pr.createElement(cr, {
    value: ur(t)
  }, pr.createElement(pe, {
    value: t && t.record
  }, e)));
}, "EditContextProvider");
var uL = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = dr(t),
      a = yo.createElement(Rs, {
    value: s
  }, e);
  return t.resource ? yo.createElement(de, {
    value: t.resource
  }, a) : a;
}, "EditBase");
var fL = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = dr(t);
  return e(s);
}, "EditController");
import { useContext as Jl, useMemo as $l } from "react";
import Zl from "lodash/defaults";
var hL = n(function (e) {
  var t = Jl(mt);
  return $l(function () {
    return Zl({}, e != null ? Bl(e) : {}, t);
  }, [t, e]);
}, "useEditContext"),
    Bl = n(function (_ref108) {
  var e = _ref108.data,
      t = _ref108.record,
      r = _ref108.defaultTitle,
      o = _ref108.isFetching,
      s = _ref108.isLoading,
      a = _ref108.mutationMode,
      i = _ref108.redirect,
      u = _ref108.resource,
      c = _ref108.save,
      p = _ref108.saving;
  return {
    data: t || e,
    record: t || e,
    defaultTitle: r,
    isFetching: o,
    isLoading: s,
    mutationMode: a,
    redirect: i,
    resource: u,
    save: c,
    saving: p
  };
}, "extractEditContextProps");
import zd from "lodash/get";
import * as go from "react";
import { isValidElement as fd, useEffect as yd, useMemo as gd } from "react";
import { useMemo as ql } from "react";
var fe = n(function (e) {
  var t = "".concat(e, ".selectedIds"),
      _ue3 = ue(t, Kl),
      _ue4 = _slicedToArray(_ue3, 2),
      r = _ue4[0],
      o = _ue4[1],
      s = fn(t),
      a = ql(function () {
    return {
      select: function select(i) {
        !i || o(_toConsumableArray(i));
      },
      unselect: function unselect(i) {
        !i || i.length === 0 || o(function (u) {
          return Array.isArray(u) ? u.filter(function (c) {
            return !i.includes(c);
          }) : [];
        });
      },
      toggle: function toggle(i) {
        typeof i != "undefined" && o(function (u) {
          if (!Array.isArray(u)) return _toConsumableArray(u);
          var c = u.indexOf(i);
          return c > -1 ? [].concat(_toConsumableArray(u.slice(0, c)), _toConsumableArray(u.slice(c + 1))) : [].concat(_toConsumableArray(u), [i]);
        });
      },
      clearSelection: function clearSelection() {
        s();
      }
    };
  }, [o, s]);

  return [r, a];
}, "useRecordSelection"),
    Kl = [];
import { useCallback as Ie, useMemo as Xl, useEffect as ed, useState as td, useRef as rd } from "react";
import { parse as od, stringify as nd } from "query-string";
import sd from "lodash/debounce";
import ad from "lodash/pickBy";
import { useNavigate as id, useLocation as cd } from "react-router-dom";
var Ps = n(function (_ref109) {
  var e = _ref109.resource,
      t = _ref109.filterDefaultValues,
      _ref109$sort = _ref109.sort,
      r = _ref109$sort === void 0 ? md : _ref109$sort,
      _ref109$perPage = _ref109.perPage,
      o = _ref109$perPage === void 0 ? 10 : _ref109$perPage,
      _ref109$debounce = _ref109.debounce,
      s = _ref109$debounce === void 0 ? 500 : _ref109$debounce,
      _ref109$disableSyncWi = _ref109.disableSyncWithLocation,
      a = _ref109$disableSyncWi === void 0 ? !1 : _ref109$disableSyncWi;

  var i = cd(),
      u = id(),
      _td = td(Ts),
      _td2 = _slicedToArray(_td, 2),
      c = _td2[0],
      p = _td2[1],
      m = "".concat(e, ".listParams"),
      _ue5 = ue(m, Ts),
      _ue6 = _slicedToArray(_ue5, 2),
      f = _ue6[0],
      x = _ue6[1],
      C = rd(),
      b = mn(),
      S = [i.search, e, JSON.stringify(a ? c : f), JSON.stringify(t), JSON.stringify(r), o, a],
      P = a ? {} : ld(i),
      g = Xl(function () {
    return pd({
      queryFromLocation: P,
      params: a ? c : f,
      filterDefaultValues: t,
      sort: r,
      perPage: o
    });
  }, S);

  ed(function () {
    Object.keys(P).length > 0 && x(g);
  }, [i.search]);
  var R = Ie(function (w) {
    !b.current || (C.current ? C.current = po(C.current, w) : (C.current = po(g, w), setTimeout(function () {
      a ? p(C.current) : u({
        search: "?".concat(nd(D(y({}, C.current), {
          filter: JSON.stringify(C.current.filter),
          displayedFilters: JSON.stringify(C.current.displayedFilters)
        })))
      }, {
        state: {
          _scrollToTop: w.type === _e
        }
      }), C.current = void 0;
    }, 0)));
  }, S),
      M = Ie(function (w) {
    return R({
      type: at,
      payload: w
    });
  }, S),
      T = Ie(function (w) {
    return R({
      type: _e,
      payload: w
    });
  }, S),
      h = Ie(function (w) {
    return R({
      type: it,
      payload: w
    });
  }, S),
      v = g.filter || Cs,
      L = g.displayedFilters || Cs,
      E = sd(function (w, O) {
    R({
      type: we,
      payload: {
        filter: X(w),
        displayedFilters: O
      }
    });
  }, s),
      I = Ie(function (w, O) {
    var k = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    return k ? E(w, O) : R({
      type: we,
      payload: {
        filter: X(w),
        displayedFilters: O
      }
    });
  }, S),
      N = Ie(function (w) {
    R({
      type: ut,
      payload: w
    });
  }, S),
      A = Ie(function (w, O) {
    R({
      type: ct,
      payload: {
        filterName: w,
        defaultValue: O
      }
    });
  }, S);
  return [y({
    displayedFilters: L,
    filterValues: v,
    requestSignature: S
  }, g), {
    changeParams: R,
    setPage: T,
    setPerPage: h,
    setSort: M,
    setFilters: I,
    hideFilter: N,
    showFilter: A
  }];
}, "useListParams"),
    ud = ["page", "perPage", "sort", "order", "filter", "displayedFilters"],
    hs = n(function (e, t) {
  if (e[t] && typeof e[t] == "string") try {
    e[t] = JSON.parse(e[t]);
  } catch (_unused5) {
    delete e[t];
  }
}, "parseObject"),
    ld = n(function (_ref110) {
  var e = _ref110.search;
  var t = ad(od(e), function (r, o) {
    return ud.indexOf(o) !== -1;
  });
  return hs(t, "filter"), hs(t, "displayedFilters"), t;
}, "parseQueryFromLocation"),
    dd = n(function (e) {
  return e && e.filter && (Object.keys(e.filter).length > 0 || e.order != null || e.page !== 1 || e.perPage != null || e.sort != null);
}, "hasCustomParams"),
    pd = n(function (_ref111) {
  var e = _ref111.queryFromLocation,
      t = _ref111.params,
      r = _ref111.filterDefaultValues,
      o = _ref111.sort,
      s = _ref111.perPage;
  var a = Object.keys(e).length > 0 ? e : dd(t) ? y({}, t) : {
    filter: r || {}
  };
  return a.sort || (a.sort = o.field, a.order = o.order), a.perPage == null && (a.perPage = s), a.page == null && (a.page = 1), D(y({}, a), {
    page: xs(a.page, 1),
    perPage: xs(a.perPage, 10)
  });
}, "getQuery"),
    xs = n(function (e, t) {
  var r = typeof e == "string" ? parseInt(e, 10) : e;
  return isNaN(r) ? t : r;
}, "getNumberOrDefault"),
    Cs = {},
    md = {
  field: "id",
  order: oe
},
    Ts = {};
var mr = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = e.disableAuthentication,
      _e$exporter = e.exporter,
      r = _e$exporter === void 0 ? rt : _e$exporter,
      o = e.filterDefaultValues,
      _e$sort = e.sort,
      s = _e$sort === void 0 ? Rd : _e$sort,
      _e$perPage = e.perPage,
      a = _e$perPage === void 0 ? 10 : _e$perPage,
      i = e.filter,
      _e$debounce = e.debounce,
      u = _e$debounce === void 0 ? 500 : _e$debounce,
      c = e.disableSyncWithLocation,
      p = e.queryOptions;
  re({
    enabled: !t
  });
  var m = H(e);
  if (!m) throw new Error("<List> was called outside of a ResourceContext and without a resource prop. You must set the resource prop.");
  if (i && fd(i)) throw new Error("<List> received a React element as `filter` props. If you intended to set the list filter elements, use the `filters` (with an s) prop instead. The `filter` prop is internal and should not be set by the developer.");

  var f = Q(),
      x = G(),
      _Ps = Ps({
    resource: m,
    filterDefaultValues: o,
    sort: s,
    perPage: a,
    debounce: u,
    disableSyncWithLocation: c
  }),
      _Ps2 = _slicedToArray(_Ps, 2),
      C = _Ps2[0],
      b = _Ps2[1],
      _fe = fe(m),
      _fe2 = _slicedToArray(_fe, 2),
      S = _fe2[0],
      P = _fe2[1],
      _Ve = Ve(m, {
    pagination: {
      page: C.page,
      perPage: C.perPage
    },
    sort: {
      field: C.sort,
      order: C.order
    },
    filter: y(y({}, C.filter), i)
  }, y({
    keepPreviousData: !0,
    retry: !1,
    onError: function onError(A) {
      return x((A == null ? void 0 : A.message) || "ra.notification.http_error", {
        type: "warning",
        messageArgs: {
          _: A == null ? void 0 : A.message
        }
      });
    }
  }, p)),
      g = _Ve.data,
      R = _Ve.pageInfo,
      M = _Ve.total,
      T = _Ve.error,
      h = _Ve.isLoading,
      v = _Ve.isFetching,
      L = _Ve.refetch;

  yd(function () {
    if (C.page <= 0 || !v && C.page > 1 && g.length === 0) {
      b.setPage(1);
      return;
    }

    if (M == null) return;
    var A = Math.ceil(M / C.perPage) || 1;
    !v && C.page > A && b.setPage(A);
  }, [v, C.page, C.perPage, g, b, M]);
  var E = gd(function () {
    return {
      field: C.sort,
      order: C.order
    };
  }, [C.sort, C.order]),
      I = Se(),
      N = f("ra.page.list", {
    name: I(m, 2)
  });
  return {
    sort: E,
    data: g,
    defaultTitle: N,
    displayedFilters: C.displayedFilters,
    error: T,
    exporter: r,
    filter: i,
    filterValues: C.filterValues,
    hideFilter: b.hideFilter,
    isFetching: v,
    isLoading: h,
    onSelect: P.select,
    onToggleItem: P.toggle,
    onUnselectItems: P.clearSelection,
    page: C.page,
    perPage: C.perPage,
    refetch: L,
    resource: m,
    selectedIds: S,
    setFilters: b.setFilters,
    setPage: b.setPage,
    setPerPage: b.setPerPage,
    setSort: b.setSort,
    showFilter: b.showFilter,
    total: M,
    hasNextPage: R ? R.hasNextPage : M != null ? C.page * C.perPage < M : void 0,
    hasPreviousPage: R ? R.hasPreviousPage : C.page > 1
  };
}, "useListController"),
    Rd = {
  field: "id",
  order: oe
},
    Ss = ["sort", "data", "defaultTitle", "displayedFilters", "error", "exporter", "filterValues", "hideFilter", "isFetching", "isLoading", "onSelect", "onToggleItem", "onUnselectItems", "page", "perPage", "refetch", "refresh", "resource", "selectedIds", "setFilters", "setPage", "setPerPage", "setSort", "showFilter", "total", "totalPages"],
    WL = n(function (e) {
  return Ss.reduce(function (t, r) {
    return D(y({}, t), _defineProperty({}, r, e[r]));
  }, {});
}, "getListControllerProps"),
    YL = n(function (e) {
  return Object.keys(e).filter(function (t) {
    return !Ss.includes(t);
  }).reduce(function (t, r) {
    return D(y({}, t), _defineProperty({}, r, e[r]));
  }, {});
}, "sanitizeListRestProps");
import * as Pt from "react";
import { createContext as Pd } from "react";
var ft = Pd({
  sort: null,
  data: null,
  defaultTitle: null,
  displayedFilters: null,
  exporter: null,
  filterValues: null,
  hasNextPage: null,
  hasPreviousPage: null,
  hideFilter: null,
  isFetching: null,
  isLoading: null,
  onSelect: null,
  onToggleItem: null,
  onUnselectItems: null,
  page: null,
  perPage: null,
  refetch: null,
  resource: null,
  selectedIds: void 0,
  setFilters: null,
  setPage: null,
  setPerPage: null,
  setSort: null,
  showFilter: null,
  total: null
});
ft.displayName = "ListContext";
import { createContext as hd, useMemo as xd } from "react";
import Cd from "lodash/pick";
var yt = hd({
  displayedFilters: null,
  filterValues: null,
  hideFilter: null,
  setFilters: null,
  showFilter: null,
  resource: null
}),
    Ms = n(function (e) {
  return xd(function () {
    return Cd(e, ["displayedFilters", "filterValues", "hideFilter", "setFilters", "showFilter", "resource"]);
  }, [e.displayedFilters, e.filterValues, e.hideFilter, e.setFilters, e.showFilter]);
}, "usePickFilterContext");
yt.displayName = "ListFilterContext";
import { createContext as Td, useMemo as Sd } from "react";
import Md from "lodash/pick";
var gt = Td({
  sort: null,
  setSort: null,
  resource: null
}),
    Ls = n(function (e) {
  return Sd(function () {
    return Md(e, ["sort", "setSort", "resource"]);
  }, [e.sort, e.setSort]);
}, "usePickSortContext");
gt.displayName = "ListSortContext";
import { createContext as Ld, useMemo as bd } from "react";
import vd from "lodash/pick";
var Rt = Ld({
  isLoading: null,
  page: null,
  perPage: null,
  setPage: null,
  setPerPage: null,
  hasPreviousPage: null,
  hasNextPage: null,
  total: void 0,
  resource: null
});
Rt.displayName = "ListPaginationContext";
var bs = n(function (e) {
  return bd(function () {
    return vd(e, ["isLoading", "hasPreviousPage", "hasNextPage", "page", "perPage", "setPage", "setPerPage", "total", "resource"]);
  }, [e.isLoading, e.hasPreviousPage, e.hasNextPage, e.page, e.perPage, e.setPage, e.setPerPage, e.total]);
}, "usePickPaginationContext");
var vs = n(function (_ref112) {
  var e = _ref112.value,
      t = _ref112.children;
  return Pt.createElement(ft.Provider, {
    value: e
  }, Pt.createElement(yt.Provider, {
    value: Ms(e)
  }, Pt.createElement(gt.Provider, {
    value: Ls(e)
  }, Pt.createElement(Rt.Provider, {
    value: bs(e)
  }, t))));
}, "ListContextProvider");
var fb = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  return go.createElement(de, {
    value: t.resource
  }, go.createElement(vs, {
    value: mr(t)
  }, e));
}, "ListBase");
var hb = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = mr(t);
  return e(s);
}, "ListController");
import { useCallback as fr, useEffect as yr, useRef as Ed } from "react";
import ht from "lodash/get";
import Dd from "lodash/isEqual";
var wd = n(function () {
  throw new Error("refetch is not available for a ListContext built from useList based on local data");
}, "refetch"),
    gr = n(function (e) {
  var t = e.data,
      r = e.error,
      _e$filter = e.filter,
      o = _e$filter === void 0 ? Id : _e$filter,
      _e$isFetching = e.isFetching,
      s = _e$isFetching === void 0 ? !1 : _e$isFetching,
      _e$isLoading = e.isLoading,
      a = _e$isLoading === void 0 ? !1 : _e$isLoading,
      _e$page = e.page,
      i = _e$page === void 0 ? 1 : _e$page,
      _e$perPage2 = e.perPage,
      u = _e$perPage2 === void 0 ? 1e3 : _e$perPage2,
      _e$sort2 = e.sort,
      c = _e$sort2 === void 0 ? Ad : _e$sort2,
      p = H(e),
      _z15 = z(s),
      _z16 = _slicedToArray(_z15, 2),
      m = _z16[0],
      f = _z16[1],
      _z17 = z(a),
      _z18 = _slicedToArray(_z17, 2),
      x = _z18[0],
      C = _z18[1],
      _z19 = z(function () {
    return {
      data: t,
      total: t ? t.length : void 0
    };
  }),
      _z20 = _slicedToArray(_z19, 2),
      b = _z20[0],
      S = _z20[1],
      _dt = dt({
    page: i,
    perPage: u
  }),
      P = _dt.page,
      g = _dt.setPage,
      R = _dt.perPage,
      M = _dt.setPerPage,
      _lt = lt(c),
      T = _lt.sort,
      h = _lt.setSort,
      v = fr(function (V) {
    h(V), g(1);
  }, [g, h]),
      _fe3 = fe(p),
      _fe4 = _slicedToArray(_fe3, 2),
      L = _fe4[0],
      E = _fe4[1],
      I = Ed(o),
      _z21 = z({}),
      _z22 = _slicedToArray(_z21, 2),
      N = _z22[0],
      A = _z22[1],
      _z23 = z(o),
      _z24 = _slicedToArray(_z23, 2),
      w = _z24[0],
      O = _z24[1],
      k = fr(function (V) {
    A(function (U) {
      var Y = U,
          j = Y[V];
      return F(Y, [Pe(V)]);
    }), O(function (U) {
      var Y = U,
          j = Y[V];
      return F(Y, [Pe(V)]);
    });
  }, [A, O]),
      $ = fr(function (V, U) {
    A(function (j) {
      return D(y({}, j), _defineProperty({}, V, !0));
    }), O(function (j) {
      return X(D(y({}, j), _defineProperty({}, V, U)));
    });
  }, [A, O]),
      q = fr(function (V, U) {
    O(X(V)), U && A(U), g(1);
  }, [A, O, g]);

  return yr(function () {
    Dd(o, I.current) || (I.current = o, O(o));
  }), yr(function () {
    if (a || !t) return;
    var V = t.filter(function (j) {
      return Object.entries(w).every(function (_ref113) {
        var _ref114 = _slicedToArray(_ref113, 2),
            B = _ref114[0],
            Y = _ref114[1];

        var K = ht(j, B);
        return Array.isArray(K) ? Array.isArray(Y) ? K.some(function (St) {
          return Y.includes(St);
        }) : K.includes(Y) : Array.isArray(Y) ? Y.includes(K) : Y == K;
      });
    }),
        U = V.length;
    T.field && (V = V.sort(function (j, B) {
      return ht(j, T.field) > ht(B, T.field) ? T.order === "ASC" ? 1 : -1 : ht(j, T.field) < ht(B, T.field) ? T.order === "ASC" ? -1 : 1 : 0;
    })), V = V.slice((P - 1) * R, P * R), S({
      data: V,
      total: U
    });
  }, [JSON.stringify(t), w, a, P, R, S, T.field, T.order]), yr(function () {
    s !== m && f(s);
  }, [s, m, f]), yr(function () {
    a !== x && C(a);
  }, [a, x, C]), {
    sort: T,
    data: b.data,
    defaultTitle: "",
    error: r,
    displayedFilters: N,
    filterValues: w,
    hasNextPage: P * R < b.total,
    hasPreviousPage: P > 1,
    hideFilter: k,
    isFetching: m,
    isLoading: x,
    onSelect: E.select,
    onToggleItem: E.toggle,
    onUnselectItems: E.clearSelection,
    page: P,
    perPage: R,
    resource: void 0,
    refetch: wd,
    selectedIds: L,
    setFilters: q,
    setPage: g,
    setPerPage: M,
    setSort: v,
    showFilter: $,
    total: b.total
  };
}, "useList"),
    Id = {},
    Ad = {
  field: null,
  order: null
};
import { useContext as Fd, useMemo as Nd } from "react";
import Od from "lodash/defaults";
var Fb = n(function (e) {
  var t = Fd(ft);
  return Nd(function () {
    return Od({}, e != null ? Ud(e) : {}, t);
  }, [t, e]);
}, "useListContext"),
    Ud = n(function (_ref115) {
  var e = _ref115.sort,
      t = _ref115.data,
      r = _ref115.defaultTitle,
      o = _ref115.displayedFilters,
      s = _ref115.exporter,
      a = _ref115.filterValues,
      i = _ref115.hasCreate,
      u = _ref115.hideFilter,
      c = _ref115.isFetching,
      p = _ref115.isLoading,
      m = _ref115.onSelect,
      f = _ref115.onToggleItem,
      x = _ref115.onUnselectItems,
      C = _ref115.page,
      b = _ref115.perPage,
      S = _ref115.refetch,
      P = _ref115.resource,
      g = _ref115.selectedIds,
      R = _ref115.setFilters,
      M = _ref115.setPage,
      T = _ref115.setPerPage,
      h = _ref115.setSort,
      v = _ref115.showFilter,
      L = _ref115.total;
  return {
    sort: e,
    data: t,
    defaultTitle: r,
    displayedFilters: o,
    exporter: s,
    filterValues: a,
    hasCreate: i,
    hideFilter: u,
    isFetching: c,
    isLoading: p,
    onSelect: m,
    onToggleItem: f,
    onUnselectItems: x,
    page: C,
    perPage: b,
    refetch: S,
    resource: P,
    selectedIds: g,
    setFilters: R,
    setPage: M,
    setPerPage: T,
    setSort: h,
    showFilter: v,
    total: L
  };
}, "extractListContextProps");
import { useContext as kd } from "react";
var jb = n(function (e) {
  var t = kd(yt);
  return t.hideFilter ? t : (process.env.NODE_ENV !== "production" && console.log("List components must be used inside a <ListContextProvider>. Relying on props rather than context to get List data and callbacks is deprecated and won't be supported in the next major version of react-admin."), e);
}, "useListFilterContext");
import { useContext as jd } from "react";
var zb = n(function (e) {
  var t = jd(Rt);
  return t.setPage ? t : (process.env.NODE_ENV !== "production" && console.log("List components must be used inside a <ListContextProvider>. Relying on props rather than context to get List data and callbacks is deprecated and won't be supported in the next major version of react-admin."), e);
}, "useListPaginationContext");
import { useContext as Vd } from "react";
var $b = n(function (e) {
  var t = Vd(gt);
  return t.setSort ? t : (process.env.NODE_ENV !== "production" && console.log("List components must be used inside a <ListContextProvider>. Relying on props rather than context to get List data and callbacks is deprecated and won't be supported in the next major version of react-admin."), e);
}, "useListSortContext");
import { useCallback as Gd } from "react";
var nr = n(function (e) {
  var _fe5 = fe(e),
      _fe6 = _slicedToArray(_fe5, 2),
      t = _fe6[1].unselect;

  return Gd(function (r) {
    t(r);
  }, [t]);
}, "useUnselect");
import { useCallback as Qd } from "react";
var tv = n(function (e) {
  var _fe7 = fe(e),
      _fe8 = _slicedToArray(_fe7, 2),
      t = _fe8[1].clearSelection;

  return Qd(function () {
    t();
  }, [t]);
}, "useUnselectAll");
import { useCallback as _d } from "react";
var sv = n(function (e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

  var _ue7 = ue("".concat(e, ".datagrid.expanded"), []),
      _ue8 = _slicedToArray(_ue7, 2),
      o = _ue8[0],
      s = _ue8[1],
      a = Array.isArray(o) ? o.map(function (u) {
    return u == t;
  }).indexOf(!0) !== -1 : !1,
      i = _d(function () {
    s(function (u) {
      if (!Array.isArray(u)) return [t];
      var c = u.findIndex(function (p) {
        return p == t;
      });
      return c > -1 ? r ? [] : [].concat(_toConsumableArray(u.slice(0, c)), _toConsumableArray(u.slice(c + 1))) : r ? [t] : [].concat(_toConsumableArray(u), [t]);
    });
  }, [s, t, r]);

  return [a, i];
}, "useExpanded");
var Hd = [],
    Wd = {},
    Yd = {
  field: null,
  order: null
},
    pv = n(function (e) {
  var _e$filter2 = e.filter,
      t = _e$filter2 === void 0 ? Wd : _e$filter2,
      _e$page2 = e.page,
      r = _e$page2 === void 0 ? 1 : _e$page2,
      _e$perPage3 = e.perPage,
      o = _e$perPage3 === void 0 ? 1e3 : _e$perPage3,
      s = e.record,
      a = e.reference,
      _e$sort3 = e.sort,
      i = _e$sort3 === void 0 ? Yd : _e$sort3,
      u = e.source,
      c = G(),
      p = zd(s, u) || Hd,
      _Ge = Ge(a, {
    ids: p
  }, {
    onError: function onError(P) {
      return c(typeof P == "string" ? P : P.message || "ra.notification.http_error", {
        type: "warning",
        messageArgs: {
          _: typeof P == "string" ? P : P && P.message ? P.message : void 0
        }
      });
    }
  }),
      m = _Ge.data,
      f = _Ge.error,
      x = _Ge.isLoading,
      C = _Ge.isFetching,
      b = _Ge.refetch,
      S = gr({
    data: m,
    error: f,
    filter: t,
    isFetching: C,
    isLoading: x,
    page: r,
    perPage: o,
    sort: i
  });

  return D(y({}, S), {
    defaultTitle: null,
    refetch: b,
    resource: a
  });
}, "useReferenceArrayFieldController");
import Jd from "lodash/get";
import { useCallback as Rr, useEffect as $d, useRef as Zd } from "react";
import Bd from "lodash/isEqual";
var qd = {},
    Sv = n(function (e) {
  var t = e.reference,
      r = e.record,
      o = e.target,
      _e$filter3 = e.filter,
      s = _e$filter3 === void 0 ? qd : _e$filter3,
      a = e.source,
      i = e.page,
      u = e.perPage,
      _e$sort4 = e.sort,
      c = _e$sort4 === void 0 ? {
    field: "id",
    order: "DESC"
  } : _e$sort4,
      p = G(),
      _dt2 = dt({
    page: i,
    perPage: u
  }),
      m = _dt2.page,
      f = _dt2.setPage,
      x = _dt2.perPage,
      C = _dt2.setPerPage,
      _lt2 = lt(c),
      b = _lt2.sort,
      S = _lt2.setSort,
      P = Rr(function (U) {
    S(U), f(1);
  }, [f, S]),
      _fe9 = fe(t),
      _fe10 = _slicedToArray(_fe9, 2),
      g = _fe10[0],
      R = _fe10[1],
      M = Zd(s),
      _z25 = z({}),
      _z26 = _slicedToArray(_z25, 2),
      T = _z26[0],
      h = _z26[1],
      _z27 = z(s),
      _z28 = _slicedToArray(_z27, 2),
      v = _z28[0],
      L = _z28[1],
      E = Rr(function (U) {
    h(function (j) {
      var K = j,
          B = K[U];
      return F(K, [Pe(U)]);
    }), L(function (j) {
      var K = j,
          B = K[U];
      return F(K, [Pe(U)]);
    });
  }, [h, L]),
      I = Rr(function (U, j) {
    h(function (B) {
      return D(y({}, B), _defineProperty({}, U, !0));
    }), L(function (B) {
      return D(y({}, B), _defineProperty({}, U, j));
    });
  }, [h, L]),
      N = Rr(function (U, j) {
    L(X(U)), h(j), f(1);
  }, [h, L, f]);

  $d(function () {
    Bd(s, M.current) || (M.current = s, L(s));
  });

  var _Qt = Qt(t, {
    target: o,
    id: Jd(r, a),
    pagination: {
      page: m,
      perPage: x
    },
    sort: b,
    filter: v
  }, {
    keepPreviousData: !0,
    onError: function onError(U) {
      return p(typeof U == "string" ? U : U.message || "ra.notification.http_error", {
        type: "warning",
        messageArgs: {
          _: typeof U == "string" ? U : U && U.message ? U.message : void 0
        }
      });
    }
  }),
      A = _Qt.data,
      w = _Qt.total,
      O = _Qt.pageInfo,
      k = _Qt.error,
      $ = _Qt.isFetching,
      q = _Qt.isLoading,
      V = _Qt.refetch;

  return {
    sort: b,
    data: A,
    defaultTitle: null,
    displayedFilters: T,
    error: k,
    filterValues: v,
    hideFilter: E,
    isFetching: $,
    isLoading: q,
    onSelect: R.select,
    onToggleItem: R.toggle,
    onUnselectItems: R.clearSelection,
    page: m,
    perPage: x,
    refetch: V,
    resource: t,
    selectedIds: g,
    setFilters: N,
    setPage: f,
    setPerPage: C,
    hasNextPage: O ? O.hasNextPage : w != null ? m * x < w : void 0,
    hasPreviousPage: O ? O.hasPreviousPage : m > 1,
    setSort: P,
    showFilter: I,
    total: w
  };
}, "useReferenceManyFieldController");
import Kd from "lodash/get";
var Ev = n(function (e) {
  var t = e.reference,
      r = e.record,
      o = e.target,
      _e$source = e.source,
      s = _e$source === void 0 ? "id" : _e$source,
      a = G(),
      _Qt2 = Qt(t, {
    target: o,
    id: Kd(r, s),
    pagination: {
      page: 1,
      perPage: 1
    },
    sort: {
      field: "id",
      order: "ASC"
    },
    filter: {}
  }, {
    enabled: !!r,
    onError: function onError(f) {
      return a(typeof f == "string" ? f : f.message || "ra.notification.http_error", {
        type: "warning",
        messageArgs: {
          _: typeof f == "string" ? f : f && f.message ? f.message : void 0
        }
      });
    }
  }),
      i = _Qt2.data,
      u = _Qt2.error,
      c = _Qt2.isFetching,
      p = _Qt2.isLoading,
      m = _Qt2.refetch;

  return {
    referenceRecord: i ? i[0] : void 0,
    error: u,
    isFetching: c,
    isLoading: p,
    refetch: m
  };
}, "useReferenceOneFieldController");
var Es = n(function (e) {
  return e && e.error !== void 0;
}, "isMatchingReferencesError"),
    Xd = n(function (_ref116) {
  var e = _ref116.field,
      t = _ref116.matchingReferences,
      r = _ref116.referenceRecord,
      _ref116$translate = _ref116.translate,
      o = _ref116$translate === void 0 ? n(function (s) {
    return s;
  }, "translate") : _ref116$translate;
  var s = Es(t) ? o(t.error, {
    _: t.error
  }) : null,
      a = e.value && !r ? o("ra.input.references.single_missing", {
    _: "ra.input.references.single_missing"
  }) : null;
  return {
    waiting: e.value && a && !t || !e.value && !t,
    error: e.value && a && s || !e.value && s ? e.value ? a : s : null,
    warning: a || s,
    choices: Array.isArray(t) ? t : [r].filter(function (i) {
      return i;
    })
  };
}, "getStatusForInput"),
    Ds = "REFERENCES_STATUS_READY",
    ep = "REFERENCES_STATUS_INCOMPLETE",
    Ro = "REFERENCES_STATUS_EMPTY",
    ws = n(function (e, t) {
  return !e.value || e.value.length === t.length ? Ds : t.length > 0 ? ep : Ro;
}, "getSelectedReferencesStatus"),
    tp = n(function (_ref117) {
  var e = _ref117.field,
      t = _ref117.matchingReferences,
      r = _ref117.referenceRecords,
      _ref117$translate = _ref117.translate,
      o = _ref117$translate === void 0 ? n(function (s) {
    return s;
  }, "translate") : _ref117$translate;
  var s = ws(e, r),
      a = Es(t) ? o(t.error, {
    _: t.error
  }) : null,
      i = Array.isArray(t) ? r.concat(t.filter(function (u) {
    return r.findIndex(function (c) {
      return c.id === u.id;
    }) === -1;
  })) : r;
  return {
    waiting: !t && e.value && s === Ro || !t && !e.value,
    error: a && (!e.value || e.value && s === Ro) ? o("ra.input.references.all_missing", {
      _: "ra.input.references.all_missing"
    }) : null,
    warning: a || e.value && s !== Ds ? a || o("ra.input.references.many_missing", {
      _: "ra.input.references.many_missing"
    }) : null,
    choices: i
  };
}, "getStatusForArrayInput");
import { useCallback as lp, useMemo as dp } from "react";
import { useWatch as pp } from "react-hook-form";
import { useCallback as Ae, useMemo as rp, useState as op, useRef as np } from "react";
import sp from "lodash/debounce";
var Pr = n(function (_ref118) {
  var e = _ref118.resource,
      t = _ref118.filter,
      _ref118$sort = _ref118.sort,
      r = _ref118$sort === void 0 ? cp : _ref118$sort,
      _ref118$page = _ref118.page,
      o = _ref118$page === void 0 ? 1 : _ref118$page,
      _ref118$perPage = _ref118.perPage,
      s = _ref118$perPage === void 0 ? 10 : _ref118$perPage,
      _ref118$debounce = _ref118.debounce,
      a = _ref118$debounce === void 0 ? 500 : _ref118$debounce;

  var _op = op(up),
      _op2 = _slicedToArray(_op, 2),
      i = _op2[0],
      u = _op2[1],
      c = np(),
      p = [e, JSON.stringify(i), JSON.stringify(t), JSON.stringify(r), o, s],
      m = rp(function () {
    return ap({
      params: i,
      filterDefaultValues: t,
      sort: r,
      page: o,
      perPage: s
    });
  }, p),
      f = Ae(function (h) {
    c.current ? c.current = or(c.current, h) : (c.current = or(m, h), setTimeout(function () {
      u(c.current), c.current = void 0;
    }, 0));
  }, p),
      x = Ae(function (h) {
    return f({
      type: at,
      payload: h
    });
  }, p),
      C = Ae(function (h) {
    return f({
      type: _e,
      payload: h
    });
  }, p),
      b = Ae(function (h) {
    return f({
      type: it,
      payload: h
    });
  }, p),
      S = m.filter || As,
      P = m.displayedFilters || As,
      g = sp(function (h, v) {
    f({
      type: we,
      payload: {
        filter: X(h),
        displayedFilters: v
      }
    });
  }, a),
      R = Ae(function (h, v) {
    var L = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    L ? g(h, v) : f({
      type: we,
      payload: {
        filter: X(h),
        displayedFilters: v
      }
    });
  }, p),
      M = Ae(function (h) {
    f({
      type: ut,
      payload: h
    });
  }, p),
      T = Ae(function (h, v) {
    f({
      type: ct,
      payload: {
        filterName: h,
        defaultValue: v
      }
    });
  }, p);

  return [y({
    displayedFilters: P,
    filterValues: S,
    requestSignature: p
  }, m), {
    changeParams: f,
    setPage: C,
    setPerPage: b,
    setSort: x,
    setFilters: R,
    hideFilter: M,
    showFilter: T
  }];
}, "useReferenceParams");
var ap = n(function (_ref119) {
  var e = _ref119.params,
      t = _ref119.filterDefaultValues,
      r = _ref119.sort,
      o = _ref119.page,
      s = _ref119.perPage;
  var a = ip(e) ? y({}, e) : {
    filter: t || {}
  };
  return a.sort || (a.sort = r.field, a.order = r.order), a.page == null && (a.page = o), a.perPage == null && (a.perPage = s), a.page == null && (a.page = 1), D(y({}, a), {
    page: Is(a.page, 1),
    perPage: Is(a.perPage, 10)
  });
}, "getQuery"),
    ip = n(function (e) {
  return e && e.filter && (Object.keys(e.filter).length > 0 || e.order != null || e.page !== 1 || e.perPage != null || e.sort != null);
}, "hasCustomParams"),
    Is = n(function (e, t) {
  var r = typeof e == "string" ? parseInt(e, 10) : e;
  return isNaN(r) ? t : r;
}, "getNumberOrDefault"),
    As = {},
    cp = {
  field: "id",
  order: oe
},
    up = {};
var Gv = n(function (e) {
  var t = e.debounce,
      r = e.enableGetChoices,
      o = e.filter,
      _e$page3 = e.page,
      s = _e$page3 === void 0 ? 1 : _e$page3,
      _e$perPage4 = e.perPage,
      a = _e$perPage4 === void 0 ? 25 : _e$perPage4,
      _e$sort5 = e.sort,
      i = _e$sort5 === void 0 ? {
    field: "id",
    order: "DESC"
  } : _e$sort5,
      _e$queryOptions2 = e.queryOptions,
      u = _e$queryOptions2 === void 0 ? {} : _e$queryOptions2,
      c = e.reference,
      p = e.source,
      m = pp({
    name: p
  }),
      _Ge2 = Ge(c, {
    ids: m || mp
  }, {
    enabled: m != null && m.length > 0
  }),
      f = _Ge2.data,
      x = _Ge2.error,
      C = _Ge2.isLoading,
      b = _Ge2.isFetching,
      S = _Ge2.refetch,
      _Pr = Pr({
    resource: c,
    page: s,
    perPage: a,
    sort: i,
    debounce: t,
    filter: o
  }),
      _Pr2 = _slicedToArray(_Pr, 2),
      P = _Pr2[0],
      g = _Pr2[1],
      R = f ? f.filter(Boolean) : [],
      M = r ? r(P.filterValues) : !0,
      _Ve2 = Ve(c, {
    pagination: {
      page: P.page,
      perPage: P.perPage
    },
    sort: {
      field: P.sort,
      order: P.order
    },
    filter: y(y({}, P.filter), o)
  }, y({
    retry: !1,
    enabled: M
  }, u)),
      T = _Ve2.data,
      h = _Ve2.total,
      v = _Ve2.pageInfo,
      L = _Ve2.error,
      E = _Ve2.isLoading,
      I = _Ve2.isFetching,
      N = _Ve2.refetch,
      A = T && T.length > 0 ? fp(T, R) : R.length > 0 ? R : T,
      w = lp(function () {
    S(), N();
  }, [S, N]);

  return {
    sort: dp(function () {
      return {
        field: P.sort,
        order: P.order
      };
    }, [P.sort, P.order]),
    allChoices: A,
    availableChoices: T,
    selectedChoices: R,
    displayedFilters: P.displayedFilters,
    error: x || L,
    filter: o,
    filterValues: P.filterValues,
    hideFilter: g.hideFilter,
    isFetching: b || I,
    isLoading: C || E,
    page: P.page,
    perPage: P.perPage,
    refetch: w,
    resource: c,
    setFilters: g.setFilters,
    setPage: g.setPage,
    setPerPage: g.setPerPage,
    setSort: g.setSort,
    showFilter: g.showFilter,
    source: p,
    total: h,
    hasNextPage: v ? v.hasNextPage : h != null ? P.page * P.perPage < h : void 0,
    hasPreviousPage: v ? v.hasPreviousPage : P.page > 1
  };
}, "useReferenceArrayInputController"),
    mp = [],
    fp = n(function (e, t) {
  var r = _toConsumableArray(e),
      o = e.map(function (s) {
    return s.id;
  });

  return t.forEach(function (s) {
    o.includes(s.id) || (o.push(s.id), r.push(s));
  }), r;
}, "mergeReferences");
import { useCallback as yp, useMemo as gp } from "react";
import { useWatch as Rp } from "react-hook-form";
var Fs = n(function (_ref120) {
  var e = _ref120.reference,
      t = _ref120.id;

  var _Ge3 = Ge(e, {
    ids: [t]
  }),
      r = _Ge3.data,
      o = _Ge3.error,
      s = _Ge3.isLoading,
      a = _Ge3.isFetching,
      i = _Ge3.refetch;

  return {
    referenceRecord: o ? void 0 : r ? r[0] : void 0,
    refetch: i,
    error: o,
    isLoading: s,
    isFetching: a
  };
}, "useReference");
var Bv = n(function (e) {
  var t = e.debounce,
      r = e.enableGetChoices,
      o = e.filter,
      _e$page4 = e.page,
      s = _e$page4 === void 0 ? 1 : _e$page4,
      _e$perPage5 = e.perPage,
      a = _e$perPage5 === void 0 ? 25 : _e$perPage5,
      i = e.sort,
      _e$queryOptions3 = e.queryOptions,
      u = _e$queryOptions3 === void 0 ? {} : _e$queryOptions3,
      c = e.reference,
      p = e.source,
      _Pr3 = Pr({
    resource: c,
    page: s,
    perPage: a,
    sort: i,
    debounce: t,
    filter: o
  }),
      _Pr4 = _slicedToArray(_Pr3, 2),
      m = _Pr4[0],
      f = _Pr4[1],
      x = Rp({
    name: p
  }),
      C = r ? r(m.filterValues) : !0,
      _Ve3 = Ve(c, {
    pagination: {
      page: m.page,
      perPage: m.perPage
    },
    sort: {
      field: m.sort,
      order: m.order
    },
    filter: y(y({}, m.filter), o)
  }, y({
    enabled: C
  }, u)),
      _Ve3$data = _Ve3.data,
      b = _Ve3$data === void 0 ? [] : _Ve3$data,
      S = _Ve3.total,
      P = _Ve3.pageInfo,
      g = _Ve3.isFetching,
      R = _Ve3.isLoading,
      M = _Ve3.error,
      T = _Ve3.refetch,
      _Fs = Fs({
    id: x,
    reference: c
  }),
      h = _Fs.referenceRecord,
      v = _Fs.refetch,
      L = _Fs.error,
      E = _Fs.isLoading,
      I = _Fs.isFetching,
      N,
      A;

  !h || b.find(function (k) {
    return k.id === x;
  }) ? (N = b, A = S) : (N = [h].concat(_toConsumableArray(b)), A = S == null ? void 0 : S + 1);
  var w = yp(function () {
    T(), v();
  }, [T, v]);
  return {
    sort: gp(function () {
      return {
        field: m.sort,
        order: m.order
      };
    }, [m.sort, m.order]),
    allChoices: N,
    availableChoices: b,
    selectedChoices: [h],
    displayedFilters: m.displayedFilters,
    error: L || M,
    filter: m.filter,
    filterValues: m.filterValues,
    hideFilter: f.hideFilter,
    isFetching: I || g,
    isLoading: E || R,
    page: m.page,
    perPage: m.perPage,
    refetch: w,
    resource: c,
    setFilters: f.setFilters,
    setPage: f.setPage,
    setPerPage: f.setPerPage,
    setSort: f.setSort,
    showFilter: f.showFilter,
    source: p,
    total: A,
    hasNextPage: P ? P.hasNextPage : S != null ? m.page * m.perPage < S : void 0,
    hasPreviousPage: P ? P.hasPreviousPage : m.page > 1
  };
}, "useReferenceInputController");
import * as ho from "react";
import { useParams as Pp } from "react-router-dom";
var hr = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = e.disableAuthentication,
      r = e.id,
      _e$queryOptions4 = e.queryOptions,
      o = _e$queryOptions4 === void 0 ? {} : _e$queryOptions4;
  re({
    enabled: !t
  });

  var s = H(e),
      a = Q(),
      i = G(),
      u = ce(),
      c = Vt(),
      _Pp = Pp(),
      p = _Pp.id,
      m = r || decodeURIComponent(p),
      _Gt2 = Gt(s, {
    id: m
  }, y({
    onError: function onError() {
      i("ra.notification.item_doesnt_exist", {
        type: "warning"
      }), u("list", s), c();
    },
    retry: !1
  }, o)),
      f = _Gt2.data,
      x = _Gt2.error,
      C = _Gt2.isLoading,
      b = _Gt2.isFetching,
      S = _Gt2.refetch;

  if (f && f.id && f.id != m) throw new Error("useShowController: Fetched record's id attribute (".concat(f.id, ") must match the requested 'id' (").concat(m, ")"));
  var P = Se();
  return {
    defaultTitle: a("ra.page.show", {
      name: P(s, 1),
      id: m,
      record: f
    }),
    error: x,
    isLoading: C,
    isFetching: b,
    record: f,
    refetch: S,
    resource: s
  };
}, "useShowController");
import * as Po from "react";
import { createContext as hp } from "react";
var xt = hp({
  record: null,
  defaultTitle: null,
  isFetching: null,
  isLoading: null,
  refetch: null,
  resource: null
});
xt.displayName = "ShowContext";
var Ns = n(function (_ref121) {
  var e = _ref121.children,
      t = _ref121.value;
  return Po.createElement(xt.Provider, {
    value: t
  }, Po.createElement(pe, {
    value: t && t.record
  }, e));
}, "ShowContextProvider");
var xE = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = hr(t),
      a = ho.createElement(Ns, {
    value: s
  }, e);
  return t.resource ? ho.createElement(de, {
    value: t.resource
  }, a) : a;
}, "ShowBase");
var LE = n(function (r) {
  var o = r,
      e = o.children,
      t = F(o, ["children"]);
  var s = hr(t);
  return e(s);
}, "ShowController");
import { useContext as xp, useMemo as Cp } from "react";
import Tp from "lodash/defaults";
var wE = n(function (e) {
  var t = xp(xt);
  return Cp(function () {
    return Tp({}, e != null ? Sp(e) : {}, t);
  }, [t, e]);
}, "useShowContext"),
    Sp = n(function (_ref122) {
  var e = _ref122.record,
      t = _ref122.data,
      r = _ref122.defaultTitle,
      o = _ref122.isFetching,
      s = _ref122.isLoading,
      a = _ref122.resource;
  return {
    record: e || t,
    data: e || t,
    defaultTitle: r,
    isFetching: o,
    isLoading: s,
    resource: a
  };
}, "extractShowContextProps");
import * as Os from "react";
import { useWatch as Mp } from "react-hook-form";
import Lp from "lodash/get";
var bp = n(function (e) {
  var t = Mp();
  return Os.createElement(vp, y({
    formData: t
  }, e));
}, "FormDataConsumer"),
    vp = n(function (e) {
  var f = e,
      t = f.children,
      r = f.form,
      o = f.formData,
      s = f.source,
      a = f.index,
      i = F(f, ["children", "form", "formData", "source", "index"]),
      u = o,
      c,
      p = !1,
      m;
  return typeof a != "undefined" ? (u = Lp(o, s), c = n(function (x) {
    return p = !0, "".concat(s, ".").concat(x);
  }, "getSource"), m = t(y({
    formData: o,
    scopedFormData: u,
    getSource: c
  }, i))) : m = t(y({
    formData: o
  }, i)), Ze(typeof a != "undefined" && m && !p, "You're using a FormDataConsumer inside an ArrayInput and you did not call the getSource function supplied by the FormDataConsumer component. This is required for your inputs to get the proper source.\n\n<ArrayInput source=\"users\">\n    <SimpleFormIterator>\n        <TextInput source=\"name\" />\n\n        <FormDataConsumer>\n            {({\n                formData, // The whole form data\n                scopedFormData, // The data for this item of the ArrayInput\n                getSource, // A function to get the valid source inside an ArrayInput\n                ...rest,\n            }) =>\n                scopedFormData.name ? (\n                    <SelectInput\n                        source={getSource('role')} // Will translate to \"users[0].role\"\n                        choices={[{id: 1, name: 'Admin'}, {id: 2, name: 'User'},\n                        {...rest}\n                    />\n                ) : null\n            }\n        </FormDataConsumer>\n    </SimpleFormIterator>\n</ArrayInput>"), m === void 0 ? null : m;
}, "FormDataConsumerView"),
    Ep = bp;
import { createContext as Dp } from "react";
var Ct = Dp(void 0);
import * as ze from "react";
var wp = n(function (e) {
  var t = e.error,
      r = Q();

  if (t.message) {
    var o = t.message,
        s = t.args;
    return ze.createElement(ze.Fragment, null, r(o, y({
      _: o
    }, s)));
  }

  return ze.createElement(ze.Fragment, null, r(t, {
    _: t
  }));
}, "ValidationError"),
    Ip = wp;
import xo from "lodash";
var Us = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return xo.isObject(e) ? xo.reduce(e, function (r, o, s) {
    return xo.merge(r, Us(o, [].concat(_toConsumableArray(t), [s])));
  }, {}) : _defineProperty({}, t.join("."), e);
}, "flattenKeys"),
    Co = n(function (e) {
  return /*#__PURE__*/function () {
    var _ref124 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t) {
      var r, o;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return e(t);

            case 2:
              r = _context14.sent;

              if (!(!r || Object.getOwnPropertyNames(r).length === 0)) {
                _context14.next = 5;
                break;
              }

              return _context14.abrupt("return", {
                values: t,
                errors: {}
              });

            case 5:
              o = Us(r);
              return _context14.abrupt("return", {
                values: {},
                errors: Object.keys(o).reduce(function (s, a) {
                  return D(y({}, s), _defineProperty({}, a, {
                    type: "manual",
                    message: o[a]
                  }));
                }, {})
              });

            case 7:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x8) {
      return _ref124.apply(this, arguments);
    };
  }();
}, "getSimpleValidationResolver");
import { createContext as Ap } from "react";
var xr = Ap(void 0);
import * as ks from "react";
var uD = n(function (_ref125) {
  var e = _ref125.children,
      t = _ref125.value;
  return ks.createElement(xr.Provider, {
    value: t
  }, e);
}, "ChoicesContextProvider");
import { useContext as Fp, useMemo as Np } from "react";
var yD = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = Fp(xr),
      a = gr({
    data: e.choices
  }),
      r = a.data,
      o = F(a, ["data"]);
  return Np(function () {
    var i, u, c, p, m, f, x, C, b, S, P, g, R, M, T, h, v, L, E, I, N, A, w, O, k, $, q, V, U, j, B, Y, K, Sr, St, Lo, bo, vo, Eo, Do, wo, Io, Ao, Fo, No, Oo;
    return {
      allChoices: (i = t == null ? void 0 : t.allChoices) != null ? i : r,
      availableChoices: (c = (u = t == null ? void 0 : t.availableChoices) != null ? u : e.availableChoices) != null ? c : r,
      selectedChoices: (m = (p = t == null ? void 0 : t.selectedChoices) != null ? p : e.selectedChoices) != null ? m : r,
      displayedFilters: (x = (f = t == null ? void 0 : t.displayedFilters) != null ? f : e.displayedFilters) != null ? x : o.displayedFilters,
      error: (b = (C = t == null ? void 0 : t.error) != null ? C : e.error) != null ? b : o.error,
      filter: (P = (S = t == null ? void 0 : t.filter) != null ? S : e.filter) != null ? P : o.filter,
      filterValues: (R = (g = t == null ? void 0 : t.filterValues) != null ? g : e.filterValues) != null ? R : o.filterValues,
      hasNextPage: (T = (M = t == null ? void 0 : t.hasNextPage) != null ? M : e.hasNextPage) != null ? T : o.hasNextPage,
      hasPreviousPage: (v = (h = t == null ? void 0 : t.hasPreviousPage) != null ? h : e.hasPreviousPage) != null ? v : o.hasPreviousPage,
      hideFilter: (E = (L = t == null ? void 0 : t.hideFilter) != null ? L : e.hideFilter) != null ? E : o.hideFilter,
      isFetching: (N = (I = t == null ? void 0 : t.isFetching) != null ? I : e.isFetching) != null ? N : o.isFetching,
      isLoading: (w = (A = t == null ? void 0 : t.isLoading) != null ? A : e.isLoading) != null ? w : o.isLoading,
      page: (k = (O = t == null ? void 0 : t.page) != null ? O : e.page) != null ? k : o.page,
      perPage: (q = ($ = t == null ? void 0 : t.perPage) != null ? $ : e.perPage) != null ? q : o.perPage,
      refetch: (U = (V = t == null ? void 0 : t.refetch) != null ? V : e.refetch) != null ? U : o.refetch,
      resource: (B = (j = t == null ? void 0 : t.resource) != null ? j : e.resource) != null ? B : o.resource,
      setFilters: (K = (Y = t == null ? void 0 : t.setFilters) != null ? Y : e.setFilters) != null ? K : o.setFilters,
      setPage: (St = (Sr = t == null ? void 0 : t.setPage) != null ? Sr : e.setPage) != null ? St : o.setPage,
      setPerPage: (bo = (Lo = t == null ? void 0 : t.setPerPage) != null ? Lo : e.setPerPage) != null ? bo : o.setPerPage,
      setSort: (Eo = (vo = t == null ? void 0 : t.setSort) != null ? vo : e.setSort) != null ? Eo : o.setSort,
      showFilter: (wo = (Do = t == null ? void 0 : t.showFilter) != null ? Do : e.showFilter) != null ? wo : o.showFilter,
      sort: (Ao = (Io = t == null ? void 0 : t.sort) != null ? Io : e.sort) != null ? Ao : o.sort,
      source: (Fo = t == null ? void 0 : t.source) != null ? Fo : e.source,
      total: (Oo = (No = t == null ? void 0 : t.total) != null ? No : e.total) != null ? Oo : o.total
    };
  }, [t, r, o, e]);
}, "useChoicesContext");
import * as Tt from "react";
import { FormProvider as Bp } from "react-hook-form";
import * as js from "react";
import { useMemo as Op, useRef as Vs } from "react";
var Gs = n(function (_ref126) {
  var e = _ref126.children;
  var t = Vs({}),
      r = Vs({}),
      o = Op(function () {
    return {
      subscribe: function subscribe(s, a) {
        return r.current[s] || (r.current[s] = []), r.current[s].push(a), function () {
          r.current[s] = r.current[s].filter(function (i) {
            return i !== a;
          });
        };
      },
      getGroupFields: function getGroupFields(s) {
        return t.current[s] || [];
      },
      registerGroup: function registerGroup(s) {
        t.current[s] = t.current[s] || [];
      },
      unregisterGroup: function unregisterGroup(s) {
        delete t[s];
      },
      registerField: function registerField(s, a) {
        a != null && ((t.current[a] || []).includes(s) || (t.current[a] = [].concat(_toConsumableArray(t.current[a] || []), [s]), r.current[a] && r.current[a].forEach(function (i) {
          return i();
        })));
      },
      unregisterField: function unregisterField(s, a) {
        if (a != null) if (!t.current[a]) console.warn("Invalid form group ".concat(a));else {
          var i = new Set(t.current[a]);
          i.delete(s), t.current[a] = Array.from(i), r.current[a] && r.current[a].forEach(function (u) {
            return u();
          });
        }
      }
    };
  }, []);
  return js.createElement(Ct.Provider, {
    value: o
  }, e);
}, "FormGroupsProvider");
import { useCallback as Hs, useMemo as $p, useEffect as Ws } from "react";
import { useForm as Zp } from "react-hook-form";
import Up from "lodash/merge";

function He(e, t) {
  return Up({}, kp(e, t), t);
}

n(He, "getFormInitialValues");

function kp(e, t) {
  return typeof e == "object" ? e : typeof e == "function" ? e(t) : {};
}

n(kp, "getValues");
var Qs = n(function (e, t) {
  var r = n(function (s, a) {
    s.forEach(function (i, u) {
      if (typeof i == "object") {
        o(i, "".concat(a, ".").concat(u, "."));
        return;
      }

      if (Array.isArray(i)) {
        r(i, "".concat(a, ".").concat(u, "."));
        return;
      }

      t("".concat(a, ".").concat(u), {
        type: "server",
        message: i.toString()
      });
    });
  }, "setErrorFromArray"),
      o = n(function (s, a) {
    Object.entries(s).forEach(function (_ref127) {
      var _ref128 = _slicedToArray(_ref127, 2),
          i = _ref128[0],
          u = _ref128[1];

      if (typeof u == "object") {
        o(u, "".concat(a).concat(i, "."));
        return;
      }

      if (Array.isArray(u)) {
        r(u, "".concat(a).concat(i, "."));
        return;
      }

      t("".concat(a).concat(i), {
        type: "server",
        message: u.toString()
      });
    });
  }, "setErrorFromObject");
  o(e, "");
}, "setSubmissionErrors");
import { useEffect as jp, useState as Vp, useRef as Gp } from "react";
import { useFormState as Qp } from "react-hook-form";

var _s = n(function (e) {
  var _Vp = Vp(!1),
      _Vp2 = _slicedToArray(_Vp, 2),
      t = _Vp2[0],
      r = _Vp2[1],
      _Qp = Qp(e ? {
    control: e
  } : void 0),
      o = _Qp.isValid,
      s = _Qp.submitCount,
      a = _Qp.errors,
      i = Gp(s);

  return jp(function () {
    s > i.current && (i.current = s, Object.keys(a).length > 0 && !o ? r(!0) : r(!1));
  }, [a, o, s]), t;
}, "useIsFormInvalid");

import { useContext as _p, useEffect as zp, useRef as Hp } from "react";
import { useFormState as Wp } from "react-hook-form";
import { UNSAFE_NavigationContext as Yp, useLocation as Jp } from "react-router-dom";
var zs = n(function (e, t, r) {
  var o = _p(Yp).navigator,
      s = Jp(),
      a = Q(),
      _Wp = Wp(r ? {
    control: r
  } : void 0),
      i = _Wp.isSubmitSuccessful,
      u = _Wp.isSubmitting,
      c = _Wp.dirtyFields,
      p = Object.keys(c).length > 0,
      m = Hp(t || s.pathname);

  zp(function () {
    if (!e || !p) return;
    var f = o.block(function (x) {
      var C = x.location.pathname.startsWith(m.current);
      !u && (C || i || window.confirm(a("ra.message.unsaved_changes"))) && (f(), x.retry());
    });
    return f;
  }, [e, s, o, p, u, i, a]);
}, "useWarnWhenUnsavedChanges");
var Ys = n(function (e) {
  var t = e.context,
      _e$criteriaMode = e.criteriaMode,
      r = _e$criteriaMode === void 0 ? "firstError" : _e$criteriaMode,
      o = e.defaultValues,
      s = e.delayError,
      a = e.formRootPathname,
      i = e.mode,
      u = e.resolver,
      _e$reValidateMode = e.reValidateMode,
      c = _e$reValidateMode === void 0 ? "onChange" : _e$reValidateMode,
      p = e.onSubmit,
      m = e.shouldFocusError,
      f = e.shouldUnregister,
      x = e.shouldUseNativeValidation,
      C = e.warnWhenUnsavedChanges,
      b = e.validate,
      S = me(e),
      P = ps(),
      g = $p(function () {
    return He(o, S);
  }, [JSON.stringify({
    defaultValues: o,
    record: S
  })]),
      R = u || (b ? Co(b) : void 0),
      M = Zp({
    context: t,
    criteriaMode: r,
    defaultValues: g,
    delayError: s,
    mode: i,
    reValidateMode: c,
    resolver: R,
    shouldFocusError: m,
    shouldUnregister: f,
    shouldUseNativeValidation: x
  });
  Ws(function () {
    if (!S) return;
    var E = He(o, S);
    M.reset(E);
  }, [M.reset, JSON.stringify(S, o)]);

  var T = _s(M.control),
      h = G();

  Ws(function () {
    T && h("ra.message.invalid_form", {
      type: "warning"
    });
  }, [T, h]), zs(C, a, M.control);
  var v = Hs( /*#__PURE__*/function () {
    var _ref129 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(E) {
      var I;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.t0 = p;

              if (!_context15.t0) {
                _context15.next = 5;
                break;
              }

              _context15.next = 4;
              return p(E);

            case 4:
              I = _context15.sent;

            case 5:
              _context15.t1 = p == null && (P == null ? void 0 : P.save);

              if (!_context15.t1) {
                _context15.next = 10;
                break;
              }

              _context15.next = 9;
              return P.save(E);

            case 9:
              I = _context15.sent;

            case 10:
              I != null && Qs(I, M.setError);

            case 11:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x9) {
      return _ref129.apply(this, arguments);
    };
  }(), [M, p, P]),
      L = Hs(function (E) {
    E.stopPropagation(), M.handleSubmit(v)(E);
  }, [M, v]);
  return {
    form: M,
    handleSubmit: v,
    formHandleSubmit: L,
    isInvalid: T
  };
}, "useAugmentedForm");
var ow = n(function (e) {
  var t = e.children,
      r = e.id,
      o = e.className,
      _e$noValidate = e.noValidate,
      s = _e$noValidate === void 0 ? !1 : _e$noValidate,
      a = me(e),
      _Ys = Ys(e),
      i = _Ys.form,
      u = _Ys.formHandleSubmit;

  return Tt.createElement(gs, {
    value: a
  }, Tt.createElement(Bp, y({}, i), Tt.createElement(Gs, null, Tt.createElement("form", {
    onSubmit: u,
    noValidate: s,
    id: r,
    className: o
  }, t))));
}, "Form");
import Js from "lodash/memoize";
var qp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    Me = n(function (e) {
  return typeof e == "undefined" || e === null || e === "" || Array.isArray(e) && e.length === 0;
}, "isEmpty");

function Kp(e) {
  return e.hasOwnProperty("message");
}

n(Kp, "isValidationErrorMessageWithArgs");
var Le = n(function (e, t, r, o) {
  return typeof e == "function" ? e({
    args: t,
    value: r,
    values: o
  }) : t ? {
    message: e,
    args: t
  } : e;
}, "getMessage"),
    be = n(function (e) {
  return Js(e, function () {
    for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      t[_key4] = arguments[_key4];
    }

    return JSON.stringify(t);
  });
}, "memoize"),
    $s = n(function (e) {
  return typeof e == "function";
}, "isFunction"),
    Xp = n(function (e, t) {
  return function (r, o, s) {
    var a = e(r, o, s);
    return a ? typeof a == "string" || Kp(a) ? a : a.then(function (i) {
      return i || t(r, o, s);
    }) : t(r, o, s);
  };
}, "combine2Validators"),
    Zs = n(function () {
  for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    e[_key5] = arguments[_key5];
  }

  return (Array.isArray(e[0]) ? e[0] : e).filter($s).reduce(Xp, function () {
    return null;
  });
}, "composeValidators"),
    aw = n(function () {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }

  return function (t, r, o) {
    var s = (Array.isArray(e[0]) ? e[0] : e).filter($s);

    var _iterator3 = _createForOfIteratorHelper(s),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var a = _step3.value;
        var i = a(t, r, o);
        if (i) return i;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
}, "composeSyncValidators"),
    iw = be(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ra.validation.required";
  return Object.assign(function (t, r) {
    return Me(t) ? Le(e, void 0, t, r) : void 0;
  }, {
    isRequired: !0
  });
}),
    cw = be(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ra.validation.minLength";
  return function (r, o) {
    return !Me(r) && r.length < e ? Le(t, {
      min: e
    }, r, o) : void 0;
  };
}),
    uw = be(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ra.validation.maxLength";
  return function (r, o) {
    return !Me(r) && r.length > e ? Le(t, {
      max: e
    }, r, o) : void 0;
  };
}),
    lw = be(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ra.validation.minValue";
  return function (r, o) {
    return !Me(r) && r < e ? Le(t, {
      min: e
    }, r, o) : void 0;
  };
}),
    dw = be(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ra.validation.maxValue";
  return function (r, o) {
    return !Me(r) && r > e ? Le(t, {
      max: e
    }, r, o) : void 0;
  };
}),
    pw = be(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ra.validation.number";
  return function (t, r) {
    return !Me(t) && isNaN(Number(t)) ? Le(e, void 0, t, r) : void 0;
  };
}),
    em = Js(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ra.validation.regex";
  return function (r, o) {
    return !Me(r) && typeof r == "string" && !e.test(r) ? Le(t, {
      pattern: e
    }, r, o) : void 0;
  };
}, function (e, t) {
  return e.toString() + t;
}),
    mw = be(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ra.validation.email";
  return em(qp, e);
}),
    tm = n(function (_ref130) {
  var e = _ref130.args;
  return {
    message: "ra.validation.oneOf",
    args: e
  };
}, "oneOfTypeMessage"),
    fw = be(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tm;
  return function (r, o) {
    return !Me(r) && e.indexOf(r) === -1 ? Le(t, {
      list: e
    }, r, o) : void 0;
  };
}),
    yw = n(function (e) {
  return e && e.isRequired ? !0 : Array.isArray(e) ? !!e.find(function (t) {
    return t.isRequired;
  }) : !1;
}, "isRequired");
import { createContext as rm } from "react";
var Cr = rm(void 0);
import * as Bs from "react";
import { useEffect as nm } from "react";
import { useContext as om } from "react";
var We = n(function () {
  return om(Ct);
}, "useFormGroups");
var bw = n(function (_ref131) {
  var e = _ref131.children,
      t = _ref131.name;
  var r = We();
  return nm(function () {
    if (!r || !r.registerGroup || !r.unregisterGroup) {
      console.warn("The FormGroupContextProvider can only be used inside a FormContext such as provided by the SimpleForm and TabbedForm components");
      return;
    }

    return r.registerGroup(t), function () {
      r.unregisterGroup(t);
    };
  }, [r, t]), Bs.createElement(Cr.Provider, {
    value: t
  }, e);
}, "FormGroupContextProvider");
import { useEffect as sm } from "react";
import { useFormContext as am } from "react-hook-form";
import To from "lodash/get";
var qs = n(function (e) {
  var t = e.defaultValue,
      r = e.source,
      o = me(e),
      _am = am(),
      s = _am.getValues,
      a = _am.resetField,
      i = To(o, r),
      u = To(s(), r);

  sm(function () {
    if (t != null && u == null && i == null) {
      if (r.split(".").some(function (p) {
        return im.test(p);
      })) {
        var p = r.split(".").slice(0, -1).join(".");
        if (To(s(), p) == null) return;
      }

      a(r, {
        defaultValue: t
      });
    }
  });
}, "useApplyInputDefaultValues"),
    im = /^\d+$/;
import * as Ks from "react";
import { isValidElement as Xs, useCallback as So } from "react";
import Mo from "lodash/get";
var ea = n(function (_ref132) {
  var _ref132$optionText = _ref132.optionText,
      e = _ref132$optionText === void 0 ? "name" : _ref132$optionText,
      _ref132$optionValue = _ref132.optionValue,
      t = _ref132$optionValue === void 0 ? "id" : _ref132$optionValue,
      _ref132$disableValue = _ref132.disableValue,
      r = _ref132$disableValue === void 0 ? "disabled" : _ref132$disableValue,
      _ref132$translateChoi = _ref132.translateChoice,
      o = _ref132$translateChoi === void 0 ? !0 : _ref132$translateChoi;
  var s = Q(),
      a = So(function (c) {
    if (Xs(e)) return Ks.createElement(pe, {
      value: c
    }, e);
    var p = typeof e == "function" ? e(c) : Mo(c, e);
    return Xs(p) ? p : o ? s(String(p), {
      _: p
    }) : String(p);
  }, [e, s, o]),
      i = So(function (c) {
    return Mo(c, t);
  }, [t]),
      u = So(function (c) {
    return Mo(c, r);
  }, [r]);
  return {
    getChoiceText: a,
    getChoiceValue: i,
    getDisableValue: u
  };
}, "useChoices");
import { useCallback as cm, useEffect as ta, useState as um } from "react";
import Tr from "lodash/get";
import lm from "lodash/isEqual";
import { useFormState as dm } from "react-hook-form";
var Hw = n(function (e) {
  var _dm = dm(),
      t = _dm.dirtyFields,
      r = _dm.touchedFields,
      o = _dm.errors,
      s = We(),
      _um = um({
    errors: void 0,
    isDirty: !1,
    isTouched: !1,
    isValid: !0
  }),
      _um2 = _slicedToArray(_um, 2),
      a = _um2[0],
      i = _um2[1],
      u = cm(function () {
    var p = s.getGroupFields(e).map(function (f) {
      return {
        name: f,
        error: Tr(o, f, void 0),
        isDirty: Tr(t, f, !1),
        isValid: Tr(o, f, void 0) == null,
        isTouched: Tr(r, f, !1)
      };
    }).filter(function (f) {
      return f != null;
    }),
        m = pm(p);
    i(function (f) {
      return lm(f, m) ? f : m;
    });
  }, [t, o, r, s, e]);

  return ta(function () {
    u();
  }, [JSON.stringify({
    dirtyFields: t,
    errors: o,
    touchedFields: r
  }), u]), ta(function () {
    return s.subscribe(e, function () {
      u();
    });
  }, [s, e, u]), a;
}, "useFormGroup"),
    pm = n(function (e) {
  return e.reduce(function (t, r) {
    var o = t.errors || {};
    return r.error && (o[r.name] = r.error), {
      isDirty: t.isDirty || r.isDirty,
      errors: o,
      isTouched: t.isTouched || r.isTouched,
      isValid: t.isValid && r.isValid
    };
  }, {
    isDirty: !1,
    errors: void 0,
    isValid: !0,
    isTouched: !1
  });
}, "getFormGroupState");
import { useContext as mm } from "react";
var ra = n(function () {
  return mm(Cr);
}, "useFormGroupContext");
var oa = n(function () {
  var e = Q();
  return function (t) {
    if (t.message != null) {
      var r = t.message,
          o = t.args;
      return e(r, y({
        _: r
      }, o));
    }

    return e(t, {
      _: t
    });
  };
}, "useGetValidationErrorMessage");
import { useEffect as fm } from "react";
import { useFormContext as ym } from "react-hook-form";
var eI = n(function (e, t) {
  var _ym = ym(),
      r = _ym.reset;

  fm(function () {
    if (!t) return;
    var o = He(e, t);
    r(o);
  }, [r, JSON.stringify(t, e)]);
}, "useInitializeFormWithRecord");
import { useEffect as Rm } from "react";
import { useController as Pm, useFormContext as hm } from "react-hook-form";
import xm from "lodash/get";
var gm = n(function (e) {
  return e && e.isRequired ? !0 : Array.isArray(e) ? e.some(function (t) {
    return t.isRequired;
  }) : !1;
}, "isRequired"),
    na = gm;
var xI = n(function (e) {
  var L = e,
      t = L.defaultValue,
      r = L.format,
      o = L.id,
      s = L.isRequired,
      a = L.name,
      i = L.onBlur,
      u = L.onChange,
      c = L.parse,
      p = L.source,
      m = L.validate,
      f = F(L, ["defaultValue", "format", "id", "isRequired", "name", "onBlur", "onChange", "parse", "source", "validate"]),
      x = a || p,
      C = ra(),
      b = We(),
      S = me(),
      P = oa(),
      g = hm();
  Rm(function () {
    if (!(!b || C == null)) return b.registerField(p, C), function () {
      b.unregisterField(p, C);
    };
  }, [b, C, p]);

  var R = Array.isArray(m) ? Zs(m) : m,
      _Pm = Pm(y({
    name: x,
    defaultValue: xm(S, p, t),
    rules: {
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(E) {
          var I;
          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (R) {
                    _context16.next = 2;
                    break;
                  }

                  return _context16.abrupt("return", !0);

                case 2:
                  _context16.next = 4;
                  return R(E, g.getValues(), e);

                case 4:
                  I = _context16.sent;
                  return _context16.abrupt("return", I ? P(I) : !0);

                case 6:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16);
        }));

        function validate(_x10) {
          return _validate.apply(this, arguments);
        }

        return validate;
      }()
    }
  }, f)),
      M = _Pm.field,
      T = _Pm.fieldState,
      h = _Pm.formState;

  qs(e);
  var v = D(y({}, M), {
    value: r ? r(M.value) : M.value,
    onBlur: function onBlur() {
      i && i.apply(void 0, arguments), M.onBlur();
    },
    onChange: function onChange() {
      var N, A, w, O, k, $, q;

      for (var _len7 = arguments.length, E = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        E[_key7] = arguments[_key7];
      }

      u && u.apply(void 0, E);
      var I = typeof ((A = (N = E[0]) == null ? void 0 : N.target) == null ? void 0 : A.checked) == "boolean" && ((O = (w = E[0]) == null ? void 0 : w.target) == null ? void 0 : O.value) === "on" ? E[0].target.checked : (q = ($ = (k = E[0]) == null ? void 0 : k.target) == null ? void 0 : $.value) != null ? q : E[0];
      M.onChange(c ? c(I) : I);
    }
  });
  return {
    id: o || p,
    field: v,
    fieldState: T,
    formState: h,
    isRequired: s || na(m)
  };
}, "useInput");
import { useCallback as Cm, isValidElement as Tm } from "react";
import sa from "lodash/set";
var DI = n(function (_ref133) {
  var e = _ref133.allowCreate,
      t = _ref133.choices,
      _ref133$createText = _ref133.createText,
      r = _ref133$createText === void 0 ? "ra.action.create" : _ref133$createText,
      _ref133$createValue = _ref133.createValue,
      o = _ref133$createValue === void 0 ? "@@create" : _ref133$createValue,
      _ref133$emptyText = _ref133.emptyText,
      s = _ref133$emptyText === void 0 ? "" : _ref133$emptyText,
      _ref133$emptyValue = _ref133.emptyValue,
      a = _ref133$emptyValue === void 0 ? null : _ref133$emptyValue,
      i = _ref133.limitChoicesToValue,
      u = _ref133.matchSuggestion,
      c = _ref133.optionText,
      p = _ref133.optionValue,
      m = _ref133.selectedItem,
      _ref133$suggestionLim = _ref133.suggestionLimit,
      f = _ref133$suggestionLim === void 0 ? 0 : _ref133$suggestionLim,
      x = _ref133.translateChoice;

  var C = Q(),
      _ea = ea({
    optionText: c,
    optionValue: p,
    translateChoice: x
  }),
      b = _ea.getChoiceText,
      S = _ea.getChoiceValue,
      P = Cm(Lm({
    allowCreate: e,
    choices: t,
    createText: r,
    createValue: o,
    emptyText: C(s, {
      _: s
    }),
    emptyValue: a,
    getChoiceText: b,
    getChoiceValue: S,
    limitChoicesToValue: i,
    matchSuggestion: u,
    optionText: c,
    optionValue: p,
    selectedItem: m,
    suggestionLimit: f
  }), [e, t, r, o, s, a, b, S, i, u, c, p, m, f, C]);

  return {
    getChoiceText: b,
    getChoiceValue: S,
    getSuggestions: P
  };
}, "useSuggestions"),
    Sm = n(function (e) {
  return e ? e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : "";
}, "escapeRegExp"),
    Mm = n(function (e) {
  return function (t, r) {
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var s = e(r),
        a = Tm(s),
        i = Sm(t);
    return a ? !1 : s && !!s.match(new RegExp(o ? "^".concat(i, "$") : i, "i"));
  };
}, "defaultMatchSuggestion"),
    Lm = n(function (_ref134) {
  var _ref134$allowCreate = _ref134.allowCreate,
      e = _ref134$allowCreate === void 0 ? !1 : _ref134$allowCreate,
      _ref134$choices = _ref134.choices,
      t = _ref134$choices === void 0 ? [] : _ref134$choices,
      _ref134$createText = _ref134.createText,
      r = _ref134$createText === void 0 ? "ra.action.create" : _ref134$createText,
      _ref134$createValue = _ref134.createValue,
      o = _ref134$createValue === void 0 ? "@@create" : _ref134$createValue,
      _ref134$emptyText = _ref134.emptyText,
      s = _ref134$emptyText === void 0 ? "" : _ref134$emptyText,
      _ref134$emptyValue = _ref134.emptyValue,
      a = _ref134$emptyValue === void 0 ? null : _ref134$emptyValue,
      _ref134$optionText = _ref134.optionText,
      i = _ref134$optionText === void 0 ? "name" : _ref134$optionText,
      _ref134$optionValue = _ref134.optionValue,
      u = _ref134$optionValue === void 0 ? "id" : _ref134$optionValue,
      c = _ref134.getChoiceText,
      p = _ref134.getChoiceValue,
      _ref134$limitChoicesT = _ref134.limitChoicesToValue,
      m = _ref134$limitChoicesT === void 0 ? !1 : _ref134$limitChoicesT,
      _ref134$matchSuggesti = _ref134.matchSuggestion,
      f = _ref134$matchSuggesti === void 0 ? Mm(c) : _ref134$matchSuggesti,
      x = _ref134.selectedItem,
      _ref134$suggestionLim = _ref134.suggestionLimit,
      C = _ref134$suggestionLim === void 0 ? 0 : _ref134$suggestionLim;
  return function (b) {
    var S = [];
    x && !Array.isArray(x) && f(b, x) ? m ? S = t.filter(function (R) {
      return p(R) === p(x);
    }) : S = _toConsumableArray(t) : S = t.filter(function (R) {
      return f(b, R) || x != null && (Array.isArray(x) ? x.some(function (M) {
        return p(R) === p(M);
      }) : p(R) === p(x));
    }), S = bm(S, C);
    var P = S.some(function (R) {
      return f(b, R, !0);
    });

    if (e) {
      var R = !!x && !Array.isArray(x) ? f(b, x, !0) : !1;
      !P && !R && S.push(vm({
        optionText: i,
        optionValue: u,
        text: r,
        value: o
      }));
    }

    return S.filter(function (R, M) {
      return S.indexOf(R) === M;
    });
  };
}, "getSuggestionsFactory"),
    bm = n(function (e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number.isInteger(t) && t > 0 ? e.slice(0, t) : e;
}, "limitSuggestions"),
    vm = n(function (_ref135) {
  var _ref135$optionText = _ref135.optionText,
      e = _ref135$optionText === void 0 ? "name" : _ref135$optionText,
      _ref135$optionValue = _ref135.optionValue,
      t = _ref135$optionValue === void 0 ? "id" : _ref135$optionValue,
      _ref135$text = _ref135.text,
      r = _ref135$text === void 0 ? "" : _ref135$text,
      _ref135$value = _ref135.value,
      o = _ref135$value === void 0 ? null : _ref135$value;
  var s = {};
  return sa(s, t, o), typeof e == "string" && sa(s, e, r), s;
}, "getSuggestion");
var aA = "I18N_TRANSLATE",
    iA = "I18N_CHANGE_LOCALE";
export { Mn as AUTH_CHECK, Ln as AUTH_ERROR, vn as AUTH_GET_PERMISSIONS, Sn as AUTH_LOGIN, bn as AUTH_LOGOUT, zo as AdminRouter, Ye as AuthContext, xP as Authenticated, _o as BasenameContextProvider, zr as CREATE, xr as ChoicesContext, uD as ChoicesContextProvider, li as ComponentPropType, eT as CoreAdmin, oo as CoreAdminContext, so as CoreAdminRoutes, $n as CoreAdminUI, TM as CreateBase, pt as CreateContext, ms as CreateContextProvider, vM as CreateController, Su as CustomRoutes, rn as DEFAULT_LOCALE, Yr as DELETE, Jr as DELETE_MANY, Ke as DataProviderContext, uL as EditBase, mt as EditContext, Rs as EditContextProvider, fL as EditController, wu as ExporterContext, ci as FieldTitle, ow as Form, Ep as FormDataConsumer, Cr as FormGroupContext, bw as FormGroupContextProvider, Ct as FormGroupsContext, Gs as FormGroupsProvider, Vr as GET_LIST, Qr as GET_MANY, _r as GET_MANY_REFERENCE, Gr as GET_ONE, ut as HIDE_FILTER, Br as HttpError, iA as I18N_CHANGE_LOCALE, aA as I18N_TRANSLATE, Je as I18nContext, Ft as I18nContextProvider, BT as InferenceTypes, _ as InferredElement, fb as ListBase, ft as ListContext, vs as ListContextProvider, hb as ListController, yt as ListFilterContext, Rt as ListPaginationContext, gt as ListSortContext, It as NotificationContext, qo as NotificationContextProvider, gs as OptionalRecordContextProvider, Ir as Ready, ar as RecordContext, pe as RecordContextProvider, qn as Resource, Ut as ResourceContext, de as ResourceContextProvider, to as ResourceDefinitionContext, _n as ResourceDefinitionContextProvider, we as SET_FILTER, _e as SET_PAGE, it as SET_PER_PAGE, at as SET_SORT, ct as SHOW_FILTER, oe as SORT_ASC, rr as SORT_DESC, ir as SaveContext, cr as SaveContextProvider, xE as ShowBase, xt as ShowContext, Ns as ShowContextProvider, LE as ShowController, Dt as StoreContext, Zo as StoreContextProvider, Of as StoreSetter, sy as TestTranslationProvider, Nt as TranslatableContext, dy as TranslatableContextProvider, Hr as UPDATE, Wr as UPDATE_MANY, Ip as ValidationError, Or as WithPermissions, ZM as WithRecord, fw as choices, Xp as combine2Validators, XP as combineDataProviders, aw as composeSyncValidators, Zs as composeValidators, jr as convertLegacyAuthProvider, Zr as convertLegacyDataProvider, je as defaultDataProvider, rt as defaultExporter, co as downloadCSV, mw as email, Va as escapePath, $r as fetchActionsWithArrayOfIdentifiedRecordsResponse, Dn as fetchActionsWithArrayOfRecordsResponse, En as fetchActionsWithRecordResponse, wn as fetchActionsWithTotalResponse, Fu as fetchRelatedRecords, On as fetchUtils, Xu as getElementsFromRecords, $e as getFieldLabelTranslationArgs, pm as getFormGroupState, WL as getListControllerProps, gi as getMutationMode, xs as getNumberOrDefault, pd as getQuery, Il as getRecordFromLocation, ws as getSelectedReferencesStatus, Co as getSimpleValidationResolver, tp as getStatusForArrayInput, Xd as getStatusForInput, he as getStorage, Lm as getSuggestionsFactory, De as getValuesFromRecords, dd as hasCustomParams, is as inferTypeFromValues, Ss as injectedProps, yw as isRequired, Wm as linkToRecord, Rf as localStorageStore, uw as maxLength, dw as maxValue, Et as memoryStore, Fg as mergeRefs, gy as mergeTranslations, cw as minLength, lw as minValue, pw as number, ld as parseQueryFromLocation, or as queryReducer, em as regex, ie as removeDoubleSlashes, X as removeEmpty, Dr as removeKey, iw as required, yy as resolveBrowserLocale, Jm as resolveRedirectTo, GP as sanitizeFetchType, YL as sanitizeListRestProps, Qs as setSubmissionErrors, sn as shallowEqual, th as testDataProvider, ge as undoableEventEmitter, qs as useApplyInputDefaultValues, Ys as useAugmentedForm, ee as useAuthProvider, Ar as useAuthState, re as useAuthenticated, ae as useBasename, ke as useCheckAuth, xl as useCheckMinimumRequiredProps, ea as useChoices, yD as useChoicesContext, jn as useCreate, AM as useCreateContext, sr as useCreateController, bt as useCreatePath, W as useDataProvider, Vg as useDeepCompareEffect, _t as useDelete, Vx as useDeleteMany, vl as useDeleteWithConfirmController, Sl as useDeleteWithUndoController, hL as useEditContext, dr as useEditController, dn as useEventCallback, sv as useExpanded, sl as useFilterState, Hw as useFormGroup, ra as useFormGroupContext, oc as useGetIdentity, Ve as useGetList, Uh as useGetMany, Ge as useGetManyAggregate, Qt as useGetManyReference, Gt as useGetOne, qe as useGetPermissions, Se as useGetResourceLabel, oa as useGetValidationErrorMessage, Ot as useI18nProvider, eI as useInitializeFormWithRecord, xI as useInput, mh as useIsDataLoaded, _s as useIsFormInvalid, mn as useIsMounted, gr as useList, Fb as useListContext, mr as useListController, jb as useListFilterContext, zb as useListPaginationContext, Ps as useListParams, $b as useListSortContext, Rh as useLoading, by as useLocale, Oe as useLocaleState, ec as useLogin, Ee as useLogout, kr as useLogoutIfAccessDenied, At as useNotificationContext, G as useNotify, dt as usePaginationState, Fr as usePermissions, Nr as usePermissionsOptimized, Ms as usePickFilterContext, bs as usePickPaginationContext, ur as usePickSaveContext, Ls as usePickSortContext, Ti as usePrevious, me as useRecordContext, fe as useRecordSelection, ce as useRedirect, Fs as useReference, pv as useReferenceArrayFieldController, Gv as useReferenceArrayInputController, Bv as useReferenceInputController, Sv as useReferenceManyFieldController, Ev as useReferenceOneFieldController, Vt as useRefresh, fn as useRemoveFromStore, yn as useResetStore, H as useResourceContext, Kn as useResourceDefinition, zt as useResourceDefinitionContext, Yt as useResourceDefinitions, z as useSafeSetState, ps as useSaveContext, Ho as useScrollToTop, Dy as useSetLocale, wE as useShowContext, hr as useShowController, lt as useSortState, ue as useStore, xe as useStoreContext, DI as useSuggestions, pn as useTimeout, Vy as useTranslatable, Hy as useTranslatableContext, Q as useTranslate, nr as useUnselect, tv as useUnselectAll, Vn as useUpdate, xx as useUpdateMany, zs as useWarnWhenUnsavedChanges, ln as useWhyDidYouUpdate, ud as validQueryParams, Ze as warning };